/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 216);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unsafeStringify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(5);


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  //
  // Note to future-self: No, you can't remove the `toLowerCase()` call.
  // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var uuid = unsafeStringify(arr, offset);
  // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }
  return uuid;
}
/* unused harmony default export */ var _unused_webpack_default_export = (stringify);

/***/ }),

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CART_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ECOMMERCE_ACTION_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECKOUT_STEP_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRODUCT_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGE_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCH_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRANSACTION_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REFUND_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PSYKHE_RECOMMENDATIONS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PSYKHE_PRODUCT_DWELL_TIME_SCHEMA; });
var CART_SCHEMA = 'iglu:com.psykhe/cart/jsonschema/1-0-0';
var ECOMMERCE_ACTION_SCHEMA = 'iglu:com.psykhe/ecommerce_action/jsonschema/1-0-0';
var CHECKOUT_STEP_SCHEMA = 'iglu:com.psykhe/checkout_step/jsonschema/1-0-0';
var PRODUCT_SCHEMA = 'iglu:com.psykhe/product/jsonschema/1-0-0';
var PAGE_SCHEMA = 'iglu:com.psykhe/page/jsonschema/1-0-0';
var SEARCH_SCHEMA = 'iglu:com.psykhe/search/jsonschema/1-0-0';
var USER_SCHEMA = 'iglu:com.psykhe/user/jsonschema/1-0-0';
var TRANSACTION_SCHEMA = 'iglu:com.psykhe/transaction/jsonschema/1-0-0';
var REFUND_SCHEMA = 'iglu:com.psykhe/refund/jsonschema/1-0-0';
var PSYKHE_RECOMMENDATIONS_SCHEMA = 'iglu:com.psykhe/recommendations/jsonschema/1-0-0';
var PSYKHE_PRODUCT_DWELL_TIME_SCHEMA = 'iglu:com.psykhe/product_dwell_time/jsonschema/1-0-0';

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SharedState */
/* unused harmony export addEventListener */
/* unused harmony export addTracker */
/* unused harmony export allTrackerNames */
/* unused harmony export allTrackers */
/* unused harmony export attemptDeleteLocalStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return attemptGetLocalStorage; });
/* unused harmony export attemptGetSessionStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return attemptWriteLocalStorage; });
/* unused harmony export attemptWriteSessionStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cookie; });
/* unused harmony export createCrossDomainParameterValue */
/* unused harmony export createSharedState */
/* unused harmony export decorateQuerystring */
/* unused harmony export deleteCookie */
/* unused harmony export dispatchToTrackers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return dispatchToTrackersInCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findRootDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fixupDomain; });
/* unused harmony export fixupTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fixupUrl; });
/* unused harmony export flushPendingCookies */
/* unused harmony export fromQuerystring */
/* unused harmony export getCookiesWithPrefix */
/* unused harmony export getCssClasses */
/* unused harmony export getFilterByClass */
/* unused harmony export getFilterByName */
/* unused harmony export getHostName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getReferrer; });
/* unused harmony export getTimeZone */
/* unused harmony export getTracker */
/* unused harmony export getTrackers */
/* unused harmony export hasLocalStorage */
/* unused harmony export hasSessionStorage */
/* unused harmony export isFunction */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isValueInArray */
/* unused harmony export localStorageAccessible */
/* unused harmony export parseAndValidateFloat */
/* unused harmony export parseAndValidateInt */
/* unused harmony export trackerExists */
/* unused harmony export urlSafeBase64Encode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha1__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow Browser trackers v4.5.0 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */






/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Attempt to get a value from localStorage
 *
 * @param string - key
 * @returns string The value obtained from localStorage, or
 *                undefined if localStorage is inaccessible
 */
function attemptGetLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage,
      exp = localStorageAlias.getItem(key + '.expires');
    if (exp === null || +exp > Date.now()) {
      return localStorageAlias.getItem(key);
    } else {
      localStorageAlias.removeItem(key);
      localStorageAlias.removeItem(key + '.expires');
    }
    return undefined;
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to localStorage
 *
 * @param string - key
 * @param string - value
 * @param number - ttl Time to live in seconds, defaults to 2 years from Date.now()
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteLocalStorage(key, value, ttl) {
  if (ttl === void 0) {
    ttl = 63072000;
  }
  try {
    var localStorageAlias = window.localStorage,
      t = Date.now() + ttl * 1000;
    localStorageAlias.setItem("".concat(key, ".expires"), t.toString());
    localStorageAlias.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to delete a value from localStorage
 *
 * @param string - key
 * @returns boolean Whether the operation succeeded
 */
function attemptDeleteLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage;
    localStorageAlias.removeItem(key);
    localStorageAlias.removeItem(key + '.expires');
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to get a value from sessionStorage
 *
 * @param string - key
 * @returns string The value obtained from sessionStorage, or
 *                undefined if sessionStorage is inaccessible
 */
function attemptGetSessionStorage(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to sessionStorage
 *
 * @param string - key
 * @param string - value
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteSessionStorage(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
var DEFAULT_CROSS_DOMAIN_LINKER_PARAMS = {
  sessionId: true,
  sourceId: true,
  sourcePlatform: false,
  userId: false,
  reason: false
};
function createCrossDomainParameterValue(isExtendedFormat, attributeConfiguration, attributeValues) {
  var _a;
  var crossDomainParameterValue;
  var timestamp = new Date().getTime();
  var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, DEFAULT_CROSS_DOMAIN_LINKER_PARAMS), attributeConfiguration);
  var domainUserId = attributeValues.domainUserId,
    userId = attributeValues.userId,
    sessionId = attributeValues.sessionId,
    sourceId = attributeValues.sourceId,
    sourcePlatform = attributeValues.sourcePlatform,
    event = attributeValues.event;
  var eventTarget = event.currentTarget;
  var reason = typeof config.reason === 'function' ? config.reason(event) : (_a = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.textContent) === null || _a === void 0 ? void 0 : _a.trim();
  if (isExtendedFormat) {
    /* Index is used by Enrich, so it should not be changed. */
    crossDomainParameterValue = [domainUserId, timestamp, config.sessionId && sessionId, config.userId && urlSafeBase64Encode(userId || ''), config.sourceId && urlSafeBase64Encode(sourceId || ''), config.sourcePlatform && sourcePlatform, config.reason && urlSafeBase64Encode(reason || '')].map(function (attribute) {
      return attribute || '';
    }).join('.')
    // Remove trailing dots
    .replace(/([.]*$)/, '');
  } else {
    crossDomainParameterValue = attributeValues.domainUserId + '.' + timestamp;
  }
  return crossDomainParameterValue;
}
/**
 *
 * The url-safe variation emits - and _ instead of + and / characters. Also removes = sign padding.
 * @param {string} str The string to encode in a URL safe manner
 * @return {string}
 */
function urlSafeBase64Encode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Checks if an object is a string
 * @param str - The object to check
 */
function isString(str) {
  if (str && typeof str.valueOf() === 'string') {
    return true;
  }
  return false;
}
/**
 * Checks if an object is an integer
 * @param int - The object to check
 */
function isInteger(_int) {
  return Number.isInteger && Number.isInteger(_int) || typeof _int === 'number' && isFinite(_int) && Math.floor(_int) === _int;
}
/**
 * Checks if the input parameter is a function
 * @param func - The object to check
 */
function isFunction(func) {
  if (func && typeof func === 'function') {
    return true;
  }
  return false;
}
/**
 * Lightweight configured runtime timezone detection
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions#getting_the_users_time_zone_and_locale_preferences
 * @returns IANA timezone name of current runtime preference
 */
function getTimeZone() {
  if ((typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && typeof Intl.DateTimeFormat === 'function') {
    var systemPreferences = new Intl.DateTimeFormat().resolvedOptions();
    return systemPreferences.timeZone;
  }
}
/**
 * Cleans up the page title
 */
function fixupTitle(title) {
  if (!isString(title)) {
    title = title.text || '';
    var tmp = document.getElementsByTagName('title');
    if (tmp && tmp[0] != null) {
      title = tmp[0].text;
    }
  }
  return title;
}
/**
 * Extract hostname from URL
 */
function getHostName(url) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:(?:https?|ftp):)/*(?:[^@]+@)?([^:/#]+)'),
    matches = e.exec(url);
  return matches ? matches[1] : url;
}
/**
 * Fix-up domain
 */
function fixupDomain(domain) {
  var dl = domain.length;
  // remove trailing '.'
  if (domain.charAt(--dl) === '.') {
    domain = domain.slice(0, dl);
  }
  // remove leading '*'
  if (domain.slice(0, 2) === '*.') {
    domain = domain.slice(1);
  }
  return domain;
}
/**
 * Get page referrer. In the case of a single-page app,
 * if the URL changes without the page reloading, pass
 * in the old URL. It will be returned unless overriden
 * by a "refer(r)er" parameter in the querystring.
 *
 * @param string - oldLocation Optional.
 * @returns string The referrer
 */
function getReferrer(oldLocation) {
  var windowAlias = window,
    fromQs = fromQuerystring('referrer', windowAlias.location.href) || fromQuerystring('referer', windowAlias.location.href);
  // Short-circuit
  if (fromQs) {
    return fromQs;
  }
  // In the case of a single-page app, return the old URL
  if (oldLocation) {
    return oldLocation;
  }
  try {
    if (windowAlias.top) {
      return windowAlias.top.document.referrer;
    } else if (windowAlias.parent) {
      return windowAlias.parent.document.referrer;
    }
  } catch (_a) {}
  return document.referrer;
}
/**
 * Cross-browser helper function to add event handler
 */
function addEventListener(element, eventType, eventHandler, options) {
  if (element.addEventListener) {
    element.addEventListener(eventType, eventHandler, options);
    return true;
  }
  // IE Support
  if (element.attachEvent) {
    return element.attachEvent('on' + eventType, eventHandler);
  }
  element['on' + eventType] = eventHandler;
}
/**
 * Return value from name-value pair in querystring
 */
function fromQuerystring(field, url) {
  var match = new RegExp('^[^#]*[?&]' + field + '=([^&#]*)').exec(url);
  if (!match) {
    return null;
  }
  return decodeURIComponent(match[1].replace(/\+/g, ' '));
}
/**
 * Add a name-value pair to the querystring of a URL
 *
 * @param string - url URL to decorate
 * @param string - name Name of the querystring pair
 * @param string - value Value of the querystring pair
 */
function decorateQuerystring(url, name, value) {
  var initialQsParams = name + '=' + value;
  var hashSplit = url.split('#');
  var qsSplit = hashSplit[0].split('?');
  var beforeQuerystring = qsSplit.shift();
  // Necessary because a querystring may contain multiple question marks
  var querystring = qsSplit.join('?');
  if (!querystring) {
    querystring = initialQsParams;
  } else {
    // Whether this is the first time the link has been decorated
    var initialDecoration = true;
    var qsFields = querystring.split('&');
    for (var i = 0; i < qsFields.length; i++) {
      if (qsFields[i].substr(0, name.length + 1) === name + '=') {
        initialDecoration = false;
        qsFields[i] = initialQsParams;
        querystring = qsFields.join('&');
        break;
      }
    }
    if (initialDecoration) {
      querystring = initialQsParams + '&' + querystring;
    }
  }
  hashSplit[0] = beforeQuerystring + '?' + querystring;
  return hashSplit.join('#');
}
/**
 * Finds the root domain
 */
function findRootDomain(sameSite, secure) {
  var windowLocationHostnameAlias = window.location.hostname,
    cookiePrefix = '_sp_root_domain_test_',
    cookieName = cookiePrefix + new Date().getTime(),
    cookieValue = '_test_value_' + new Date().getTime();
  var locationParts = windowLocationHostnameAlias.split('.');
  for (var idx = locationParts.length - 2; idx >= 0; idx--) {
    var currentDomain = locationParts.slice(idx).join('.');
    cookie(cookieName, cookieValue, 0, '/', currentDomain, sameSite, secure);
    if (cookie(cookieName) === cookieValue) {
      // Clean up created cookie(s)
      deleteCookie(cookieName, '/', currentDomain, sameSite, secure);
      var cookieNames = getCookiesWithPrefix(cookiePrefix);
      for (var i = 0; i < cookieNames.length; i++) {
        deleteCookie(cookieNames[i], '/', currentDomain, sameSite, secure);
      }
      return currentDomain;
    }
  }
  // Cookies cannot be read
  return windowLocationHostnameAlias;
}
/**
 * Checks whether a value is present within an array
 *
 * @param val - The value to check for
 * @param array - The array to check within
 * @returns boolean Whether it exists
 */
function isValueInArray(val, array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === val) {
      return true;
    }
  }
  return false;
}
/**
 * Deletes an arbitrary cookie by setting the expiration date to the past
 *
 * @param cookieName - The name of the cookie to delete
 * @param domainName - The domain the cookie is in
 */
function deleteCookie(cookieName, path, domainName, sameSite, secure) {
  cookie(cookieName, '', -1, path, domainName, sameSite, secure);
}
/**
 * Fetches the name of all cookies beginning with a certain prefix
 *
 * @param cookiePrefix - The prefix to check for
 * @returns array The cookies that begin with the prefix
 */
function getCookiesWithPrefix(cookiePrefix) {
  var cookies = document.cookie.split('; ');
  var cookieNames = [];
  for (var i = 0; i < cookies.length; i++) {
    if (cookies[i].substring(0, cookiePrefix.length) === cookiePrefix) {
      cookieNames.push(cookies[i]);
    }
  }
  return cookieNames;
}
/**
 * Get and set the cookies associated with the current document in browser
 * This implementation always returns a string, returns the cookie value if only name is specified
 *
 * @param name - The cookie name (required)
 * @param value - The cookie value
 * @param ttl - The cookie Time To Live (seconds)
 * @param path - The cookies path
 * @param domain - The cookies domain
 * @param samesite - The cookies samesite attribute
 * @param secure - Boolean to specify if cookie should be secure
 * @returns string The cookies value
 */
function cookie(name, value, ttl, path, domain, samesite, secure) {
  if (arguments.length > 1) {
    return document.cookie = name + '=' + encodeURIComponent(value !== null && value !== void 0 ? value : '') + (ttl ? '; Expires=' + new Date(+new Date() + ttl * 1000).toUTCString() : '') + (path ? '; Path=' + path : '') + (domain ? '; Domain=' + domain : '') + (samesite ? '; SameSite=' + samesite : '') + (secure ? '; Secure' : '');
  }
  return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
}
/**
 * Parses an object and returns either the
 * integer or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateInt(obj) {
  var result = parseInt(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Parses an object and returns either the
 * number or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateFloat(obj) {
  var result = parseFloat(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 * @param boolean - byClass Whether to allowlist/denylist based on an element's classes (for forms)
 *                        or name attribute (for fields)
 */
function getFilterByClass(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = Object.prototype.hasOwnProperty.call(criterion, 'allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return checkClass(elt, specifiedClassesSet) === inclusive;
  });
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 */
function getFilterByName(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = criterion.hasOwnProperty('allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return elt.name in specifiedClassesSet === inclusive;
  });
}
/**
 * List the classes of a DOM element without using elt.classList (for compatibility with IE 9)
 */
function getCssClasses(elt) {
  return elt.className.match(/\S+/g) || [];
}
/**
 * Check whether an element has at least one class from a given list
 */
function checkClass(elt, classList) {
  var classes = getCssClasses(elt);
  for (var _i = 0, classes_1 = classes; _i < classes_1.length; _i++) {
    var className = classes_1[_i];
    if (classList[className]) {
      return true;
    }
  }
  return false;
}
function getFilter(criterion, fallbackFilter) {
  if (criterion.hasOwnProperty('filter') && criterion.filter) {
    return criterion.filter;
  }
  return fallbackFilter;
}
function getSpecifiedClassesSet(criterion) {
  // Convert the array of classes to an object of the form {class1: true, class2: true, ...}
  var specifiedClassesSet = {};
  var specifiedClasses = criterion.allowlist || criterion.denylist;
  if (specifiedClasses) {
    if (!Array.isArray(specifiedClasses)) {
      specifiedClasses = [specifiedClasses];
    }
    for (var i = 0; i < specifiedClasses.length; i++) {
      specifiedClassesSet[specifiedClasses[i]] = true;
    }
  }
  return specifiedClassesSet;
}
function newLocalStorageEventStore(_a) {
  var trackerId = _a.trackerId,
    _b = _a.maxLocalStorageQueueSize,
    maxLocalStorageQueueSize = _b === void 0 ? 1000 : _b,
    _c = _a.useLocalStorage,
    useLocalStorage = _c === void 0 ? true : _c;
  var queueName = "snowplowOutQueue_".concat(trackerId);
  function newInMemoryEventStoreFromLocalStorage() {
    if (useLocalStorage) {
      var localStorageQueue = window.localStorage.getItem(queueName);
      var events = localStorageQueue ? JSON.parse(localStorageQueue) : [];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["a" /* newInMemoryEventStore */])({
        maxSize: maxLocalStorageQueueSize,
        events: events
      });
    } else {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["a" /* newInMemoryEventStore */])({
        maxSize: maxLocalStorageQueueSize
      });
    }
  }
  var _d = newInMemoryEventStoreFromLocalStorage(),
    getAll = _d.getAll,
    getAllPayloads = _d.getAllPayloads,
    _add = _d.add,
    count = _d.count,
    iterator = _d.iterator,
    _removeHead = _d.removeHead;
  function sync() {
    if (useLocalStorage) {
      return getAll().then(function (events) {
        window.localStorage.setItem(queueName, JSON.stringify(events));
      });
    } else {
      return Promise.resolve();
    }
  }
  return {
    count: count,
    add: function add(payload) {
      _add(payload);
      return sync().then(count);
    },
    removeHead: function removeHead(count) {
      _removeHead(count);
      return sync();
    },
    iterator: iterator,
    getAll: getAll,
    getAllPayloads: getAllPayloads,
    setUseLocalStorage: function setUseLocalStorage(use) {
      useLocalStorage = use;
    }
  };
}
function newOutQueue(configuration, sharedState) {
  var _a;
  var eventStore = (_a = configuration.eventStore) !== null && _a !== void 0 ? _a : newLocalStorageEventStore(configuration);
  configuration.eventStore = eventStore;
  var emitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["b" /* newEmitter */])(configuration);
  sharedState.bufferFlushers.push(emitter.flush);
  return {
    enqueueRequest: emitter.input,
    executeQueue: emitter.flush,
    setAnonymousTracking: emitter.setAnonymousTracking,
    setCollectorUrl: emitter.setCollectorUrl,
    setBufferSize: emitter.setBufferSize,
    setUseLocalStorage: function setUseLocalStorage(localStorage) {
      if (eventStore.hasOwnProperty('setUseLocalStorage')) {
        var localStorageStore = eventStore;
        localStorageStore.setUseLocalStorage(localStorage);
      }
    }
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Extract parameter from URL
 */
function getParameter(url, name) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:https?|ftp)(?::/*(?:[^?]+))([?][^#]+)'),
    matches = e.exec(url);
  if (matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 1) {
    return fromQuerystring(name, matches[1]);
  }
  return null;
}
/*
 * Fix-up URL when page rendered from search engine cache or translated page.
 */
function fixupUrl(hostName, href, referrer) {
  var _a;
  if (hostName === 'translate.googleusercontent.com') {
    // Google
    if (referrer === '') {
      referrer = href;
    }
    href = (_a = getParameter(href, 'u')) !== null && _a !== void 0 ? _a : '';
    hostName = getHostName(href);
  } else if (hostName === 'cc.bingj.com' ||
  // Bing & Yahoo
  hostName === 'webcache.googleusercontent.com' // Google
  ) {
    href = document.links[0].href;
    hostName = getHostName(href);
  }
  return [hostName, href, referrer];
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Indices of cookie values
 */
var cookieDisabledIndex = 0,
  domainUserIdIndex = 1,
  createTsIndex = 2,
  visitCountIndex = 3,
  nowTsIndex = 4,
  lastVisitTsIndex = 5,
  sessionIdIndex = 6,
  previousSessionIdIndex = 7,
  firstEventIdIndex = 8,
  firstEventTsInMsIndex = 9,
  eventIndexIndex = 10;
function emptyIdCookie() {
  var idCookie = ['1', '', 0, 0, 0, undefined, '', '', '', undefined, 0];
  return idCookie;
}
/**
 * Parses the cookie values from its string representation.
 *
 * @param id Cookie value as string
 * @param domainUserId Domain user ID to be used in case of empty cookie string
 * @returns Parsed ID cookie tuple
 */
function parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount) {
  var now = new Date(),
    nowTs = Math.round(now.getTime() / 1000),
    tmpContainer;
  if (id) {
    tmpContainer = id.split('.');
    // cookies enabled
    tmpContainer.unshift('0');
  } else {
    tmpContainer = [
    // cookies disabled
    '1',
    // Domain user ID
    domainUserId,
    // Creation timestamp - seconds since Unix epoch
    nowTs,
    // visitCount - 0 = no previous visit
    memorizedVisitCount,
    // Current visit timestamp
    nowTs,
    // Last visit timestamp - blank meaning no previous visit
    '',
    // Session ID
    memorizedSessionId];
  }
  if (!tmpContainer[sessionIdIndex] || tmpContainer[sessionIdIndex] === 'undefined') {
    // session id
    tmpContainer[sessionIdIndex] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
  }
  if (!tmpContainer[previousSessionIdIndex] || tmpContainer[previousSessionIdIndex] === 'undefined') {
    // previous session id
    tmpContainer[previousSessionIdIndex] = '';
  }
  if (!tmpContainer[firstEventIdIndex] || tmpContainer[firstEventIdIndex] === 'undefined') {
    // firstEventId - blank meaning no previous event
    tmpContainer[firstEventIdIndex] = '';
  }
  if (!tmpContainer[firstEventTsInMsIndex] || tmpContainer[firstEventTsInMsIndex] === 'undefined') {
    // firstEventTs - blank meaning no previous event
    tmpContainer[firstEventTsInMsIndex] = '';
  }
  if (!tmpContainer[eventIndexIndex] || tmpContainer[eventIndexIndex] === 'undefined') {
    // eventIndex – 0 = no previous event
    tmpContainer[eventIndexIndex] = 0;
  }
  var parseIntOr = function parseIntOr(value, defaultValue) {
    var parsed = parseInt(value);
    return isNaN(parsed) ? defaultValue : parsed;
  };
  var parseIntOrUndefined = function parseIntOrUndefined(value) {
    return value ? parseIntOr(value, undefined) : undefined;
  };
  var parsed = [tmpContainer[cookieDisabledIndex], tmpContainer[domainUserIdIndex], parseIntOr(tmpContainer[createTsIndex], nowTs), parseIntOr(tmpContainer[visitCountIndex], memorizedVisitCount), parseIntOr(tmpContainer[nowTsIndex], nowTs), parseIntOrUndefined(tmpContainer[lastVisitTsIndex]), tmpContainer[sessionIdIndex], tmpContainer[previousSessionIdIndex], tmpContainer[firstEventIdIndex], parseIntOrUndefined(tmpContainer[firstEventTsInMsIndex]), parseIntOr(tmpContainer[eventIndexIndex], 0)];
  return parsed;
}
/**
 * Initializes the domain user ID if not already present in the cookie. Sets an empty string if anonymous tracking.
 *
 * @param idCookie Parsed cookie
 * @param configAnonymousTracking Whether anonymous tracking is enabled
 * @returns Domain user ID
 */
function initializeDomainUserId(idCookie, configAnonymousTracking) {
  var domainUserId;
  if (idCookie[domainUserIdIndex]) {
    domainUserId = idCookie[domainUserIdIndex];
  } else if (!configAnonymousTracking) {
    domainUserId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
    idCookie[domainUserIdIndex] = domainUserId;
  } else {
    domainUserId = '';
    idCookie[domainUserIdIndex] = domainUserId;
  }
  return domainUserId;
}
/**
 * Starts a new session with a new ID.
 * Sets the previous session, last visit timestamp, and increments visit count if cookies enabled.
 * First event references are reset and will be updated in `updateFirstEventInIdCookie`.
 *
 * @param idCookie Parsed cookie
 * @param options.configStateStorageStrategy Cookie storage strategy
 * @param options.configAnonymousTracking If anonymous tracking is enabled
 * @param options.memorizedVisitCount Visit count to be used if cookies not enabled
 * @param options.onSessionUpdateCallback Session callback triggered on every session update
 * @returns New session ID
 */
function startNewIdCookieSession(idCookie, options) {
  if (options === void 0) {
    options = {
      memorizedVisitCount: 1
    };
  }
  var memorizedVisitCount = options.memorizedVisitCount;
  // If cookies are enabled, base visit count and session ID on the cookies
  if (cookiesEnabledInIdCookie(idCookie)) {
    // Store the previous session ID
    idCookie[previousSessionIdIndex] = idCookie[sessionIdIndex];
    // Set lastVisitTs to currentVisitTs
    idCookie[lastVisitTsIndex] = idCookie[nowTsIndex];
    // Increment the session ID
    idCookie[visitCountIndex]++;
  } else {
    idCookie[visitCountIndex] = memorizedVisitCount;
  }
  // Create a new sessionId
  var sessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
  idCookie[sessionIdIndex] = sessionId;
  // Reset event index and first event references
  idCookie[eventIndexIndex] = 0;
  idCookie[firstEventIdIndex] = '';
  idCookie[firstEventTsInMsIndex] = undefined;
  return sessionId;
}
/**
 * Update now timestamp in cookie.
 *
 * @param idCookie Parsed cookie
 */
function updateNowTsInIdCookie(idCookie) {
  idCookie[nowTsIndex] = Math.round(new Date().getTime() / 1000);
}
/**
 * Updates the first event references according to the event payload if first event in session.
 *
 * @param idCookie - Parsed cookie
 * @param payloadBuilder - Event payload builder
 */
function updateFirstEventInIdCookie(idCookie, payloadBuilder) {
  // Update first event references if new session or not present
  if (idCookie[eventIndexIndex] === 0) {
    var payload = payloadBuilder.build();
    idCookie[firstEventIdIndex] = payload['eid'];
    var ts = payload['dtm'] || payload['ttm'];
    idCookie[firstEventTsInMsIndex] = ts ? parseInt(ts) : undefined;
  }
}
/**
 * Increments event index counter.
 *
 * @param idCookie Parsed cookie
 */
function incrementEventIndexInIdCookie(idCookie) {
  idCookie[eventIndexIndex] += 1;
}
/**
 * Serializes parsed cookie to string representation.
 *
 * @param idCookie Parsed cookie
 * @returns String cookie value
 */
function serializeIdCookie(idCookie, configAnonymousTracking) {
  var anonymizedIdCookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __spreadArray */])([], idCookie, true);
  if (configAnonymousTracking) {
    anonymizedIdCookie[domainUserIdIndex] = '';
    anonymizedIdCookie[previousSessionIdIndex] = '';
  }
  anonymizedIdCookie.shift();
  return anonymizedIdCookie.join('.');
}
/**
 * Transforms the parsed cookie into a client session context entity.
 *
 * @param idCookie Parsed cookie
 * @param configStateStorageStrategy Cookie storage strategy
 * @param configAnonymousTracking If anonymous tracking is enabled
 * @returns Client session context entity
 */
function clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking) {
  var firstEventTsInMs = idCookie[firstEventTsInMsIndex];
  var clientSession = {
    userId: configAnonymousTracking ? '00000000-0000-0000-0000-000000000000' // TODO: use uuid.NIL when we upgrade to uuid v8.3
    : idCookie[domainUserIdIndex],
    sessionId: idCookie[sessionIdIndex],
    eventIndex: idCookie[eventIndexIndex],
    sessionIndex: idCookie[visitCountIndex],
    previousSessionId: configAnonymousTracking ? null : idCookie[previousSessionIdIndex] || null,
    storageMechanism: configStateStorageStrategy == 'localStorage' ? 'LOCAL_STORAGE' : 'COOKIE_1',
    firstEventId: idCookie[firstEventIdIndex] || null,
    firstEventTimestamp: firstEventTsInMs ? new Date(firstEventTsInMs).toISOString() : null
  };
  return clientSession;
}
function sessionIdFromIdCookie(idCookie) {
  return idCookie[sessionIdIndex];
}
function domainUserIdFromIdCookie(idCookie) {
  return idCookie[domainUserIdIndex];
}
function visitCountFromIdCookie(idCookie) {
  return idCookie[visitCountIndex];
}
function cookiesEnabledInIdCookie(idCookie) {
  return idCookie[cookieDisabledIndex] === '0';
}
function eventIndexFromIdCookie(idCookie) {
  return idCookie[eventIndexIndex];
}
var WEB_PAGE_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/web_page/jsonschema/1-0-0';
var BROWSER_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/browser_context/jsonschema/2-0-0';
var CLIENT_SESSION_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/client_session/jsonschema/1-0-2';
var APPLICATION_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/application/jsonschema/1-0-0';
function useResizeObserver() {
  return 'ResizeObserver' in window;
}
var resizeObserverInitialized = false;
var readBrowserPropertiesTask = null;
function initializeResizeObserver() {
  if (resizeObserverInitialized) {
    return;
  }
  if (!document || !document.body || !document.documentElement) {
    return;
  }
  resizeObserverInitialized = true;
  var resizeObserver = new ResizeObserver(function () {
    if (!readBrowserPropertiesTask) {
      // The browser property lookup causes a forced synchronous layout when offsets/sizes are
      // queried. It's possible that the forced synchronous layout causes the ResizeObserver
      // to be fired again, leading to an infinite loop and the "ResizeObserver loop completed
      // with undelivered notifications" error.
      readBrowserPropertiesTask = requestAnimationFrame(function () {
        readBrowserPropertiesTask = null;
        cachedProperties = readBrowserProperties();
      });
    }
  });
  resizeObserver.observe(document.body);
  resizeObserver.observe(document.documentElement);
}
var cachedProperties;
/* Separator used for dimension values e.g. widthxheight */
var DIMENSION_SEPARATOR = 'x';
/**
 * Gets various browser properties (that are expensive to read!)
 * - Will use a "ResizeObserver" approach in modern browsers to update cached properties only on change
 * - Will fallback to a direct read approach without cache in old browsers
 *
 * @returns BrowserProperties
 */
function getBrowserProperties() {
  if (!useResizeObserver()) {
    return readBrowserProperties();
  }
  if (!cachedProperties) {
    cachedProperties = readBrowserProperties();
  }
  initializeResizeObserver();
  return cachedProperties;
}
/**
 * Reads the browser properties - expensive call!
 *
 * @returns BrowserProperties
 */
function readBrowserProperties() {
  return {
    viewport: floorDimensionFields(detectViewport()),
    documentSize: floorDimensionFields(detectDocumentSize()),
    resolution: floorDimensionFields(detectScreenResolution()),
    colorDepth: screen.colorDepth,
    devicePixelRatio: window.devicePixelRatio,
    cookiesEnabled: window.navigator.cookieEnabled,
    online: window.navigator.onLine,
    browserLanguage: window.navigator.language || window.navigator.userLanguage,
    documentLanguage: document.documentElement.lang,
    webdriver: window.navigator.webdriver,
    deviceMemory: window.navigator.deviceMemory,
    hardwareConcurrency: window.navigator.hardwareConcurrency
  };
}
/**
 * Gets the current viewport.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 * - http://responsejs.com/labs/dimensions/
 */
function detectViewport() {
  var width, height;
  if ('innerWidth' in window) {
    width = window['innerWidth'];
    height = window['innerHeight'];
  } else {
    var e = document.documentElement || document.body;
    width = e['clientWidth'];
    height = e['clientHeight'];
  }
  return Math.max(0, width) + DIMENSION_SEPARATOR + Math.max(0, height);
}
/**
 * Gets the dimensions of the current
 * document.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 */
function detectDocumentSize() {
  var de = document.documentElement,
    // Alias
    be = document.body,
    // document.body may not have rendered, so check whether be.offsetHeight is null
    bodyHeight = be ? Math.max(be.offsetHeight, be.scrollHeight) : 0;
  var w = Math.max(de.clientWidth, de.offsetWidth, de.scrollWidth);
  var h = Math.max(de.clientHeight, de.offsetHeight, de.scrollHeight, bodyHeight);
  return isNaN(w) || isNaN(h) ? '' : w + DIMENSION_SEPARATOR + h;
}
function detectScreenResolution() {
  return screen.width + DIMENSION_SEPARATOR + screen.height;
}
function floorDimensionFields(field) {
  return field && field.split(DIMENSION_SEPARATOR).map(function (dimension) {
    return Math.floor(Number(dimension));
  }).join(DIMENSION_SEPARATOR);
}
function newCookie(name) {
  var flushTimer;
  var lastSetValueArgs;
  var cacheExpireAt;
  var flushed = true;
  var flushTimeout = 10; // milliseconds
  var maxCacheTtl = 0.05; // seconds
  function getValue() {
    var _a;
    // Note: we can't cache the cookie value as we don't know the expiration date
    if (lastSetValueArgs && (!cacheExpireAt || cacheExpireAt > new Date())) {
      return (_a = lastSetValueArgs[0]) !== null && _a !== void 0 ? _a : cookie(name);
    }
    return cookie(name);
  }
  function setValue(value, ttl, path, domain, samesite, secure) {
    lastSetValueArgs = [value, ttl, path, domain, samesite, secure];
    flushed = false;
    // throttle setting the cookie
    if (flushTimer === undefined) {
      flushTimer = setTimeout(function () {
        flushTimer = undefined;
        flush();
      }, flushTimeout);
    }
    cacheExpireAt = new Date(Date.now() + Math.min(maxCacheTtl, ttl !== null && ttl !== void 0 ? ttl : maxCacheTtl) * 1000);
    return true;
  }
  function deleteValue(path, domainName, sameSite, secure) {
    lastSetValueArgs = undefined;
    flushed = true;
    // cancel setting the cookie
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    deleteCookie(name, path, domainName, sameSite, secure);
  }
  function flush() {
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    if (flushed) {
      return;
    }
    flushed = true;
    if (lastSetValueArgs !== undefined) {
      var value = lastSetValueArgs[0],
        ttl = lastSetValueArgs[1],
        path = lastSetValueArgs[2],
        domain = lastSetValueArgs[3],
        samesite = lastSetValueArgs[4],
        secure = lastSetValueArgs[5];
      cookie(name, value, ttl, path, domain, samesite, secure);
    }
  }
  return {
    getValue: getValue,
    setValue: setValue,
    deleteValue: deleteValue,
    flush: flush
  };
}
/**
 * Create a new async cookie storage
 *
 * @returns A new cookie storage
 */
function newCookieStorage() {
  var cache = {};
  function getOrInitCookie(name) {
    if (!cache[name]) {
      cache[name] = newCookie(name);
    }
    return cache[name];
  }
  function getCookie(name) {
    return getOrInitCookie(name).getValue();
  }
  function setCookie(name, value, ttl, path, domain, samesite, secure) {
    return getOrInitCookie(name).setValue(value, ttl, path, domain, samesite, secure);
  }
  function deleteCookie(name, path, domainName, sameSite, secure) {
    getOrInitCookie(name).deleteValue(path, domainName, sameSite, secure);
  }
  function clearCache() {
    cache = {};
  }
  function flush() {
    for (var _i = 0, _a = Object.values(cache); _i < _a.length; _i++) {
      var cookie_1 = _a[_i];
      cookie_1.flush();
    }
  }
  return {
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
    clearCache: clearCache,
    flush: flush
  };
}
/**
 * Cookie storage instance with asynchronous cookie writes
 */
var asyncCookieStorage = newCookieStorage();
/**
 * Cookie storage instance with synchronous cookie writes
 */
var syncCookieStorage = {
  getCookie: cookie,
  setCookie: function setCookie(name, value, ttl, path, domain, samesite, secure) {
    cookie(name, value, ttl, path, domain, samesite, secure);
    return document.cookie.indexOf("".concat(name, "=")) !== -1;
  },
  deleteCookie: deleteCookie,
  flush: function flush() {}
};

/**
 * The Snowplow Tracker
 *
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker object
 * @param version - The current version of the JavaScript Tracker
 * @param endpoint - The collector endpoint to send events to, with or without protocol
 * @param sharedState - An object containing state which is shared across tracker instances
 * @param trackerConfiguration - Dictionary of configuration options
 */
function Tracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration) {
  if (trackerConfiguration === void 0) {
    trackerConfiguration = {};
  }
  var browserPlugins = [];
  var newTracker = function newTracker(trackerId, namespace, version, endpoint, state, trackerConfiguration) {
    /************************************************************
     * Private members
     ************************************************************/
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    //use POST if eventMethod isn't present on the newTrackerConfiguration
    trackerConfiguration.eventMethod = (_a = trackerConfiguration.eventMethod) !== null && _a !== void 0 ? _a : 'post';
    var getStateStorageStrategy = function getStateStorageStrategy(config) {
        var _a;
        return (_a = config.stateStorageStrategy) !== null && _a !== void 0 ? _a : 'cookieAndLocalStorage';
      },
      getAnonymousSessionTracking = function getAnonymousSessionTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withSessionTracking) === true;
      },
      getAnonymousServerTracking = function getAnonymousServerTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withServerAnonymisation) === true;
      },
      getAnonymousTracking = function getAnonymousTracking(config) {
        return !!config.anonymousTracking;
      },
      isBrowserContextAvailable = (_c = (_b = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _b === void 0 ? void 0 : _b.browser) !== null && _c !== void 0 ? _c : false,
      isWebPageContextAvailable = (_e = (_d = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _d === void 0 ? void 0 : _d.webPage) !== null && _e !== void 0 ? _e : true,
      getExtendedCrossDomainTrackingConfiguration = function getExtendedCrossDomainTrackingConfiguration(crossDomainTrackingConfig) {
        if (typeof crossDomainTrackingConfig === 'boolean') {
          return {
            useExtendedCrossDomainLinker: crossDomainTrackingConfig
          };
        }
        return {
          useExtendedCrossDomainLinker: true,
          collectCrossDomainAttributes: crossDomainTrackingConfig
        };
      };
    // Create a new cookie storage instance with synchronous cookie write if configured
    var cookieStorage = trackerConfiguration.synchronousCookieWrite ? syncCookieStorage : asyncCookieStorage;
    // Get all injected plugins
    browserPlugins.push(getBrowserDataPlugin());
    /* When including the Web Page context, we add the relevant internal plugins */
    if (isWebPageContextAvailable) {
      browserPlugins.push(getWebPagePlugin());
    }
    if (isBrowserContextAvailable) {
      browserPlugins.push(getBrowserContextPlugin());
    }
    browserPlugins.push.apply(browserPlugins, (_f = trackerConfiguration.plugins) !== null && _f !== void 0 ? _f : []);
    var
      // Tracker core
      core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["c" /* trackerCore */])({
        base64: (_g = trackerConfiguration.encodeBase64) !== null && _g !== void 0 ? _g : trackerConfiguration.eventMethod !== 'post',
        corePlugins: browserPlugins,
        callback: sendRequest
      }),
      // Aliases
      documentCharset = document.characterSet || document.charset,
      // Current URL and Referrer URL
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer()),
      domainAlias = fixupDomain(locationArray[0]),
      locationHrefAlias = locationArray[1],
      configReferrerUrl = locationArray[2],
      customReferrer,
      // Platform defaults to web for this tracker
      configPlatform = (_h = trackerConfiguration.platform) !== null && _h !== void 0 ? _h : 'web',
      // Site ID
      configTrackerSiteId = (_j = trackerConfiguration.appId) !== null && _j !== void 0 ? _j : '',
      // Application version
      configAppVersion = trackerConfiguration.appVersion,
      // Document URL
      configCustomUrl,
      // Document title
      lastDocumentTitle = document.title,
      // Custom title
      lastConfigTitle,
      // Indicates that the lastConfigTitle was set from a trackPageView call
      // Custom title configured this way has a shorter lifespan than when set using setDocumentTitle.
      // It only lasts until the next trackPageView call.
      lastConfigTitleFromTrackPageView = false,
      // Controls whether activity tracking page ping event timers are reset on page view events
      resetActivityTrackingOnPageView = (_k = trackerConfiguration.resetActivityTrackingOnPageView) !== null && _k !== void 0 ? _k : true,
      // Disallow hash tags in URL. TODO: Should this be set to true by default?
      configDiscardHashTag,
      // Disallow brace in URL.
      configDiscardBrace,
      // First-party cookie name prefix
      configCookieNamePrefix = (_l = trackerConfiguration.cookieName) !== null && _l !== void 0 ? _l : '_sp_',
      // First-party cookie domain
      // User agent defaults to origin hostname
      configCookieDomain = (_m = trackerConfiguration.cookieDomain) !== null && _m !== void 0 ? _m : undefined,
      discoverRootDomain = (_o = trackerConfiguration.discoverRootDomain) !== null && _o !== void 0 ? _o : configCookieDomain === undefined,
      // First-party cookie path
      // Default is user agent defined.
      configCookiePath = '/',
      // First-party cookie samesite attribute
      configCookieSameSite = (_p = trackerConfiguration.cookieSameSite) !== null && _p !== void 0 ? _p : 'Lax',
      // First-party cookie secure attribute
      configCookieSecure = (_q = trackerConfiguration.cookieSecure) !== null && _q !== void 0 ? _q : true,
      // Do Not Track browser feature
      dnt = window.navigator.doNotTrack || window.navigator.msDoNotTrack || window.doNotTrack,
      // Do Not Track
      configDoNotTrack = typeof trackerConfiguration.respectDoNotTrack !== 'undefined' ? trackerConfiguration.respectDoNotTrack && (dnt === 'yes' || dnt === '1') : false,
      // Opt out of cookie tracking
      configOptOutCookie,
      // Life of the visitor cookie (in seconds)
      configVisitorCookieTimeout = (_r = trackerConfiguration.cookieLifetime) !== null && _r !== void 0 ? _r : 63072000,
      // 2 years
      // Life of the session cookie (in seconds)
      configSessionCookieTimeout = (_s = trackerConfiguration.sessionCookieTimeout) !== null && _s !== void 0 ? _s : 1800,
      // 30 minutes
      // Allows tracking user session (using cookies or local storage), can only be used with anonymousTracking
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration),
      // Will send a header to server to prevent returning cookie and capturing IP
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration),
      // Sets tracker to work in anonymous mode without accessing client storage
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration),
      // Strategy defining how to store the state: cookie, localStorage, cookieAndLocalStorage or none
      configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration),
      // Last activity timestamp
      lastActivityTime,
      // The last time an event was fired on the page - used to invalidate session if cookies are disabled
      lastEventTime = new Date().getTime(),
      // How are we scrolling?
      minXOffset,
      maxXOffset,
      minYOffset,
      maxYOffset,
      // Domain hash value
      domainHash,
      // Domain unique user ID
      domainUserId,
      // ID for the current session
      memorizedSessionId,
      // Index for the current session - kept in memory in case cookies are disabled
      memorizedVisitCount = 1,
      // Business-defined unique user ID
      businessUserId,
      // Manager for local storage queue
      outQueue = newOutQueue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({
        trackerId: trackerId,
        endpoint: asCollectorUrl(endpoint),
        serverAnonymization: configAnonymousServerTracking,
        useLocalStorage: configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage'
      }, trackerConfiguration), state),
      // Whether pageViewId should be regenerated after each trackPageView. Affect web_page context
      _preservePageViewId = false,
      // Whether pageViewId should be kept the same until the page URL changes. Affects web_page context
      _preservePageViewIdForUrl = (_t = trackerConfiguration.preservePageViewIdForUrl) !== null && _t !== void 0 ? _t : false,
      // The pageViewId of the last page view event or undefined if no page view tracked yet. Used to determine if pageViewId should be regenerated for a new page view.
      lastSentPageViewId = undefined,
      // Activity tracking config for callback and page ping variants
      activityTrackingConfig = {
        enabled: false,
        installed: false,
        configurations: {}
      },
      configSessionContext = (_v = (_u = trackerConfiguration.contexts) === null || _u === void 0 ? void 0 : _u.session) !== null && _v !== void 0 ? _v : false,
      toOptoutByCookie,
      onSessionUpdateCallback = trackerConfiguration.onSessionUpdateCallback,
      manualSessionUpdateCalled = false,
      _w = getExtendedCrossDomainTrackingConfiguration(trackerConfiguration.useExtendedCrossDomainLinker || false),
      useExtendedCrossDomainLinker = _w.useExtendedCrossDomainLinker,
      collectCrossDomainAttributes = _w.collectCrossDomainAttributes;
    if (discoverRootDomain && !configCookieDomain) {
      configCookieDomain = findRootDomain(configCookieSameSite, configCookieSecure);
    }
    var _x = getBrowserProperties(),
      browserLanguage = _x.browserLanguage,
      resolution = _x.resolution,
      colorDepth = _x.colorDepth,
      cookiesEnabled = _x.cookiesEnabled;
    var timeZone = getTimeZone();
    // Set up unchanging name-value pairs
    core.setTrackerVersion(version);
    core.setTrackerNamespace(namespace);
    core.setAppId(configTrackerSiteId);
    core.setPlatform(configPlatform);
    core.addPayloadPair('cookie', cookiesEnabled ? '1' : '0');
    core.addPayloadPair('cs', documentCharset);
    core.addPayloadPair('lang', browserLanguage);
    core.addPayloadPair('res', resolution);
    core.addPayloadPair('cd', colorDepth);
    if (timeZone) core.addPayloadPair('tz', timeZone);
    // Add the application version context entity
    if (configAppVersion) {
      core.addPlugin({
        plugin: {
          contexts: function contexts() {
            return [{
              schema: APPLICATION_CONTEXT_SCHEMA,
              data: {
                version: configAppVersion
              }
            }];
          }
        }
      });
    }
    /*
     * Initialize tracker
     */
    updateDomainHash();
    initializeIdsAndCookies();
    if (trackerConfiguration.crossDomainLinker) {
      decorateLinks(trackerConfiguration.crossDomainLinker);
    }
    /**
     * Recalculate the domain, URL, and referrer
     */
    function refreshUrl() {
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer());
      // If this is a single-page app and the page URL has changed, then:
      //   - if the new URL's querystring contains a "refer(r)er" parameter, use it as the referrer
      //   - otherwise use the old URL as the referer
      if (locationArray[1] !== locationHrefAlias) {
        configReferrerUrl = getReferrer(locationHrefAlias);
      }
      domainAlias = fixupDomain(locationArray[0]);
      locationHrefAlias = locationArray[1];
    }
    /**
     * Create link handler to decorate the querystring of a link (onClick/onMouseDown)
     *
     * @param event - e The event targeting the link
     */
    function addLinkDecorationHandler(extended) {
      var CROSS_DOMAIN_PARAMETER_NAME = '_sp';
      return function (evt) {
        var elt = evt.currentTarget;
        var crossDomainParameterValue = createCrossDomainParameterValue(extended, collectCrossDomainAttributes, {
          domainUserId: domainUserId,
          userId: businessUserId || undefined,
          sessionId: memorizedSessionId,
          sourceId: configTrackerSiteId,
          sourcePlatform: configPlatform,
          event: evt
        });
        if (elt === null || elt === void 0 ? void 0 : elt.href) {
          elt.href = decorateQuerystring(elt.href, CROSS_DOMAIN_PARAMETER_NAME, crossDomainParameterValue);
        }
      };
    }
    /**
     * Enable querystring decoration for links passing a filter
     * Whenever such a link is clicked on or navigated to via the keyboard,
     * add "_sp={{duid}}.{{timestamp}}" to its querystring
     *
     * @param crossDomainLinker - Function used to determine which links to decorate
     */
    function decorateLinks(crossDomainLinker) {
      var crossDomainLinkHandler = addLinkDecorationHandler(useExtendedCrossDomainLinker);
      for (var i = 0; i < document.links.length; i++) {
        var elt = document.links[i];
        if (!elt.spDecorationEnabled && crossDomainLinker(elt)) {
          elt.addEventListener('click', crossDomainLinkHandler, true);
          elt.addEventListener('mousedown', crossDomainLinkHandler, true);
          // Don't add event listeners more than once
          elt.spDecorationEnabled = true;
        }
      }
    }
    /*
     * Removes hash tag from the URL
     *
     * URLs are purified before being recorded in the cookie,
     * or before being sent as GET parameters
     */
    function purify(url) {
      var targetPattern;
      if (configDiscardHashTag) {
        targetPattern = new RegExp('#.*');
        url = url.replace(targetPattern, '');
      }
      if (configDiscardBrace) {
        targetPattern = new RegExp('[{}]', 'g');
        url = url.replace(targetPattern, '');
      }
      return url;
    }
    /*
     * Extract scheme/protocol from URL
     */
    function getProtocolScheme(url) {
      var e = new RegExp('^([a-z]+):'),
        matches = e.exec(url);
      return matches ? matches[1] : null;
    }
    /*
     * Resolve relative reference
     *
     * Note: not as described in rfc3986 section 5.2
     */
    function resolveRelativeReference(baseUrl, url) {
      var protocol = getProtocolScheme(url),
        i;
      if (protocol) {
        return url;
      }
      if (url.slice(0, 1) === '/') {
        return getProtocolScheme(baseUrl) + '://' + getHostName(baseUrl) + url;
      }
      baseUrl = purify(baseUrl);
      if ((i = baseUrl.indexOf('?')) >= 0) {
        baseUrl = baseUrl.slice(0, i);
      }
      if ((i = baseUrl.lastIndexOf('/')) !== baseUrl.length - 1) {
        baseUrl = baseUrl.slice(0, i + 1);
      }
      return baseUrl + url;
    }
    /*
     * Send request
     */
    function sendRequest(request) {
      if (!(configDoNotTrack || toOptoutByCookie)) {
        outQueue.enqueueRequest(request.build());
      }
    }
    /*
     * Get cookie name with prefix and domain hash
     */
    function getSnowplowCookieName(baseName) {
      return configCookieNamePrefix + baseName + '.' + domainHash;
    }
    /*
     * Cookie getter.
     */
    function getSnowplowCookieValue(cookieName) {
      var fullName = getSnowplowCookieName(cookieName);
      if (configStateStorageStrategy == 'localStorage') {
        return attemptGetLocalStorage(fullName);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.getCookie(fullName);
      }
      return undefined;
    }
    /*
     * Update domain hash
     */
    function updateDomainHash() {
      refreshUrl();
      domainHash = __WEBPACK_IMPORTED_MODULE_2_sha1___default()((configCookieDomain || domainAlias) + (configCookiePath || '/')).slice(0, 4); // 4 hexits = 16 bits
    }
    /*
     * Process all "activity" events.
     * For performance, this function must have low overhead.
     */
    function activityHandler() {
      var now = new Date();
      lastActivityTime = now.getTime();
    }
    /*
     * Process all "scroll" events.
     */
    function scrollHandler() {
      updateMaxScrolls();
      activityHandler();
    }
    /*
     * Returns [pageXOffset, pageYOffset]
     */
    function getPageOffsets() {
      var documentElement = document.documentElement;
      if (documentElement) {
        return [documentElement.scrollLeft || window.pageXOffset, documentElement.scrollTop || window.pageYOffset];
      }
      return [0, 0];
    }
    /*
     * Quick initialization/reset of max scroll levels
     */
    function resetMaxScrolls() {
      var offsets = getPageOffsets();
      var x = offsets[0];
      minXOffset = x;
      maxXOffset = x;
      var y = offsets[1];
      minYOffset = y;
      maxYOffset = y;
    }
    /*
     * Check the max scroll levels, updating as necessary
     */
    function updateMaxScrolls() {
      var offsets = getPageOffsets();
      var x = offsets[0];
      if (x < minXOffset) {
        minXOffset = x;
      } else if (x > maxXOffset) {
        maxXOffset = x;
      }
      var y = offsets[1];
      if (y < minYOffset) {
        minYOffset = y;
      } else if (y > maxYOffset) {
        maxYOffset = y;
      }
    }
    /*
     * Prevents offsets from being decimal or NaN
     * See https://github.com/snowplow/snowplow-javascript-tracker/issues/324
     */
    function cleanOffset(offset) {
      return Math.round(offset);
    }
    /**
     * Sets or renews the session cookie.
     * Responsible for calling the `onSessionUpdateCallback` callback.
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setSessionCookie() {
      var cookieName = getSnowplowCookieName('ses');
      var cookieValue = '*';
      return persistValue(cookieName, cookieValue, configSessionCookieTimeout);
    }
    /**
     * @mutates idCookie
     * @param {ParsedIdCookie} idCookie
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setDomainUserIdCookie(idCookie) {
      var cookieName = getSnowplowCookieName('id');
      var cookieValue = serializeIdCookie(idCookie, configAnonymousTracking);
      return persistValue(cookieName, cookieValue, configVisitorCookieTimeout);
    }
    /**
     * no-op if anonymousTracking enabled, will still set cookies if anonymousSessionTracking is enabled
     * Sets a cookie based on the storage strategy:
     * - if 'localStorage': attempts to write to local storage
     * - if 'cookie' or 'cookieAndLocalStorage': writes to cookies
     * - otherwise: no-op
     * @param {string} name Name/key of the value to persist
     * @param {string} value
     * @param {number} timeout Used as the expiration date for cookies or as a TTL to be checked on LocalStorage
     * @returns {boolean} If the operation was successful or not
     */
    function persistValue(name, value, timeout) {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return false;
      }
      if (configStateStorageStrategy == 'localStorage') {
        return attemptWriteLocalStorage(name, value, timeout);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.setCookie(name, value, timeout, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      }
      return false;
    }
    /**
     * Clears all cookie and local storage for id and ses values
     */
    function clearUserDataAndCookies(configuration) {
      var idname = getSnowplowCookieName('id');
      var sesname = getSnowplowCookieName('ses');
      attemptDeleteLocalStorage(idname);
      attemptDeleteLocalStorage(sesname);
      cookieStorage.deleteCookie(idname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      cookieStorage.deleteCookie(sesname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveSession)) {
        memorizedSessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        memorizedVisitCount = 1;
      }
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveUser)) {
        domainUserId = configAnonymousTracking ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        businessUserId = null;
      }
    }
    /**
     * Toggle Anonymous Tracking
     */
    function toggleAnonymousTracking(configuration) {
      if (configuration && configuration.stateStorageStrategy) {
        trackerConfiguration.stateStorageStrategy = configuration.stateStorageStrategy;
        configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration);
      }
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration);
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration);
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration);
      outQueue.setUseLocalStorage(configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage');
      outQueue.setAnonymousTracking(configAnonymousServerTracking);
    }
    /*
     * Load the domain user ID and the session ID
     * Set the cookies (if cookies are enabled)
     */
    function initializeIdsAndCookies() {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return;
      }
      var sesCookieSet = configStateStorageStrategy != 'none' && !!getSnowplowCookieValue('ses');
      var idCookie = loadDomainUserIdCookie();
      domainUserId = initializeDomainUserId(idCookie, configAnonymousTracking);
      if (!sesCookieSet) {
        memorizedSessionId = startNewIdCookieSession(idCookie);
      } else {
        memorizedSessionId = sessionIdFromIdCookie(idCookie);
      }
      memorizedVisitCount = visitCountFromIdCookie(idCookie);
      if (configStateStorageStrategy != 'none') {
        setSessionCookie();
        // Update currentVisitTs
        updateNowTsInIdCookie(idCookie);
        setDomainUserIdCookie(idCookie);
        if (!eventIndexFromIdCookie(idCookie)) {
          // Synchronously update the cookies to persist the new session ASAP
          cookieStorage.flush();
        }
      }
    }
    /*
     * Load visitor ID cookie
     */
    function loadDomainUserIdCookie() {
      if (configStateStorageStrategy == 'none') {
        return emptyIdCookie();
      }
      var id = getSnowplowCookieValue('id') || undefined;
      return parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount);
    }
    /**
     * Adds the protocol in front of our collector URL
     *
     * @param string - collectorUrl The collector URL with or without protocol
     * @returns string collectorUrl The tracker URL with protocol
     */
    function asCollectorUrl(collectorUrl) {
      if (collectorUrl.indexOf('http') === 0) {
        return collectorUrl;
      }
      return ('https:' === document.location.protocol ? 'https' : 'http') + '://' + collectorUrl;
    }
    /**
     * Initialize new `pageViewId` if it shouldn't be preserved.
     * Should be called when `trackPageView` is invoked
     */
    function resetPageView() {
      if (!_preservePageViewId || state.pageViewId == null) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
    }
    /**
     * Safe function to get `pageViewId`.
     * Generates it if it wasn't initialized by other tracker
     */
    function getPageViewId() {
      if (shouldGenerateNewPageViewId()) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
      return state.pageViewId;
    }
    function shouldGenerateNewPageViewId() {
      // If pageViewId is not initialized, generate it
      if (state.pageViewId == null) {
        return true;
      }
      // If pageViewId should be preserved regardless of the URL, don't generate a new one
      if (_preservePageViewId || !_preservePageViewIdForUrl) {
        return false;
      }
      // If doesn't have previous URL in state, generate a new pageViewId
      if (state.pageViewUrl === undefined) {
        return true;
      }
      var current = configCustomUrl || locationHrefAlias;
      // If full preserve is enabled, compare the full URL
      if (_preservePageViewIdForUrl === true || _preservePageViewIdForUrl == 'full' || !('URL' in window)) {
        return state.pageViewUrl != current;
      }
      var currentUrl = new URL(current);
      var previousUrl = new URL(state.pageViewUrl);
      // If pathname preserve is enabled, compare the pathname
      if (_preservePageViewIdForUrl == 'pathname') {
        return currentUrl.pathname != previousUrl.pathname;
      }
      // If pathname and search preserve is enabled, compare the pathname and search
      if (_preservePageViewIdForUrl == 'pathnameAndSearch') {
        return currentUrl.pathname != previousUrl.pathname || currentUrl.search != previousUrl.search;
      }
      return false;
    }
    /**
     * Safe function to get `tabId`.
     * Generates it if it is not yet initialized. Shared between trackers.
     */
    function getTabId() {
      if (configStateStorageStrategy === 'none' || configAnonymousTracking || !isWebPageContextAvailable) {
        return null;
      }
      var SESSION_STORAGE_TAB_ID = '_sp_tab_id';
      var tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      if (!tabId) {
        attemptWriteSessionStorage(SESSION_STORAGE_TAB_ID, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])());
        tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      }
      return tabId || null;
    }
    /**
     * Put together a web page context with a unique UUID for the page view
     *
     * @returns web_page context
     */
    function getWebPagePlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: WEB_PAGE_SCHEMA,
            data: {
              id: getPageViewId()
            }
          }];
        }
      };
    }
    function getBrowserContextPlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: BROWSER_CONTEXT_SCHEMA,
            data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, getBrowserProperties()), {
              tabId: getTabId()
            })
          }];
        }
      };
    }
    /*
     * Attaches common web fields to every request (resolution, url, referrer, etc.)
     * Also sets the required cookies.
     */
    function getBrowserDataPlugin() {
      var anonymizeOr = function anonymizeOr(value) {
        return configAnonymousTracking ? null : value;
      };
      var anonymizeSessionOr = function anonymizeSessionOr(value) {
        return configAnonymousSessionTracking ? value : anonymizeOr(value);
      };
      return {
        beforeTrack: function beforeTrack(payloadBuilder) {
          var existingSession = getSnowplowCookieValue('ses'),
            idCookie = loadDomainUserIdCookie();
          var isFirstEventInSession = eventIndexFromIdCookie(idCookie) === 0;
          if (configOptOutCookie) {
            toOptoutByCookie = !!cookieStorage.getCookie(configOptOutCookie);
          } else {
            toOptoutByCookie = false;
          }
          if (configDoNotTrack || toOptoutByCookie) {
            clearUserDataAndCookies();
            return;
          }
          // If cookies are enabled, base visit count and session ID on the cookies
          if (cookiesEnabledInIdCookie(idCookie)) {
            // New session?
            if (!existingSession && configStateStorageStrategy != 'none') {
              memorizedSessionId = startNewIdCookieSession(idCookie);
            } else {
              memorizedSessionId = sessionIdFromIdCookie(idCookie);
            }
            memorizedVisitCount = visitCountFromIdCookie(idCookie);
          } else if (new Date().getTime() - lastEventTime > configSessionCookieTimeout * 1000) {
            memorizedVisitCount++;
            memorizedSessionId = startNewIdCookieSession(idCookie, {
              memorizedVisitCount: memorizedVisitCount
            });
          }
          // Update cookie
          updateNowTsInIdCookie(idCookie);
          updateFirstEventInIdCookie(idCookie, payloadBuilder);
          incrementEventIndexInIdCookie(idCookie);
          var _a = getBrowserProperties(),
            viewport = _a.viewport,
            documentSize = _a.documentSize;
          payloadBuilder.add('vp', viewport);
          payloadBuilder.add('ds', documentSize);
          payloadBuilder.add('vid', anonymizeSessionOr(memorizedVisitCount));
          payloadBuilder.add('sid', anonymizeSessionOr(memorizedSessionId));
          payloadBuilder.add('duid', anonymizeOr(domainUserIdFromIdCookie(idCookie))); // Always load from cookie as this is better etiquette than in-memory values
          payloadBuilder.add('uid', anonymizeOr(businessUserId));
          refreshUrl();
          payloadBuilder.add('refr', purify(customReferrer || configReferrerUrl));
          // Add the page URL last as it may take us over the IE limit (and we don't always need it)
          payloadBuilder.add('url', purify(configCustomUrl || locationHrefAlias));
          var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
          if (configSessionContext && (!configAnonymousTracking || configAnonymousSessionTracking)) {
            addSessionContextToPayload(payloadBuilder, clientSession);
          }
          // Update cookies
          if (configStateStorageStrategy != 'none') {
            setDomainUserIdCookie(idCookie);
            var sessionIdentifierPersisted = setSessionCookie();
            if ((!existingSession || isFirstEventInSession) && sessionIdentifierPersisted && onSessionUpdateCallback && !manualSessionUpdateCalled) {
              // Synchronously update the cookies to persist the new session ASAP
              cookieStorage.flush();
              onSessionUpdateCallback(clientSession);
              manualSessionUpdateCalled = false;
            }
          }
          lastEventTime = new Date().getTime();
        }
      };
    }
    function addSessionContextToPayload(payloadBuilder, clientSession) {
      var sessionContext = {
        schema: CLIENT_SESSION_SCHEMA,
        data: clientSession
      };
      payloadBuilder.addContextEntity(sessionContext);
    }
    /**
     * Expires current session and starts a new session.
     */
    function newSession() {
      // If cookies are enabled, base visit count and session ID on the cookies
      var idCookie = loadDomainUserIdCookie();
      // When cookies are enabled
      if (cookiesEnabledInIdCookie(idCookie)) {
        // When cookie/local storage is enabled - make a new session
        if (configStateStorageStrategy != 'none') {
          memorizedSessionId = startNewIdCookieSession(idCookie);
        } else {
          memorizedSessionId = sessionIdFromIdCookie(idCookie);
        }
        memorizedVisitCount = visitCountFromIdCookie(idCookie);
      } else {
        memorizedVisitCount++;
        memorizedSessionId = startNewIdCookieSession(idCookie, {
          memorizedVisitCount: memorizedVisitCount
        });
      }
      updateNowTsInIdCookie(idCookie);
      // Update cookies
      if (configStateStorageStrategy != 'none') {
        var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
        setDomainUserIdCookie(idCookie);
        var sessionIdentifierPersisted = setSessionCookie();
        // Synchronously update the cookies to persist the new session ASAP
        cookieStorage.flush();
        if (sessionIdentifierPersisted && onSessionUpdateCallback) {
          manualSessionUpdateCalled = true;
          onSessionUpdateCallback(clientSession);
        }
      }
      lastEventTime = new Date().getTime();
    }
    /**
     * Combine an array of unchanging contexts with the result of a context-creating function
     *
     * @param staticContexts - Array of custom contexts
     * @param contextCallback - Function returning an array of contexts
     */
    function finalizeContexts(staticContexts, contextCallback) {
      return (staticContexts || []).concat(contextCallback ? contextCallback() : []);
    }
    function logPageView(_a) {
      var title = _a.title,
        context = _a.context,
        timestamp = _a.timestamp,
        contextCallback = _a.contextCallback;
      refreshUrl();
      if (lastSentPageViewId && lastSentPageViewId == getPageViewId()) {
        // Do not reset pageViewId if a page view was not tracked yet or a different page view ID was used (in order to support multiple trackers with shared state)
        resetPageView();
      }
      lastSentPageViewId = getPageViewId();
      // So we know what document.title was at the time of trackPageView
      lastDocumentTitle = document.title;
      if (title) {
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = true;
      } else if (lastConfigTitleFromTrackPageView) {
        lastConfigTitle = null;
      }
      // Fixup page title
      var pageTitle = fixupTitle(lastConfigTitle || lastDocumentTitle);
      // Log page view
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* buildPageView */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: pageTitle,
        referrer: purify(customReferrer || configReferrerUrl)
      }), finalizeContexts(context, contextCallback), timestamp);
      // Send ping (to log that user has stayed on page)
      var now = new Date();
      var installingActivityTracking = false;
      if (activityTrackingConfig.enabled && !activityTrackingConfig.installed) {
        activityTrackingConfig.installed = true;
        installingActivityTracking = true;
        // Add mousewheel event handler, detect passive event listeners for performance
        var detectPassiveEvents_1 = {
          update: function update() {
            if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
              var passive_1 = false;
              var options = Object.defineProperty({}, 'passive', {
                get: function get() {
                  passive_1 = true;
                },
                set: function set() {}
              });
              // note: have to set and remove a no-op listener instead of null
              // (which was used previously), because Edge v15 throws an error
              // when providing a null callback.
              // https://github.com/rafrex/detect-passive-events/pull/3
              var noop = function noop() {};
              window.addEventListener('testPassiveEventSupport', noop, options);
              window.removeEventListener('testPassiveEventSupport', noop, options);
              detectPassiveEvents_1.hasSupport = passive_1;
            }
          }
        };
        detectPassiveEvents_1.update();
        // Detect available wheel event
        var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' // Modern browsers support "wheel"
        : document.onmousewheel !== undefined ? 'mousewheel' // Webkit and IE support at least "mousewheel"
        : 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
        if (Object.prototype.hasOwnProperty.call(detectPassiveEvents_1, 'hasSupport')) {
          addEventListener(document, wheelEvent, activityHandler, {
            passive: true
          });
        } else {
          addEventListener(document, wheelEvent, activityHandler);
        }
        // Capture our initial scroll points
        resetMaxScrolls();
        // Add event handlers; cross-browser compatibility here varies significantly
        // @see http://quirksmode.org/dom/events
        var documentHandlers = ['click', 'mouseup', 'mousedown', 'mousemove', 'keypress', 'keydown', 'keyup', 'touchend', 'touchstart'];
        var windowHandlers = ['resize', 'focus', 'blur'];
        var listener = function listener(_, handler) {
          if (handler === void 0) {
            handler = activityHandler;
          }
          return function (ev) {
            return addEventListener(document, ev, handler);
          };
        };
        documentHandlers.forEach(listener(document));
        windowHandlers.forEach(listener(window));
        listener(window, scrollHandler)('scroll');
      }
      if (activityTrackingConfig.enabled && (resetActivityTrackingOnPageView || installingActivityTracking)) {
        // Periodic check for activity.
        lastActivityTime = now.getTime();
        var key = void 0;
        for (key in activityTrackingConfig.configurations) {
          var config = activityTrackingConfig.configurations[key];
          if (config) {
            //Clear page ping heartbeat on new page view
            window.clearInterval(config.activityInterval);
            scheduleActivityInterval(config, context, contextCallback);
          }
        }
      }
    }
    function scheduleActivityInterval(config, context, contextCallback) {
      var executePagePing = function executePagePing(cb, context) {
        refreshUrl();
        cb({
          context: context,
          pageViewId: getPageViewId(),
          minXOffset: minXOffset,
          minYOffset: minYOffset,
          maxXOffset: maxXOffset,
          maxYOffset: maxYOffset
        });
        resetMaxScrolls();
      };
      var timeout = function timeout() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configMinimumVisitLength > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      };
      var heartbeat = function heartbeat() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configHeartBeatTimer > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
      };
      if (config.configMinimumVisitLength === 0) {
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      } else {
        config.activityInterval = window.setTimeout(timeout, config.configMinimumVisitLength);
      }
    }
    /**
     * Configure the activity tracking and ensures integer values for min visit and heartbeat
     */
    function configureActivityTracking(configuration) {
      var minimumVisitLength = configuration.minimumVisitLength,
        heartbeatDelay = configuration.heartbeatDelay,
        callback = configuration.callback;
      if (isInteger(minimumVisitLength) && isInteger(heartbeatDelay)) {
        return {
          configMinimumVisitLength: minimumVisitLength * 1000,
          configHeartBeatTimer: heartbeatDelay * 1000,
          callback: callback
        };
      }
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].error('Activity tracking minimumVisitLength & heartbeatDelay must be integers');
      return undefined;
    }
    /**
     * Log that a user is still viewing a given page by sending a page ping.
     * Not part of the public API - only called from logPageView() above.
     */
    function logPagePing(_a) {
      var context = _a.context,
        minXOffset = _a.minXOffset,
        minYOffset = _a.minYOffset,
        maxXOffset = _a.maxXOffset,
        maxYOffset = _a.maxYOffset;
      var newDocumentTitle = document.title;
      if (newDocumentTitle !== lastDocumentTitle) {
        lastDocumentTitle = newDocumentTitle;
        lastConfigTitle = undefined;
      }
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["f" /* buildPagePing */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: fixupTitle(lastConfigTitle || lastDocumentTitle),
        referrer: purify(customReferrer || configReferrerUrl),
        minXOffset: cleanOffset(minXOffset),
        maxXOffset: cleanOffset(maxXOffset),
        minYOffset: cleanOffset(minYOffset),
        maxYOffset: cleanOffset(maxYOffset)
      }), context);
    }
    function disableActivityTrackingAction(actionKey) {
      var callbackConfiguration = activityTrackingConfig.configurations[actionKey];
      if ((callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.configMinimumVisitLength) === 0) {
        window.clearTimeout(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      } else {
        window.clearInterval(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      }
      activityTrackingConfig.configurations[actionKey] = undefined;
    }
    var apiMethods = {
      getDomainSessionIndex: function getDomainSessionIndex() {
        return memorizedVisitCount;
      },
      getPageViewId: getPageViewId,
      getTabId: getTabId,
      newSession: newSession,
      getCookieName: function getCookieName(basename) {
        return getSnowplowCookieName(basename);
      },
      getUserId: function getUserId() {
        return businessUserId;
      },
      getDomainUserId: function getDomainUserId() {
        return loadDomainUserIdCookie()[1];
      },
      getDomainUserInfo: function getDomainUserInfo() {
        return loadDomainUserIdCookie();
      },
      setReferrerUrl: function setReferrerUrl(url) {
        customReferrer = url;
      },
      setCustomUrl: function setCustomUrl(url) {
        refreshUrl();
        configCustomUrl = resolveRelativeReference(locationHrefAlias, url);
      },
      setDocumentTitle: function setDocumentTitle(title) {
        // So we know what document.title was at the time of trackPageView
        lastDocumentTitle = document.title;
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = false;
      },
      discardHashTag: function discardHashTag(enableFilter) {
        configDiscardHashTag = enableFilter;
      },
      discardBrace: function discardBrace(enableFilter) {
        configDiscardBrace = enableFilter;
      },
      setCookiePath: function setCookiePath(path) {
        configCookiePath = path;
        updateDomainHash();
      },
      setVisitorCookieTimeout: function setVisitorCookieTimeout(timeout) {
        configVisitorCookieTimeout = timeout;
      },
      crossDomainLinker: function crossDomainLinker(crossDomainLinkerCriterion) {
        decorateLinks(crossDomainLinkerCriterion);
      },
      enableActivityTracking: function enableActivityTracking(configuration) {
        if (!activityTrackingConfig.configurations.pagePing) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.pagePing = configureActivityTracking(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, configuration), {
            callback: logPagePing
          }));
        }
      },
      enableActivityTrackingCallback: function enableActivityTrackingCallback(configuration) {
        if (!activityTrackingConfig.configurations.callback) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.callback = configureActivityTracking(configuration);
        }
      },
      disableActivityTracking: function disableActivityTracking() {
        disableActivityTrackingAction('pagePing');
      },
      disableActivityTrackingCallback: function disableActivityTrackingCallback() {
        disableActivityTrackingAction('callback');
      },
      updatePageActivity: function updatePageActivity() {
        activityHandler();
      },
      setOptOutCookie: function setOptOutCookie(name) {
        configOptOutCookie = name;
      },
      setUserId: function setUserId(userId) {
        businessUserId = userId;
      },
      setUserIdFromLocation: function setUserIdFromLocation(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, locationHrefAlias);
      },
      setUserIdFromReferrer: function setUserIdFromReferrer(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, configReferrerUrl);
      },
      setUserIdFromCookie: function setUserIdFromCookie(cookieName) {
        businessUserId = cookieStorage.getCookie(cookieName);
      },
      setCollectorUrl: function setCollectorUrl(collectorUrl) {
        outQueue.setCollectorUrl(asCollectorUrl(collectorUrl));
      },
      setBufferSize: function setBufferSize(newBufferSize) {
        outQueue.setBufferSize(newBufferSize);
      },
      flushBuffer: function flushBuffer(configuration) {
        if (configuration === void 0) {
          configuration = {};
        }
        outQueue.executeQueue();
        if (configuration.newBufferSize) {
          outQueue.setBufferSize(configuration.newBufferSize);
        }
      },
      trackPageView: function trackPageView(event) {
        if (event === void 0) {
          event = {};
        }
        logPageView(event);
      },
      preservePageViewId: function preservePageViewId() {
        _preservePageViewId = true;
      },
      preservePageViewIdForUrl: function preservePageViewIdForUrl(preserve) {
        _preservePageViewIdForUrl = preserve;
      },
      disableAnonymousTracking: function disableAnonymousTracking(configuration) {
        trackerConfiguration.anonymousTracking = false;
        toggleAnonymousTracking(configuration);
        initializeIdsAndCookies();
        outQueue.executeQueue(); // There might be some events in the queue we've been unable to send in anonymous mode
      },
      enableAnonymousTracking: function enableAnonymousTracking(configuration) {
        var _a;
        trackerConfiguration.anonymousTracking = (_a = configuration && (configuration === null || configuration === void 0 ? void 0 : configuration.options)) !== null && _a !== void 0 ? _a : true;
        toggleAnonymousTracking(configuration);
        // Reset the page view, if not tracking the session, so can't stitch user into new events on the page view id
        if (!configAnonymousSessionTracking) {
          resetPageView();
        }
      },
      clearUserData: clearUserDataAndCookies
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, apiMethods), {
      id: trackerId,
      namespace: namespace,
      core: core,
      sharedState: state
    });
  };
  // Initialise the tracker
  var partialTracker = newTracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration),
    tracker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, partialTracker), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        tracker.core.addPlugin(configuration);
        (_b = (_a = configuration.plugin).activateBrowserPlugin) === null || _b === void 0 ? void 0 : _b.call(_a, tracker);
      }
    });
  // Initialise each plugin with the tracker
  browserPlugins.forEach(function (p) {
    var _a;
    (_a = p.activateBrowserPlugin) === null || _a === void 0 ? void 0 : _a.call(p, tracker);
  });
  return tracker;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var namedTrackers = {};
/**
 * Dispatch function to all specified trackers
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackers(trackers, fn) {
  try {
    getTrackers(trackers !== null && trackers !== void 0 ? trackers : allTrackerNames()).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Dispatch function to all specified trackers from the supplied collection
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param trackerCollection - The collection which the trackers will be selected from
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackersInCollection(trackers, trackerCollection, fn) {
  try {
    getTrackersFromCollection(trackers !== null && trackers !== void 0 ? trackers : Object.keys(trackerCollection), trackerCollection).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Checks if a tracker has been created for a particular identifier
 * @param trackerId - The unique identifier of the tracker
 */
function trackerExists(trackerId) {
  return namedTrackers.hasOwnProperty(trackerId);
}
/**
 * Creates a Tracker and adds it to the internal collection
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker, tracked with each event as `tna`
 * @param version - The current version of the tracker library
 * @param endpoint - The endpoint to send events to
 * @param sharedState - The instance of shared state to use for this tracker
 * @param configuration - The configuration to use for this tracker instance
 */
function addTracker(trackerId, namespace, version, endpoint, sharedState, configuration) {
  if (!namedTrackers.hasOwnProperty(trackerId)) {
    namedTrackers[trackerId] = Tracker(trackerId, namespace, version, endpoint, sharedState, configuration);
    return namedTrackers[trackerId];
  }
  return null;
}
/**
 * Gets a single instance of the internal tracker object
 * @param trackerId - The unique identifier of the tracker
 * @returns The tracker instance, or null if not found
 */
function getTracker(trackerId) {
  if (namedTrackers.hasOwnProperty(trackerId)) {
    return namedTrackers[trackerId];
  }
  __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].warn(trackerId + ' not configured');
  return null;
}
/**
 * Gets an array of tracker instances based on the list of identifiers
 * @param trackerIds - An array of unique identifiers of the trackers
 * @returns The tracker instances, or empty list if none found
 */
function getTrackers(trackerIds) {
  return getTrackersFromCollection(trackerIds, namedTrackers);
}
/**
 * Gets all the trackers as a object, keyed by their unique identifiers
 */
function allTrackers() {
  return namedTrackers;
}
/**
 * Returns all the unique tracker identifiers
 */
function allTrackerNames() {
  return Object.keys(namedTrackers);
}
function getTrackersFromCollection(trackerIds, trackerCollection) {
  var trackers = [];
  for (var _i = 0, trackerIds_1 = trackerIds; _i < trackerIds_1.length; _i++) {
    var id = trackerIds_1[_i];
    if (trackerCollection.hasOwnProperty(id)) {
      trackers.push(trackerCollection[id]);
    } else {
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].warn(id + ' not configured');
    }
  }
  return trackers;
}
/**
 * Write all pending cookies to the browser.
 * Useful if you track events just before the page is unloaded.
 * This call is not necessary if `synchronousCookieWrite` is set to `true`.
 */
function flushPendingCookies() {
  asyncCookieStorage.flush();
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Checks whether sessionStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasSessionStorage() {
  try {
    return !!window.sessionStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is accessible
 * sets and removes an item to handle private IOS5 browsing
 * (http://git.io/jFB2Xw)
 */
function localStorageAccessible() {
  var mod = 'modernizr';
  if (!hasLocalStorage()) {
    return false;
  }
  try {
    var ls = window.localStorage;
    ls.setItem(mod, mod);
    ls.removeItem(mod);
    return true;
  } catch (e) {
    return false;
  }
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * A set of variables which are shared among all initialised trackers
 */
var SharedState = /** @class */function () {
  function SharedState() {
    this.bufferFlushers = [];
    /* DOM Ready */
    this.hasLoaded = false;
    this.registeredOnLoadHandlers = [];
  }
  return SharedState;
}();
function createSharedState() {
  var sharedState = new SharedState(),
    documentAlias = document,
    windowAlias = window;
  /*
   * Handle page visibility event
   * Works everywhere except IE9
   */
  function visibilityChangeHandler() {
    if (documentAlias.visibilityState == 'hidden') {
      // Flush all POST queues
      sharedState.bufferFlushers.forEach(function (flusher) {
        flusher(false);
      });
    }
  }
  function flushBuffers() {
    // Flush all POST queues
    sharedState.bufferFlushers.forEach(function (flusher) {
      flusher(false);
    });
  }
  /*
   * Handler for onload event
   */
  function loadHandler() {
    var i;
    if (!sharedState.hasLoaded) {
      sharedState.hasLoaded = true;
      for (i = 0; i < sharedState.registeredOnLoadHandlers.length; i++) {
        sharedState.registeredOnLoadHandlers[i]();
      }
    }
    return true;
  }
  /*
   * Add onload or DOM ready handler
   */
  function addReadyListener() {
    if (documentAlias.addEventListener) {
      documentAlias.addEventListener('DOMContentLoaded', function ready() {
        documentAlias.removeEventListener('DOMContentLoaded', ready, false);
        loadHandler();
      });
    } else if (documentAlias.attachEvent) {
      documentAlias.attachEvent('onreadystatechange', function ready() {
        if (documentAlias.readyState === 'complete') {
          documentAlias.detachEvent('onreadystatechange', ready);
          loadHandler();
        }
      });
    }
    // fallback
    addEventListener(windowAlias, 'load', loadHandler, false);
  }
  /************************************************************
   * Constructor
   ************************************************************/
  // initialize the Snowplow singleton
  if (documentAlias.visibilityState) {
    // Flush for mobile and modern browsers
    addEventListener(documentAlias, 'visibilitychange', visibilityChangeHandler, false);
  }
  // Last attempt at flushing in beforeunload
  addEventListener(windowAlias, 'beforeunload', flushBuffers, false);
  if (document.readyState === 'loading') {
    addReadyListener();
  } else {
    loadHandler();
  }
  return sharedState;
}


/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SharedState */
/* unused harmony export addEventListener */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTracker; });
/* unused harmony export allTrackerNames */
/* unused harmony export allTrackers */
/* unused harmony export attemptDeleteLocalStorage */
/* unused harmony export attemptGetLocalStorage */
/* unused harmony export attemptGetSessionStorage */
/* unused harmony export attemptWriteLocalStorage */
/* unused harmony export attemptWriteSessionStorage */
/* unused harmony export cookie */
/* unused harmony export createCrossDomainParameterValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSharedState; });
/* unused harmony export decorateQuerystring */
/* unused harmony export deleteCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dispatchToTrackers; });
/* unused harmony export dispatchToTrackersInCollection */
/* unused harmony export findRootDomain */
/* unused harmony export fixupDomain */
/* unused harmony export fixupTitle */
/* unused harmony export fixupUrl */
/* unused harmony export flushPendingCookies */
/* unused harmony export fromQuerystring */
/* unused harmony export getCookiesWithPrefix */
/* unused harmony export getCssClasses */
/* unused harmony export getFilterByClass */
/* unused harmony export getFilterByName */
/* unused harmony export getHostName */
/* unused harmony export getReferrer */
/* unused harmony export getTimeZone */
/* unused harmony export getTracker */
/* unused harmony export getTrackers */
/* unused harmony export hasLocalStorage */
/* unused harmony export hasSessionStorage */
/* unused harmony export isFunction */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isValueInArray */
/* unused harmony export localStorageAccessible */
/* unused harmony export parseAndValidateFloat */
/* unused harmony export parseAndValidateInt */
/* unused harmony export trackerExists */
/* unused harmony export urlSafeBase64Encode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow Browser trackers v4.8.2 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */





/**
 * Pure-JS SHA-1 implementation (FIPS 180-4).
 * Replaces the `sha1` npm package to avoid pulling in a Node.js `Buffer`
 * polyfill (~28 KB) when bundled for the browser.
 */
/** Compute SHA-1 hex digest of a UTF-8 string (FIPS 180-4). */
function sha1(message) {
  // Encode UTF-8
  var bytes = [];
  for (var i = 0; i < message.length; i++) {
    var c = message.charCodeAt(i);
    if (c < 0x80) {
      bytes.push(c);
    } else if (c < 0x800) {
      bytes.push(0xc0 | c >> 6, 0x80 | c & 0x3f);
    } else if (c >= 0xd800 && c <= 0xdbff && i + 1 < message.length) {
      var next = message.charCodeAt(++i);
      c = 0x10000 + ((c & 0x3ff) << 10) + (next & 0x3ff);
      bytes.push(0xf0 | c >> 18, 0x80 | c >> 12 & 0x3f, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
    } else {
      bytes.push(0xe0 | c >> 12, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
    }
  }
  // Pre-processing: pad to 512-bit blocks
  var bitLen = bytes.length * 8;
  bytes.push(0x80);
  while (bytes.length % 64 !== 56) bytes.push(0);
  // Append length as 64-bit big-endian (high 32 bits always 0 for strings < 512 MB)
  bytes.push(0, 0, 0, 0);
  bytes.push(bitLen >>> 24 & 0xff, bitLen >>> 16 & 0xff, bitLen >>> 8 & 0xff, bitLen & 0xff);
  // Initialize hash values
  var h0 = 0x67452301;
  var h1 = 0xefcdab89;
  var h2 = 0x98badcfe;
  var h3 = 0x10325476;
  var h4 = 0xc3d2e1f0;
  // Process each 512-bit block
  var w = new Array(80);
  for (var offset = 0; offset < bytes.length; offset += 64) {
    for (var i = 0; i < 16; i++) {
      w[i] = bytes[offset + i * 4] << 24 | bytes[offset + i * 4 + 1] << 16 | bytes[offset + i * 4 + 2] << 8 | bytes[offset + i * 4 + 3];
    }
    for (var i = 16; i < 80; i++) {
      var n = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
      w[i] = n << 1 | n >>> 31;
    }
    var a = h0,
      b = h1,
      c = h2,
      d = h3,
      e = h4;
    for (var i = 0; i < 80; i++) {
      var f = void 0,
        k = void 0;
      if (i < 20) {
        f = b & c | ~b & d;
        k = 0x5a827999;
      } else if (i < 40) {
        f = b ^ c ^ d;
        k = 0x6ed9eba1;
      } else if (i < 60) {
        f = b & c | b & d | c & d;
        k = 0x8f1bbcdc;
      } else {
        f = b ^ c ^ d;
        k = 0xca62c1d6;
      }
      var temp = (a << 5 | a >>> 27) + f + e + k + w[i] | 0;
      e = d;
      d = c;
      c = b << 30 | b >>> 2;
      b = a;
      a = temp;
    }
    h0 = h0 + a | 0;
    h1 = h1 + b | 0;
    h2 = h2 + c | 0;
    h3 = h3 + d | 0;
    h4 = h4 + e | 0;
  }
  // Produce hex digest
  var hex = '';
  for (var _i = 0, _a = [h0, h1, h2, h3, h4]; _i < _a.length; _i++) {
    var h = _a[_i];
    var part = (h >>> 0).toString(16);
    hex += (part.length < 8 ? '00000000'.slice(part.length) : '') + part;
  }
  return hex;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Attempt to get a value from localStorage
 *
 * @param string - key
 * @returns string The value obtained from localStorage, or
 *                undefined if localStorage is inaccessible
 */
function attemptGetLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage,
      exp = localStorageAlias.getItem(key + '.expires');
    if (exp === null || +exp > Date.now()) {
      return localStorageAlias.getItem(key);
    } else {
      localStorageAlias.removeItem(key);
      localStorageAlias.removeItem(key + '.expires');
    }
    return undefined;
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to localStorage
 *
 * @param string - key
 * @param string - value
 * @param number - ttl Time to live in seconds, defaults to 2 years from Date.now()
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteLocalStorage(key, value, ttl) {
  if (ttl === void 0) {
    ttl = 63072000;
  }
  try {
    var localStorageAlias = window.localStorage,
      t = Date.now() + ttl * 1000;
    localStorageAlias.setItem("".concat(key, ".expires"), t.toString());
    localStorageAlias.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to delete a value from localStorage
 *
 * @param string - key
 * @returns boolean Whether the operation succeeded
 */
function attemptDeleteLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage;
    localStorageAlias.removeItem(key);
    localStorageAlias.removeItem(key + '.expires');
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to get a value from sessionStorage
 *
 * @param string - key
 * @returns string The value obtained from sessionStorage, or
 *                undefined if sessionStorage is inaccessible
 */
function attemptGetSessionStorage(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to sessionStorage
 *
 * @param string - key
 * @param string - value
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteSessionStorage(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
var DEFAULT_CROSS_DOMAIN_LINKER_PARAMS = {
  sessionId: true,
  sourceId: true,
  sourcePlatform: false,
  userId: false,
  reason: false
};
function createCrossDomainParameterValue(isExtendedFormat, attributeConfiguration, attributeValues) {
  var _a;
  var crossDomainParameterValue;
  var timestamp = new Date().getTime();
  var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, DEFAULT_CROSS_DOMAIN_LINKER_PARAMS), attributeConfiguration);
  var domainUserId = attributeValues.domainUserId,
    userId = attributeValues.userId,
    sessionId = attributeValues.sessionId,
    sourceId = attributeValues.sourceId,
    sourcePlatform = attributeValues.sourcePlatform,
    event = attributeValues.event;
  var eventTarget = event.currentTarget;
  var reason = typeof config.reason === 'function' ? config.reason(event) : (_a = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.textContent) === null || _a === void 0 ? void 0 : _a.trim();
  if (isExtendedFormat) {
    /* Index is used by Enrich, so it should not be changed. */
    crossDomainParameterValue = [domainUserId, timestamp, config.sessionId && sessionId, config.userId && urlSafeBase64Encode(userId || ''), config.sourceId && urlSafeBase64Encode(sourceId || ''), config.sourcePlatform && sourcePlatform, config.reason && urlSafeBase64Encode(reason || '')].map(function (attribute) {
      return attribute || '';
    }).join('.')
    // Remove trailing dots
    .replace(/([.]*$)/, '');
  } else {
    crossDomainParameterValue = attributeValues.domainUserId + '.' + timestamp;
  }
  return crossDomainParameterValue;
}
/**
 *
 * The url-safe variation emits - and _ instead of + and / characters. Also removes = sign padding.
 * @param {string} str The string to encode in a URL safe manner
 * @return {string}
 */
function urlSafeBase64Encode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Checks if an object is a string
 * @param str - The object to check
 */
function isString(str) {
  if (str && typeof str.valueOf() === 'string') {
    return true;
  }
  return false;
}
/**
 * Checks if an object is an integer
 * @param int - The object to check
 */
function isInteger(_int) {
  return Number.isInteger && Number.isInteger(_int) || typeof _int === 'number' && isFinite(_int) && Math.floor(_int) === _int;
}
/**
 * Checks if the input parameter is a function
 * @param func - The object to check
 */
function isFunction(func) {
  if (func && typeof func === 'function') {
    return true;
  }
  return false;
}
/**
 * Lightweight configured runtime timezone detection
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions#getting_the_users_time_zone_and_locale_preferences
 * @returns IANA timezone name of current runtime preference
 */
function getTimeZone() {
  if ((typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && typeof Intl.DateTimeFormat === 'function') {
    var systemPreferences = new Intl.DateTimeFormat().resolvedOptions();
    return systemPreferences.timeZone;
  }
}
/**
 * Cleans up the page title
 */
function fixupTitle(title) {
  if (!isString(title)) {
    title = title.text || '';
    var tmp = document.getElementsByTagName('title');
    if (tmp && tmp[0] != null) {
      title = tmp[0].text;
    }
  }
  return title;
}
/**
 * Extract hostname from URL
 */
function getHostName(url) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:(?:https?|ftp):)/*(?:[^@]+@)?([^:/#]+)'),
    matches = e.exec(url);
  return matches ? matches[1] : url;
}
/**
 * Fix-up domain
 */
function fixupDomain(domain) {
  var dl = domain.length;
  // remove trailing '.'
  if (domain.charAt(--dl) === '.') {
    domain = domain.slice(0, dl);
  }
  // remove leading '*'
  if (domain.slice(0, 2) === '*.') {
    domain = domain.slice(1);
  }
  return domain;
}
/**
 * Get page referrer. In the case of a single-page app,
 * if the URL changes without the page reloading, pass
 * in the old URL. It will be returned unless overriden
 * by a "refer(r)er" parameter in the querystring.
 *
 * @param string - oldLocation Optional.
 * @returns string The referrer
 */
function getReferrer(oldLocation) {
  var windowAlias = window,
    fromQs = fromQuerystring('referrer', windowAlias.location.href) || fromQuerystring('referer', windowAlias.location.href);
  // Short-circuit
  if (fromQs) {
    return fromQs;
  }
  // In the case of a single-page app, return the old URL
  if (oldLocation) {
    return oldLocation;
  }
  try {
    if (windowAlias.top) {
      return windowAlias.top.document.referrer;
    } else if (windowAlias.parent) {
      return windowAlias.parent.document.referrer;
    }
  } catch (_a) {}
  return document.referrer;
}
/**
 * Cross-browser helper function to add event handler
 */
function addEventListener(element, eventType, eventHandler, options) {
  if (element.addEventListener) {
    element.addEventListener(eventType, eventHandler, options);
    return true;
  }
  // IE Support
  if (element.attachEvent) {
    return element.attachEvent('on' + eventType, eventHandler);
  }
  element['on' + eventType] = eventHandler;
}
/**
 * Return value from name-value pair in querystring
 */
function fromQuerystring(field, url) {
  var match = new RegExp('^[^#]*[?&]' + field + '=([^&#]*)').exec(url);
  if (!match) {
    return null;
  }
  return decodeURIComponent(match[1].replace(/\+/g, ' '));
}
/**
 * Add a name-value pair to the querystring of a URL
 *
 * @param string - url URL to decorate
 * @param string - name Name of the querystring pair
 * @param string - value Value of the querystring pair
 */
function decorateQuerystring(url, name, value) {
  var initialQsParams = name + '=' + value;
  var hashSplit = url.split('#');
  var qsSplit = hashSplit[0].split('?');
  var beforeQuerystring = qsSplit.shift();
  // Necessary because a querystring may contain multiple question marks
  var querystring = qsSplit.join('?');
  if (!querystring) {
    querystring = initialQsParams;
  } else {
    // Whether this is the first time the link has been decorated
    var initialDecoration = true;
    var qsFields = querystring.split('&');
    for (var i = 0; i < qsFields.length; i++) {
      if (qsFields[i].substr(0, name.length + 1) === name + '=') {
        initialDecoration = false;
        qsFields[i] = initialQsParams;
        querystring = qsFields.join('&');
        break;
      }
    }
    if (initialDecoration) {
      querystring = initialQsParams + '&' + querystring;
    }
  }
  hashSplit[0] = beforeQuerystring + '?' + querystring;
  return hashSplit.join('#');
}
/**
 * Finds the root domain
 */
function findRootDomain(sameSite, secure) {
  var windowLocationHostnameAlias = window.location.hostname,
    cookiePrefix = '_sp_root_domain_test_',
    cookieName = cookiePrefix + new Date().getTime(),
    cookieValue = '_test_value_' + new Date().getTime();
  var locationParts = windowLocationHostnameAlias.split('.');
  for (var idx = locationParts.length - 2; idx >= 0; idx--) {
    var currentDomain = locationParts.slice(idx).join('.');
    cookie(cookieName, cookieValue, 0, '/', currentDomain, sameSite, secure);
    if (cookie(cookieName) === cookieValue) {
      // Clean up created cookie(s)
      deleteCookie(cookieName, '/', currentDomain, sameSite, secure);
      var cookieNames = getCookiesWithPrefix(cookiePrefix);
      for (var i = 0; i < cookieNames.length; i++) {
        deleteCookie(cookieNames[i], '/', currentDomain, sameSite, secure);
      }
      return currentDomain;
    }
  }
  // Cookies cannot be read
  return windowLocationHostnameAlias;
}
/**
 * Checks whether a value is present within an array
 *
 * @param val - The value to check for
 * @param array - The array to check within
 * @returns boolean Whether it exists
 */
function isValueInArray(val, array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === val) {
      return true;
    }
  }
  return false;
}
/**
 * Deletes an arbitrary cookie by setting the expiration date to the past
 *
 * @param cookieName - The name of the cookie to delete
 * @param domainName - The domain the cookie is in
 */
function deleteCookie(cookieName, path, domainName, sameSite, secure) {
  cookie(cookieName, '', -1, path, domainName, sameSite, secure);
}
/**
 * Fetches the name of all cookies beginning with a certain prefix
 *
 * @param cookiePrefix - The prefix to check for
 * @returns array The cookies that begin with the prefix
 */
function getCookiesWithPrefix(cookiePrefix) {
  var cookies = document.cookie.split('; ');
  var cookieNames = [];
  for (var i = 0; i < cookies.length; i++) {
    if (cookies[i].substring(0, cookiePrefix.length) === cookiePrefix) {
      cookieNames.push(cookies[i]);
    }
  }
  return cookieNames;
}
/**
 * Get and set the cookies associated with the current document in browser
 * This implementation always returns a string, returns the cookie value if only name is specified
 *
 * @param name - The cookie name (required)
 * @param value - The cookie value
 * @param ttl - The cookie Time To Live (seconds)
 * @param path - The cookies path
 * @param domain - The cookies domain
 * @param samesite - The cookies samesite attribute
 * @param secure - Boolean to specify if cookie should be secure
 * @returns string The cookies value
 */
function cookie(name, value, ttl, path, domain, samesite, secure) {
  if (arguments.length > 1) {
    return document.cookie = name + '=' + encodeURIComponent(value !== null && value !== void 0 ? value : '') + (ttl ? '; Expires=' + new Date(+new Date() + ttl * 1000).toUTCString() : '') + (path ? '; Path=' + path : '') + (domain ? '; Domain=' + domain : '') + (samesite ? '; SameSite=' + samesite : '') + (secure ? '; Secure' : '');
  }
  return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
}
/**
 * Parses an object and returns either the
 * integer or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateInt(obj) {
  var result = parseInt(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Parses an object and returns either the
 * number or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateFloat(obj) {
  var result = parseFloat(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 * @param boolean - byClass Whether to allowlist/denylist based on an element's classes (for forms)
 *                        or name attribute (for fields)
 */
function getFilterByClass(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = Object.prototype.hasOwnProperty.call(criterion, 'allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return checkClass(elt, specifiedClassesSet) === inclusive;
  });
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 */
function getFilterByName(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = criterion.hasOwnProperty('allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return elt.name in specifiedClassesSet === inclusive;
  });
}
/**
 * List the classes of a DOM element without using elt.classList (for compatibility with IE 9)
 */
function getCssClasses(elt) {
  return elt.className.match(/\S+/g) || [];
}
/**
 * Check whether an element has at least one class from a given list
 */
function checkClass(elt, classList) {
  var classes = getCssClasses(elt);
  for (var _i = 0, classes_1 = classes; _i < classes_1.length; _i++) {
    var className = classes_1[_i];
    if (classList[className]) {
      return true;
    }
  }
  return false;
}
function getFilter(criterion, fallbackFilter) {
  if (criterion.hasOwnProperty('filter') && criterion.filter) {
    return criterion.filter;
  }
  return fallbackFilter;
}
function getSpecifiedClassesSet(criterion) {
  // Convert the array of classes to an object of the form {class1: true, class2: true, ...}
  var specifiedClassesSet = {};
  var specifiedClasses = criterion.allowlist || criterion.denylist;
  if (specifiedClasses) {
    if (!Array.isArray(specifiedClasses)) {
      specifiedClasses = [specifiedClasses];
    }
    for (var i = 0; i < specifiedClasses.length; i++) {
      specifiedClassesSet[specifiedClasses[i]] = true;
    }
  }
  return specifiedClassesSet;
}
function newLocalStorageEventStore(_a) {
  var trackerId = _a.trackerId,
    _b = _a.maxLocalStorageQueueSize,
    maxLocalStorageQueueSize = _b === void 0 ? 1000 : _b,
    _c = _a.useLocalStorage,
    useLocalStorage = _c === void 0 ? true : _c;
  var queueName = "snowplowOutQueue_".concat(trackerId);
  function newInMemoryEventStoreFromLocalStorage() {
    if (useLocalStorage) {
      try {
        var localStorageQueue = window.localStorage.getItem(queueName);
        var events = localStorageQueue ? JSON.parse(localStorageQueue) : [];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* newInMemoryEventStore */])({
          maxSize: maxLocalStorageQueueSize,
          events: events
        });
      } catch (e) {
        console.error('Failed to access localStorage when initializing event store:', e);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* newInMemoryEventStore */])({
          maxSize: maxLocalStorageQueueSize
        });
      }
    } else {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* newInMemoryEventStore */])({
        maxSize: maxLocalStorageQueueSize
      });
    }
  }
  var _d = newInMemoryEventStoreFromLocalStorage(),
    getAll = _d.getAll,
    getAllPayloads = _d.getAllPayloads,
    _add = _d.add,
    count = _d.count,
    iterator = _d.iterator,
    _removeHead = _d.removeHead;
  function sync() {
    if (useLocalStorage) {
      return getAll().then(function (events) {
        try {
          window.localStorage.setItem(queueName, JSON.stringify(events));
        } catch (e) {
          console.error('Failed to persist events to localStorage:', e);
        }
      });
    } else {
      return Promise.resolve();
    }
  }
  return {
    count: count,
    add: function add(payload) {
      _add(payload);
      return sync().then(count);
    },
    removeHead: function removeHead(count) {
      _removeHead(count);
      return sync();
    },
    iterator: iterator,
    getAll: getAll,
    getAllPayloads: getAllPayloads,
    setUseLocalStorage: function setUseLocalStorage(use) {
      useLocalStorage = use;
    }
  };
}
function newOutQueue(configuration, sharedState) {
  var _a;
  var eventStore = (_a = configuration.eventStore) !== null && _a !== void 0 ? _a : newLocalStorageEventStore(configuration);
  configuration.eventStore = eventStore;
  var emitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* newEmitter */])(configuration);
  sharedState.bufferFlushers.push(emitter.flush);
  return {
    enqueueRequest: emitter.input,
    executeQueue: emitter.flush,
    setAnonymousTracking: emitter.setAnonymousTracking,
    setCollectorUrl: emitter.setCollectorUrl,
    setBufferSize: emitter.setBufferSize,
    setUseLocalStorage: function setUseLocalStorage(localStorage) {
      if (eventStore.hasOwnProperty('setUseLocalStorage')) {
        var localStorageStore = eventStore;
        localStorageStore.setUseLocalStorage(localStorage);
      }
    }
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Extract parameter from URL
 */
function getParameter(url, name) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:https?|ftp)(?::/*(?:[^?]+))([?][^#]+)'),
    matches = e.exec(url);
  if (matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 1) {
    return fromQuerystring(name, matches[1]);
  }
  return null;
}
/*
 * Fix-up URL when page rendered from search engine cache or translated page.
 */
function fixupUrl(hostName, href, referrer) {
  var _a;
  if (hostName === 'translate.googleusercontent.com') {
    // Google
    if (referrer === '') {
      referrer = href;
    }
    href = (_a = getParameter(href, 'u')) !== null && _a !== void 0 ? _a : '';
    hostName = getHostName(href);
  } else if (hostName === 'cc.bingj.com' ||
  // Bing & Yahoo
  hostName === 'webcache.googleusercontent.com' // Google
  ) {
    href = document.links[0].href;
    hostName = getHostName(href);
  }
  return [hostName, href, referrer];
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Indices of cookie values
 */
var cookieDisabledIndex = 0,
  domainUserIdIndex = 1,
  createTsIndex = 2,
  visitCountIndex = 3,
  nowTsIndex = 4,
  lastVisitTsIndex = 5,
  sessionIdIndex = 6,
  previousSessionIdIndex = 7,
  firstEventIdIndex = 8,
  firstEventTsInMsIndex = 9,
  eventIndexIndex = 10;
function emptyIdCookie() {
  var idCookie = ['1', '', 0, 0, 0, undefined, '', '', '', undefined, 0];
  return idCookie;
}
/**
 * Parses the cookie values from its string representation.
 *
 * @param id Cookie value as string
 * @param domainUserId Domain user ID to be used in case of empty cookie string
 * @returns Parsed ID cookie tuple
 */
function parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount) {
  var now = new Date(),
    nowTs = Math.round(now.getTime() / 1000),
    tmpContainer;
  if (id) {
    tmpContainer = id.split('.');
    // cookies enabled
    tmpContainer.unshift('0');
  } else {
    tmpContainer = [
    // cookies disabled
    '1',
    // Domain user ID
    domainUserId,
    // Creation timestamp - seconds since Unix epoch
    nowTs,
    // visitCount - 0 = no previous visit
    memorizedVisitCount,
    // Current visit timestamp
    nowTs,
    // Last visit timestamp - blank meaning no previous visit
    '',
    // Session ID
    memorizedSessionId];
  }
  if (!tmpContainer[sessionIdIndex] || tmpContainer[sessionIdIndex] === 'undefined') {
    // session id
    tmpContainer[sessionIdIndex] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
  }
  if (!tmpContainer[previousSessionIdIndex] || tmpContainer[previousSessionIdIndex] === 'undefined') {
    // previous session id
    tmpContainer[previousSessionIdIndex] = '';
  }
  if (!tmpContainer[firstEventIdIndex] || tmpContainer[firstEventIdIndex] === 'undefined') {
    // firstEventId - blank meaning no previous event
    tmpContainer[firstEventIdIndex] = '';
  }
  if (!tmpContainer[firstEventTsInMsIndex] || tmpContainer[firstEventTsInMsIndex] === 'undefined') {
    // firstEventTs - blank meaning no previous event
    tmpContainer[firstEventTsInMsIndex] = '';
  }
  if (!tmpContainer[eventIndexIndex] || tmpContainer[eventIndexIndex] === 'undefined') {
    // eventIndex – 0 = no previous event
    tmpContainer[eventIndexIndex] = 0;
  }
  var parseIntOr = function parseIntOr(value, defaultValue) {
    var parsed = parseInt(value);
    return isNaN(parsed) ? defaultValue : parsed;
  };
  var parseIntOrUndefined = function parseIntOrUndefined(value) {
    return value ? parseIntOr(value, undefined) : undefined;
  };
  var parsed = [tmpContainer[cookieDisabledIndex], tmpContainer[domainUserIdIndex], parseIntOr(tmpContainer[createTsIndex], nowTs), parseIntOr(tmpContainer[visitCountIndex], memorizedVisitCount), parseIntOr(tmpContainer[nowTsIndex], nowTs), parseIntOrUndefined(tmpContainer[lastVisitTsIndex]), tmpContainer[sessionIdIndex], tmpContainer[previousSessionIdIndex], tmpContainer[firstEventIdIndex], parseIntOrUndefined(tmpContainer[firstEventTsInMsIndex]), parseIntOr(tmpContainer[eventIndexIndex], 0)];
  return parsed;
}
/**
 * Initializes the domain user ID if not already present in the cookie. Sets an empty string if anonymous tracking.
 *
 * @param idCookie Parsed cookie
 * @param configAnonymousTracking Whether anonymous tracking is enabled
 * @returns Domain user ID
 */
function initializeDomainUserId(idCookie, configAnonymousTracking) {
  var domainUserId;
  if (idCookie[domainUserIdIndex]) {
    domainUserId = idCookie[domainUserIdIndex];
  } else if (!configAnonymousTracking) {
    domainUserId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
    idCookie[domainUserIdIndex] = domainUserId;
  } else {
    domainUserId = '';
    idCookie[domainUserIdIndex] = domainUserId;
  }
  return domainUserId;
}
/**
 * Starts a new session with a new ID.
 * Sets the previous session, last visit timestamp, and increments visit count if cookies enabled.
 * First event references are reset and will be updated in `updateFirstEventInIdCookie`.
 *
 * @param idCookie Parsed cookie
 * @param options.configStateStorageStrategy Cookie storage strategy
 * @param options.configAnonymousTracking If anonymous tracking is enabled
 * @param options.memorizedVisitCount Visit count to be used if cookies not enabled
 * @param options.onSessionUpdateCallback Session callback triggered on every session update
 * @returns New session ID
 */
function startNewIdCookieSession(idCookie, options) {
  if (options === void 0) {
    options = {
      memorizedVisitCount: 1
    };
  }
  var memorizedVisitCount = options.memorizedVisitCount;
  // If cookies are enabled, base visit count and session ID on the cookies
  if (cookiesEnabledInIdCookie(idCookie)) {
    // Store the previous session ID
    idCookie[previousSessionIdIndex] = idCookie[sessionIdIndex];
    // Set lastVisitTs to currentVisitTs
    idCookie[lastVisitTsIndex] = idCookie[nowTsIndex];
    // Increment the session ID
    idCookie[visitCountIndex]++;
  } else {
    idCookie[visitCountIndex] = memorizedVisitCount;
  }
  // Create a new sessionId
  var sessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
  idCookie[sessionIdIndex] = sessionId;
  // Reset event index and first event references
  idCookie[eventIndexIndex] = 0;
  idCookie[firstEventIdIndex] = '';
  idCookie[firstEventTsInMsIndex] = undefined;
  return sessionId;
}
/**
 * Update now timestamp in cookie.
 *
 * @param idCookie Parsed cookie
 */
function updateNowTsInIdCookie(idCookie) {
  idCookie[nowTsIndex] = Math.round(new Date().getTime() / 1000);
}
/**
 * Updates the first event references according to the event payload if first event in session.
 *
 * @param idCookie - Parsed cookie
 * @param payloadBuilder - Event payload builder
 */
function updateFirstEventInIdCookie(idCookie, payloadBuilder) {
  // Update first event references if new session or not present
  if (idCookie[eventIndexIndex] === 0) {
    var payload = payloadBuilder.build();
    idCookie[firstEventIdIndex] = payload['eid'];
    var ts = payload['dtm'] || payload['ttm'];
    idCookie[firstEventTsInMsIndex] = ts ? parseInt(ts) : undefined;
  }
}
/**
 * Increments event index counter.
 *
 * @param idCookie Parsed cookie
 */
function incrementEventIndexInIdCookie(idCookie) {
  idCookie[eventIndexIndex] += 1;
}
/**
 * Serializes parsed cookie to string representation.
 *
 * @param idCookie Parsed cookie
 * @returns String cookie value
 */
function serializeIdCookie(idCookie, configAnonymousTracking) {
  var anonymizedIdCookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __spreadArray */])([], idCookie, true);
  if (configAnonymousTracking) {
    anonymizedIdCookie[domainUserIdIndex] = '';
    anonymizedIdCookie[previousSessionIdIndex] = '';
  }
  anonymizedIdCookie.shift();
  return anonymizedIdCookie.join('.');
}
/**
 * Transforms the parsed cookie into a client session context entity.
 *
 * @param idCookie Parsed cookie
 * @param configStateStorageStrategy Cookie storage strategy
 * @param configAnonymousTracking If anonymous tracking is enabled
 * @returns Client session context entity
 */
function clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking) {
  var firstEventTsInMs = idCookie[firstEventTsInMsIndex];
  var clientSession = {
    userId: configAnonymousTracking ? '00000000-0000-0000-0000-000000000000' // TODO: use uuid.NIL when we upgrade to uuid v8.3
    : idCookie[domainUserIdIndex],
    sessionId: idCookie[sessionIdIndex],
    eventIndex: idCookie[eventIndexIndex],
    sessionIndex: idCookie[visitCountIndex],
    previousSessionId: configAnonymousTracking ? null : idCookie[previousSessionIdIndex] || null,
    storageMechanism: configStateStorageStrategy == 'localStorage' ? 'LOCAL_STORAGE' : 'COOKIE_1',
    firstEventId: idCookie[firstEventIdIndex] || null,
    firstEventTimestamp: firstEventTsInMs ? new Date(firstEventTsInMs).toISOString() : null
  };
  return clientSession;
}
function sessionIdFromIdCookie(idCookie) {
  return idCookie[sessionIdIndex];
}
function domainUserIdFromIdCookie(idCookie) {
  return idCookie[domainUserIdIndex];
}
function visitCountFromIdCookie(idCookie) {
  return idCookie[visitCountIndex];
}
function cookiesEnabledInIdCookie(idCookie) {
  return idCookie[cookieDisabledIndex] === '0';
}
function eventIndexFromIdCookie(idCookie) {
  return idCookie[eventIndexIndex];
}
var WEB_PAGE_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/web_page/jsonschema/1-0-0';
var BROWSER_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/browser_context/jsonschema/2-0-0';
var CLIENT_SESSION_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/client_session/jsonschema/1-0-2';
var APPLICATION_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/application/jsonschema/1-0-0';
var ACTIVITY_METRICS_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/activity_metrics/jsonschema/1-0-0';
function useResizeObserver() {
  return 'ResizeObserver' in window;
}
var resizeObserverInitialized = false;
var readBrowserPropertiesTask = null;
function initializeResizeObserver() {
  if (resizeObserverInitialized) {
    return;
  }
  if (!document || !document.body || !document.documentElement) {
    return;
  }
  resizeObserverInitialized = true;
  var resizeObserver = new ResizeObserver(function () {
    if (!readBrowserPropertiesTask) {
      // The browser property lookup causes a forced synchronous layout when offsets/sizes are
      // queried. It's possible that the forced synchronous layout causes the ResizeObserver
      // to be fired again, leading to an infinite loop and the "ResizeObserver loop completed
      // with undelivered notifications" error.
      readBrowserPropertiesTask = requestAnimationFrame(function () {
        readBrowserPropertiesTask = null;
        cachedProperties = readBrowserProperties();
      });
    }
  });
  resizeObserver.observe(document.body);
  resizeObserver.observe(document.documentElement);
}
var cachedProperties;
/**
 * Gets various browser properties (that are expensive to read!)
 * - Will use a "ResizeObserver" approach in modern browsers to update cached properties only on change
 * - Will fallback to a direct read approach without cache in old browsers
 *
 * @returns BrowserProperties
 */
function getBrowserProperties() {
  if (!useResizeObserver()) {
    return readBrowserProperties();
  }
  if (!cachedProperties) {
    cachedProperties = readBrowserProperties();
  }
  initializeResizeObserver();
  return cachedProperties;
}
/**
 * Reads the browser properties - expensive call!
 *
 * @returns BrowserProperties
 */
function readBrowserProperties() {
  return {
    viewport: detectViewport(),
    documentSize: detectDocumentSize(),
    resolution: detectScreenResolution(),
    colorDepth: screen.colorDepth,
    devicePixelRatio: window.devicePixelRatio,
    cookiesEnabled: window.navigator.cookieEnabled,
    online: window.navigator.onLine,
    browserLanguage: window.navigator.language || window.navigator.userLanguage,
    documentLanguage: document.documentElement.lang,
    webdriver: window.navigator.webdriver,
    deviceMemory: window.navigator.deviceMemory,
    hardwareConcurrency: Math.floor(window.navigator.hardwareConcurrency) || undefined
  };
}
/**
 * Gets the current viewport.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 * - http://responsejs.com/labs/dimensions/
 */
function detectViewport() {
  var width, height;
  if ('innerWidth' in window) {
    width = window['innerWidth'];
    height = window['innerHeight'];
  } else {
    var e = document.documentElement || document.body;
    width = e['clientWidth'];
    height = e['clientHeight'];
  }
  return makeDimension(Math.max(0, width), Math.max(0, height));
}
/**
 * Gets the dimensions of the current
 * document.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 */
function detectDocumentSize() {
  var de = document.documentElement,
    // Alias
    be = document.body,
    // document.body may not have rendered, so check whether be.offsetHeight is null
    bodyHeight = be ? Math.max(be.offsetHeight, be.scrollHeight) : 0;
  return makeDimension(Math.max(de.clientWidth, de.offsetWidth, de.scrollWidth), Math.max(de.clientHeight, de.offsetHeight, de.scrollHeight, bodyHeight));
}
function detectScreenResolution() {
  return makeDimension(screen.width, screen.height);
}
function makeDimension(width, height) {
  if (isNaN(width) || isNaN(height)) {
    return null;
  }
  return Math.floor(width) + 'x' + Math.floor(height);
}
function newCookie(name) {
  var flushTimer;
  var lastSetValueArgs;
  var cacheExpireAt;
  var flushed = true;
  var flushTimeout = 10; // milliseconds
  var maxCacheTtl = 0.05; // seconds
  function getValue() {
    var _a;
    // Note: we can't cache the cookie value as we don't know the expiration date
    if (lastSetValueArgs && (!cacheExpireAt || cacheExpireAt > new Date())) {
      return (_a = lastSetValueArgs[0]) !== null && _a !== void 0 ? _a : cookie(name);
    }
    return cookie(name);
  }
  function setValue(value, ttl, path, domain, samesite, secure) {
    lastSetValueArgs = [value, ttl, path, domain, samesite, secure];
    flushed = false;
    // throttle setting the cookie
    if (flushTimer === undefined) {
      flushTimer = setTimeout(function () {
        flushTimer = undefined;
        flush();
      }, flushTimeout);
    }
    cacheExpireAt = new Date(Date.now() + Math.min(maxCacheTtl, ttl !== null && ttl !== void 0 ? ttl : maxCacheTtl) * 1000);
    return true;
  }
  function deleteValue(path, domainName, sameSite, secure) {
    lastSetValueArgs = undefined;
    flushed = true;
    // cancel setting the cookie
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    deleteCookie(name, path, domainName, sameSite, secure);
  }
  function flush() {
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    if (flushed) {
      return;
    }
    flushed = true;
    if (lastSetValueArgs !== undefined) {
      var value = lastSetValueArgs[0],
        ttl = lastSetValueArgs[1],
        path = lastSetValueArgs[2],
        domain = lastSetValueArgs[3],
        samesite = lastSetValueArgs[4],
        secure = lastSetValueArgs[5];
      cookie(name, value, ttl, path, domain, samesite, secure);
    }
  }
  return {
    getValue: getValue,
    setValue: setValue,
    deleteValue: deleteValue,
    flush: flush
  };
}
/**
 * Create a new async cookie storage
 *
 * @returns A new cookie storage
 */
function newCookieStorage() {
  var cache = {};
  function getOrInitCookie(name) {
    if (!cache[name]) {
      cache[name] = newCookie(name);
    }
    return cache[name];
  }
  function getCookie(name) {
    return getOrInitCookie(name).getValue();
  }
  function setCookie(name, value, ttl, path, domain, samesite, secure) {
    return getOrInitCookie(name).setValue(value, ttl, path, domain, samesite, secure);
  }
  function deleteCookie(name, path, domainName, sameSite, secure) {
    getOrInitCookie(name).deleteValue(path, domainName, sameSite, secure);
  }
  function clearCache() {
    cache = {};
  }
  function flush() {
    for (var _i = 0, _a = Object.values(cache); _i < _a.length; _i++) {
      var cookie_1 = _a[_i];
      cookie_1.flush();
    }
  }
  return {
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
    clearCache: clearCache,
    flush: flush
  };
}
/**
 * Cookie storage instance with asynchronous cookie writes
 */
var asyncCookieStorage = newCookieStorage();
/**
 * Cookie storage instance with synchronous cookie writes
 */
var syncCookieStorage = {
  getCookie: cookie,
  setCookie: function setCookie(name, value, ttl, path, domain, samesite, secure) {
    cookie(name, value, ttl, path, domain, samesite, secure);
    return document.cookie.indexOf("".concat(name, "=")) !== -1;
  },
  deleteCookie: deleteCookie,
  flush: function flush() {}
};

/**
 * The Snowplow Tracker
 *
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker object
 * @param version - The current version of the JavaScript Tracker
 * @param endpoint - The collector endpoint to send events to, with or without protocol
 * @param sharedState - An object containing state which is shared across tracker instances
 * @param trackerConfiguration - Dictionary of configuration options
 */
function Tracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration) {
  if (trackerConfiguration === void 0) {
    trackerConfiguration = {};
  }
  var browserPlugins = [];
  var newTracker = function newTracker(trackerId, namespace, version, endpoint, state, trackerConfiguration) {
    /************************************************************
     * Private members
     ************************************************************/
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    //use POST if eventMethod isn't present on the newTrackerConfiguration
    trackerConfiguration.eventMethod = (_a = trackerConfiguration.eventMethod) !== null && _a !== void 0 ? _a : 'post';
    var getStateStorageStrategy = function getStateStorageStrategy(config) {
        var _a;
        return (_a = config.stateStorageStrategy) !== null && _a !== void 0 ? _a : 'cookieAndLocalStorage';
      },
      getAnonymousSessionTracking = function getAnonymousSessionTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withSessionTracking) === true;
      },
      getAnonymousServerTracking = function getAnonymousServerTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withServerAnonymisation) === true;
      },
      getAnonymousTracking = function getAnonymousTracking(config) {
        return !!config.anonymousTracking;
      },
      isBrowserContextAvailable = (_c = (_b = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _b === void 0 ? void 0 : _b.browser) !== null && _c !== void 0 ? _c : false,
      isWebPageContextAvailable = (_e = (_d = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _d === void 0 ? void 0 : _d.webPage) !== null && _e !== void 0 ? _e : true,
      getExtendedCrossDomainTrackingConfiguration = function getExtendedCrossDomainTrackingConfiguration(crossDomainTrackingConfig) {
        if (typeof crossDomainTrackingConfig === 'boolean') {
          return {
            useExtendedCrossDomainLinker: crossDomainTrackingConfig
          };
        }
        return {
          useExtendedCrossDomainLinker: true,
          collectCrossDomainAttributes: crossDomainTrackingConfig
        };
      };
    // Create a new cookie storage instance with synchronous cookie write if configured
    var cookieStorage = trackerConfiguration.synchronousCookieWrite ? syncCookieStorage : asyncCookieStorage;
    // Get all injected plugins
    browserPlugins.push(getBrowserDataPlugin());
    /* When including the Web Page context, we add the relevant internal plugins */
    if (isWebPageContextAvailable) {
      browserPlugins.push(getWebPagePlugin());
    }
    if (isBrowserContextAvailable) {
      browserPlugins.push(getBrowserContextPlugin());
    }
    browserPlugins.push.apply(browserPlugins, (_f = trackerConfiguration.plugins) !== null && _f !== void 0 ? _f : []);
    var
      // Tracker core
      core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["f" /* trackerCore */])({
        base64: (_g = trackerConfiguration.encodeBase64) !== null && _g !== void 0 ? _g : trackerConfiguration.eventMethod !== 'post',
        corePlugins: browserPlugins,
        callback: sendRequest
      }),
      // Aliases
      documentCharset = document.characterSet || document.charset,
      // Current URL and Referrer URL
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer()),
      domainAlias = fixupDomain(locationArray[0]),
      locationHrefAlias = locationArray[1],
      configReferrerUrl = locationArray[2],
      customReferrer,
      // Platform defaults to web for this tracker
      configPlatform = (_h = trackerConfiguration.platform) !== null && _h !== void 0 ? _h : 'web',
      // Site ID
      configTrackerSiteId = (_j = trackerConfiguration.appId) !== null && _j !== void 0 ? _j : '',
      // Application version
      configAppVersion = trackerConfiguration.appVersion,
      // Document URL
      configCustomUrl,
      // Document title
      lastDocumentTitle = document.title,
      // Custom title
      lastConfigTitle,
      // Indicates that the lastConfigTitle was set from a trackPageView call
      // Custom title configured this way has a shorter lifespan than when set using setDocumentTitle.
      // It only lasts until the next trackPageView call.
      lastConfigTitleFromTrackPageView = false,
      // Controls whether activity tracking page ping event timers are reset on page view events
      resetActivityTrackingOnPageView = (_k = trackerConfiguration.resetActivityTrackingOnPageView) !== null && _k !== void 0 ? _k : true,
      // Disallow hash tags in URL. TODO: Should this be set to true by default?
      configDiscardHashTag,
      // Disallow brace in URL.
      configDiscardBrace,
      // First-party cookie name prefix
      configCookieNamePrefix = (_l = trackerConfiguration.cookieName) !== null && _l !== void 0 ? _l : '_sp_',
      // First-party cookie domain
      // User agent defaults to origin hostname
      configCookieDomain = (_m = trackerConfiguration.cookieDomain) !== null && _m !== void 0 ? _m : undefined,
      discoverRootDomain = (_o = trackerConfiguration.discoverRootDomain) !== null && _o !== void 0 ? _o : configCookieDomain === undefined,
      // First-party cookie path
      // Default is user agent defined.
      configCookiePath = '/',
      // First-party cookie samesite attribute
      configCookieSameSite = (_p = trackerConfiguration.cookieSameSite) !== null && _p !== void 0 ? _p : 'Lax',
      // First-party cookie secure attribute
      configCookieSecure = (_q = trackerConfiguration.cookieSecure) !== null && _q !== void 0 ? _q : true,
      // Do Not Track browser feature
      dnt = window.navigator.doNotTrack || window.navigator.msDoNotTrack || window.doNotTrack,
      // Do Not Track
      configDoNotTrack = typeof trackerConfiguration.respectDoNotTrack !== 'undefined' ? trackerConfiguration.respectDoNotTrack && (dnt === 'yes' || dnt === '1') : false,
      // Opt out of cookie tracking
      configOptOutCookie,
      // Life of the visitor cookie (in seconds)
      configVisitorCookieTimeout = (_r = trackerConfiguration.cookieLifetime) !== null && _r !== void 0 ? _r : 63072000,
      // 2 years
      // Life of the session cookie (in seconds)
      configSessionCookieTimeout = (_s = trackerConfiguration.sessionCookieTimeout) !== null && _s !== void 0 ? _s : 1800,
      // 30 minutes
      // Allows tracking user session (using cookies or local storage), can only be used with anonymousTracking
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration),
      // Will send a header to server to prevent returning cookie and capturing IP
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration),
      // Sets tracker to work in anonymous mode without accessing client storage
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration),
      // Strategy defining how to store the state: cookie, localStorage, cookieAndLocalStorage or none
      configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration),
      // Last activity timestamp
      lastActivityTime,
      // The last time an event was fired on the page - used to invalidate session if cookies are disabled
      lastEventTime = new Date().getTime(),
      // How are we scrolling?
      minXOffset,
      maxXOffset,
      minYOffset,
      maxYOffset,
      // Activity metrics tracking state
      activityMetricsState = {
        metrics: {
          mouseDistance: 0,
          scrollDistance: 0,
          keyPresses: 0,
          clicks: 0,
          touches: 0
        },
        lastMouseX: undefined,
        lastMouseY: undefined,
        lastScrollX: undefined,
        lastScrollY: undefined
      },
      // Domain hash value
      domainHash,
      // Domain unique user ID
      domainUserId,
      // ID for the current session
      memorizedSessionId,
      // Index for the current session - kept in memory in case cookies are disabled
      memorizedVisitCount = 1,
      // Business-defined unique user ID
      businessUserId,
      // Manager for local storage queue
      outQueue = newOutQueue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({
        trackerId: trackerId,
        endpoint: asCollectorUrl(endpoint),
        serverAnonymization: configAnonymousServerTracking,
        useLocalStorage: configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage'
      }, trackerConfiguration), state),
      // Whether pageViewId should be regenerated after each trackPageView. Affect web_page context
      _preservePageViewId = false,
      // Whether pageViewId should be kept the same until the page URL changes. Affects web_page context
      _preservePageViewIdForUrl = (_t = trackerConfiguration.preservePageViewIdForUrl) !== null && _t !== void 0 ? _t : false,
      // The pageViewId of the last page view event or undefined if no page view tracked yet. Used to determine if pageViewId should be regenerated for a new page view.
      lastSentPageViewId = undefined,
      // Activity tracking config for callback and page ping variants
      activityTrackingConfig = {
        enabled: false,
        installed: false,
        configurations: {}
      },
      configSessionContext = (_v = (_u = trackerConfiguration.contexts) === null || _u === void 0 ? void 0 : _u.session) !== null && _v !== void 0 ? _v : false,
      toOptoutByCookie,
      onSessionUpdateCallback = trackerConfiguration.onSessionUpdateCallback,
      manualSessionUpdateCalled = false,
      _w = getExtendedCrossDomainTrackingConfiguration(trackerConfiguration.useExtendedCrossDomainLinker || false),
      useExtendedCrossDomainLinker = _w.useExtendedCrossDomainLinker,
      collectCrossDomainAttributes = _w.collectCrossDomainAttributes;
    if (discoverRootDomain && !configCookieDomain) {
      configCookieDomain = findRootDomain(configCookieSameSite, configCookieSecure);
    }
    var _x = getBrowserProperties(),
      browserLanguage = _x.browserLanguage,
      resolution = _x.resolution,
      colorDepth = _x.colorDepth,
      cookiesEnabled = _x.cookiesEnabled;
    var timeZone = getTimeZone();
    // Set up unchanging name-value pairs
    core.setTrackerVersion(version);
    core.setTrackerNamespace(namespace);
    core.setAppId(configTrackerSiteId);
    core.setPlatform(configPlatform);
    core.addPayloadPair('cookie', cookiesEnabled ? '1' : '0');
    core.addPayloadPair('cs', documentCharset);
    core.addPayloadPair('lang', browserLanguage);
    core.addPayloadPair('res', resolution);
    core.addPayloadPair('cd', colorDepth);
    if (timeZone) core.addPayloadPair('tz', timeZone);
    // Add the application version context entity
    if (configAppVersion) {
      core.addPlugin({
        plugin: {
          contexts: function contexts() {
            return [{
              schema: APPLICATION_CONTEXT_SCHEMA,
              data: {
                version: configAppVersion
              }
            }];
          }
        }
      });
    }
    /*
     * Initialize tracker
     */
    updateDomainHash();
    initializeIdsAndCookies();
    if (trackerConfiguration.crossDomainLinker) {
      decorateLinks(trackerConfiguration.crossDomainLinker);
    }
    /**
     * Recalculate the domain, URL, and referrer
     */
    function refreshUrl() {
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer());
      // If this is a single-page app and the page URL has changed, then:
      //   - if the new URL's querystring contains a "refer(r)er" parameter, use it as the referrer
      //   - otherwise use the old URL as the referer
      if (locationArray[1] !== locationHrefAlias) {
        configReferrerUrl = getReferrer(locationHrefAlias);
      }
      domainAlias = fixupDomain(locationArray[0]);
      locationHrefAlias = locationArray[1];
    }
    /**
     * Create link handler to decorate the querystring of a link (onClick/onMouseDown)
     *
     * @param event - e The event targeting the link
     */
    function addLinkDecorationHandler(extended) {
      var CROSS_DOMAIN_PARAMETER_NAME = '_sp';
      return function (evt) {
        var elt = evt.currentTarget;
        var crossDomainParameterValue = createCrossDomainParameterValue(extended, collectCrossDomainAttributes, {
          domainUserId: domainUserId,
          userId: businessUserId || undefined,
          sessionId: memorizedSessionId,
          sourceId: configTrackerSiteId,
          sourcePlatform: configPlatform,
          event: evt
        });
        if (elt === null || elt === void 0 ? void 0 : elt.href) {
          elt.href = decorateQuerystring(elt.href, CROSS_DOMAIN_PARAMETER_NAME, crossDomainParameterValue);
        }
      };
    }
    /**
     * Enable querystring decoration for links passing a filter
     * Whenever such a link is clicked on or navigated to via the keyboard,
     * add "_sp={{duid}}.{{timestamp}}" to its querystring
     *
     * @param crossDomainLinker - Function used to determine which links to decorate
     */
    function decorateLinks(crossDomainLinker) {
      var crossDomainLinkHandler = addLinkDecorationHandler(useExtendedCrossDomainLinker);
      for (var i = 0; i < document.links.length; i++) {
        var elt = document.links[i];
        if (!elt.spDecorationEnabled && crossDomainLinker(elt)) {
          elt.addEventListener('click', crossDomainLinkHandler, true);
          elt.addEventListener('mousedown', crossDomainLinkHandler, true);
          // Don't add event listeners more than once
          elt.spDecorationEnabled = true;
        }
      }
    }
    /*
     * Removes hash tag from the URL
     *
     * URLs are purified before being recorded in the cookie,
     * or before being sent as GET parameters
     */
    function purify(url) {
      var targetPattern;
      if (configDiscardHashTag) {
        targetPattern = new RegExp('#.*');
        url = url.replace(targetPattern, '');
      }
      if (configDiscardBrace) {
        targetPattern = new RegExp('[{}]', 'g');
        url = url.replace(targetPattern, '');
      }
      return url;
    }
    /*
     * Extract scheme/protocol from URL
     */
    function getProtocolScheme(url) {
      var e = new RegExp('^([a-z]+):'),
        matches = e.exec(url);
      return matches ? matches[1] : null;
    }
    /*
     * Resolve relative reference
     *
     * Note: not as described in rfc3986 section 5.2
     */
    function resolveRelativeReference(baseUrl, url) {
      var protocol = getProtocolScheme(url),
        i;
      if (protocol) {
        return url;
      }
      if (url.slice(0, 1) === '/') {
        return getProtocolScheme(baseUrl) + '://' + getHostName(baseUrl) + url;
      }
      baseUrl = purify(baseUrl);
      if ((i = baseUrl.indexOf('?')) >= 0) {
        baseUrl = baseUrl.slice(0, i);
      }
      if ((i = baseUrl.lastIndexOf('/')) !== baseUrl.length - 1) {
        baseUrl = baseUrl.slice(0, i + 1);
      }
      return baseUrl + url;
    }
    /*
     * Send request
     */
    function sendRequest(request) {
      if (!(configDoNotTrack || toOptoutByCookie)) {
        outQueue.enqueueRequest(request.build());
      }
    }
    /*
     * Get cookie name with prefix and domain hash
     */
    function getSnowplowCookieName(baseName) {
      return configCookieNamePrefix + baseName + '.' + domainHash;
    }
    /*
     * Cookie getter.
     */
    function getSnowplowCookieValue(cookieName) {
      var fullName = getSnowplowCookieName(cookieName);
      if (configStateStorageStrategy == 'localStorage') {
        return attemptGetLocalStorage(fullName);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.getCookie(fullName);
      }
      return undefined;
    }
    /*
     * Update domain hash
     */
    function updateDomainHash() {
      refreshUrl();
      domainHash = sha1((configCookieDomain || domainAlias) + (configCookiePath || '/')).slice(0, 4); // 4 hexits = 16 bits
    }
    /*
     * Process all "activity" events.
     * For performance, this function must have low overhead.
     */
    function activityHandler(event) {
      var now = new Date();
      lastActivityTime = now.getTime();
      if (isActivityMetricsEnabled() && event) {
        switch (event.type) {
          case 'mousemove':
            {
              var me = event;
              if (activityMetricsState.lastMouseX !== undefined && activityMetricsState.lastMouseY !== undefined) {
                var dx = me.clientX - activityMetricsState.lastMouseX;
                var dy = me.clientY - activityMetricsState.lastMouseY;
                activityMetricsState.metrics.mouseDistance += Math.sqrt(dx * dx + dy * dy);
              }
              activityMetricsState.lastMouseX = me.clientX;
              activityMetricsState.lastMouseY = me.clientY;
              break;
            }
          case 'click':
            activityMetricsState.metrics.clicks++;
            break;
          case 'keydown':
            activityMetricsState.metrics.keyPresses++;
            break;
          case 'touchstart':
            activityMetricsState.metrics.touches++;
            break;
          // scroll handled in scrollHandler
        }
      }
    }
    /*
     * Process all "scroll" events.
     */
    function scrollHandler() {
      activityHandler();
      var offsets = getPageOffsets();
      var x = offsets[0];
      if (x < minXOffset) {
        minXOffset = x;
      } else if (x > maxXOffset) {
        maxXOffset = x;
      }
      var y = offsets[1];
      if (y < minYOffset) {
        minYOffset = y;
      } else if (y > maxYOffset) {
        maxYOffset = y;
      }
      if (isActivityMetricsEnabled()) {
        if (activityMetricsState.lastScrollX !== undefined && activityMetricsState.lastScrollY !== undefined) {
          activityMetricsState.metrics.scrollDistance += Math.abs(x - activityMetricsState.lastScrollX) + Math.abs(y - activityMetricsState.lastScrollY);
        }
        activityMetricsState.lastScrollX = x;
        activityMetricsState.lastScrollY = y;
      }
    }
    /*
     * Returns [pageXOffset, pageYOffset]
     */
    function getPageOffsets() {
      var documentElement = document.documentElement;
      if (documentElement) {
        return [documentElement.scrollLeft || window.pageXOffset, documentElement.scrollTop || window.pageYOffset];
      }
      return [0, 0];
    }
    /*
     * Quick initialization/reset of max scroll levels
     */
    function resetMaxScrolls() {
      var offsets = getPageOffsets();
      var x = offsets[0];
      minXOffset = x;
      maxXOffset = x;
      var y = offsets[1];
      minYOffset = y;
      maxYOffset = y;
    }
    /*
     * Whether activity metrics tracking is enabled for any active configuration
     */
    function isActivityMetricsEnabled() {
      var _a, _b;
      return !!(((_a = activityTrackingConfig.configurations.pagePing) === null || _a === void 0 ? void 0 : _a.activityMetrics) || ((_b = activityTrackingConfig.configurations.callback) === null || _b === void 0 ? void 0 : _b.activityMetrics));
    }
    /*
     * Reset activity metrics accumulators and position trackers
     */
    function resetActivityMetricsState() {
      activityMetricsState.metrics = {
        mouseDistance: 0,
        scrollDistance: 0,
        keyPresses: 0,
        clicks: 0,
        touches: 0
      };
      activityMetricsState.lastMouseX = undefined;
      activityMetricsState.lastMouseY = undefined;
      activityMetricsState.lastScrollX = undefined;
      activityMetricsState.lastScrollY = undefined;
    }
    /*
     * Return a snapshot of current activity metrics
     */
    function getActivityMetrics() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, activityMetricsState.metrics), {
        mouseDistance: Math.round(activityMetricsState.metrics.mouseDistance),
        scrollDistance: Math.round(activityMetricsState.metrics.scrollDistance)
      });
    }
    /*
     * Prevents offsets from being decimal or NaN
     * See https://github.com/snowplow/snowplow-javascript-tracker/issues/324
     */
    function cleanOffset(offset) {
      return Math.round(offset);
    }
    /**
     * Sets or renews the session cookie.
     * Responsible for calling the `onSessionUpdateCallback` callback.
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setSessionCookie() {
      var cookieName = getSnowplowCookieName('ses');
      var cookieValue = '*';
      return persistValue(cookieName, cookieValue, configSessionCookieTimeout);
    }
    /**
     * @mutates idCookie
     * @param {ParsedIdCookie} idCookie
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setDomainUserIdCookie(idCookie) {
      var cookieName = getSnowplowCookieName('id');
      var cookieValue = serializeIdCookie(idCookie, configAnonymousTracking);
      return persistValue(cookieName, cookieValue, configVisitorCookieTimeout);
    }
    /**
     * no-op if anonymousTracking enabled, will still set cookies if anonymousSessionTracking is enabled
     * Sets a cookie based on the storage strategy:
     * - if 'localStorage': attempts to write to local storage
     * - if 'cookie' or 'cookieAndLocalStorage': writes to cookies
     * - otherwise: no-op
     * @param {string} name Name/key of the value to persist
     * @param {string} value
     * @param {number} timeout Used as the expiration date for cookies or as a TTL to be checked on LocalStorage
     * @returns {boolean} If the operation was successful or not
     */
    function persistValue(name, value, timeout) {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return false;
      }
      if (configStateStorageStrategy == 'localStorage') {
        return attemptWriteLocalStorage(name, value, timeout);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.setCookie(name, value, timeout, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      }
      return false;
    }
    /**
     * Clears all cookie and local storage for id and ses values
     */
    function clearUserDataAndCookies(configuration) {
      var idname = getSnowplowCookieName('id');
      var sesname = getSnowplowCookieName('ses');
      attemptDeleteLocalStorage(idname);
      attemptDeleteLocalStorage(sesname);
      cookieStorage.deleteCookie(idname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      cookieStorage.deleteCookie(sesname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveSession)) {
        memorizedSessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        memorizedVisitCount = 1;
      }
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveUser)) {
        domainUserId = configAnonymousTracking ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        businessUserId = null;
      }
    }
    /**
     * Toggle Anonymous Tracking
     */
    function toggleAnonymousTracking(configuration) {
      if (configuration && configuration.stateStorageStrategy) {
        trackerConfiguration.stateStorageStrategy = configuration.stateStorageStrategy;
        configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration);
      }
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration);
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration);
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration);
      outQueue.setUseLocalStorage(configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage');
      outQueue.setAnonymousTracking(configAnonymousServerTracking);
    }
    /*
     * Load the domain user ID and the session ID
     * Set the cookies (if cookies are enabled)
     */
    function initializeIdsAndCookies() {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return;
      }
      var sesCookieSet = configStateStorageStrategy != 'none' && !!getSnowplowCookieValue('ses');
      var idCookie = loadDomainUserIdCookie();
      domainUserId = initializeDomainUserId(idCookie, configAnonymousTracking);
      if (!sesCookieSet) {
        memorizedSessionId = startNewIdCookieSession(idCookie);
      } else {
        memorizedSessionId = sessionIdFromIdCookie(idCookie);
      }
      memorizedVisitCount = visitCountFromIdCookie(idCookie);
      if (configStateStorageStrategy != 'none') {
        setSessionCookie();
        // Update currentVisitTs
        updateNowTsInIdCookie(idCookie);
        setDomainUserIdCookie(idCookie);
        if (!eventIndexFromIdCookie(idCookie)) {
          // Synchronously update the cookies to persist the new session ASAP
          cookieStorage.flush();
        }
      }
    }
    /*
     * Load visitor ID cookie
     */
    function loadDomainUserIdCookie() {
      if (configStateStorageStrategy == 'none') {
        return emptyIdCookie();
      }
      var id = getSnowplowCookieValue('id') || undefined;
      return parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount);
    }
    /**
     * Adds the protocol in front of our collector URL
     *
     * @param string - collectorUrl The collector URL with or without protocol
     * @returns string collectorUrl The tracker URL with protocol
     */
    function asCollectorUrl(collectorUrl) {
      if (collectorUrl.indexOf('http') === 0) {
        return collectorUrl;
      }
      return ('https:' === document.location.protocol ? 'https' : 'http') + '://' + collectorUrl;
    }
    /**
     * Initialize new `pageViewId` if it shouldn't be preserved.
     * Should be called when `trackPageView` is invoked
     */
    function resetPageView() {
      if (!_preservePageViewId || state.pageViewId == null) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
    }
    /**
     * Safe function to get `pageViewId`.
     * Generates it if it wasn't initialized by other tracker
     */
    function getPageViewId() {
      if (shouldGenerateNewPageViewId()) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
      return state.pageViewId;
    }
    function shouldGenerateNewPageViewId() {
      // If pageViewId is not initialized, generate it
      if (state.pageViewId == null) {
        return true;
      }
      // If pageViewId should be preserved regardless of the URL, don't generate a new one
      if (_preservePageViewId || !_preservePageViewIdForUrl) {
        return false;
      }
      // If doesn't have previous URL in state, generate a new pageViewId
      if (state.pageViewUrl === undefined) {
        return true;
      }
      var current = configCustomUrl || locationHrefAlias;
      // If full preserve is enabled, compare the full URL
      if (_preservePageViewIdForUrl === true || _preservePageViewIdForUrl == 'full' || !('URL' in window)) {
        return state.pageViewUrl != current;
      }
      var currentUrl = new URL(current);
      var previousUrl = new URL(state.pageViewUrl);
      // If pathname preserve is enabled, compare the pathname
      if (_preservePageViewIdForUrl == 'pathname') {
        return currentUrl.pathname != previousUrl.pathname;
      }
      // If pathname and search preserve is enabled, compare the pathname and search
      if (_preservePageViewIdForUrl == 'pathnameAndSearch') {
        return currentUrl.pathname != previousUrl.pathname || currentUrl.search != previousUrl.search;
      }
      return false;
    }
    /**
     * Safe function to get `tabId`.
     * Generates it if it is not yet initialized. Shared between trackers.
     */
    function getTabId() {
      if (configStateStorageStrategy === 'none' || configAnonymousTracking || !isWebPageContextAvailable) {
        return null;
      }
      var SESSION_STORAGE_TAB_ID = '_sp_tab_id';
      var tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      if (!tabId) {
        attemptWriteSessionStorage(SESSION_STORAGE_TAB_ID, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])());
        tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      }
      return tabId || null;
    }
    /**
     * Put together a web page context with a unique UUID for the page view
     *
     * @returns web_page context
     */
    function getWebPagePlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: WEB_PAGE_SCHEMA,
            data: {
              id: getPageViewId()
            }
          }];
        }
      };
    }
    function getBrowserContextPlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: BROWSER_CONTEXT_SCHEMA,
            data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, getBrowserProperties()), {
              tabId: getTabId()
            })
          }];
        }
      };
    }
    /*
     * Attaches common web fields to every request (resolution, url, referrer, etc.)
     * Also sets the required cookies.
     */
    function getBrowserDataPlugin() {
      var anonymizeOr = function anonymizeOr(value) {
        return configAnonymousTracking ? null : value;
      };
      var anonymizeSessionOr = function anonymizeSessionOr(value) {
        return configAnonymousSessionTracking ? value : anonymizeOr(value);
      };
      return {
        beforeTrack: function beforeTrack(payloadBuilder) {
          var existingSession = getSnowplowCookieValue('ses'),
            idCookie = loadDomainUserIdCookie();
          var isFirstEventInSession = eventIndexFromIdCookie(idCookie) === 0;
          if (configOptOutCookie) {
            toOptoutByCookie = !!cookieStorage.getCookie(configOptOutCookie);
          } else {
            toOptoutByCookie = false;
          }
          if (configDoNotTrack || toOptoutByCookie) {
            clearUserDataAndCookies();
            return;
          }
          // If cookies are enabled, base visit count and session ID on the cookies
          if (cookiesEnabledInIdCookie(idCookie)) {
            // New session?
            if (!existingSession && configStateStorageStrategy != 'none') {
              memorizedSessionId = startNewIdCookieSession(idCookie);
            } else {
              memorizedSessionId = sessionIdFromIdCookie(idCookie);
            }
            memorizedVisitCount = visitCountFromIdCookie(idCookie);
          } else if (new Date().getTime() - lastEventTime > configSessionCookieTimeout * 1000) {
            memorizedVisitCount++;
            memorizedSessionId = startNewIdCookieSession(idCookie, {
              memorizedVisitCount: memorizedVisitCount
            });
          }
          // Update cookie
          updateNowTsInIdCookie(idCookie);
          updateFirstEventInIdCookie(idCookie, payloadBuilder);
          incrementEventIndexInIdCookie(idCookie);
          var _a = getBrowserProperties(),
            viewport = _a.viewport,
            documentSize = _a.documentSize;
          payloadBuilder.add('vp', viewport);
          payloadBuilder.add('ds', documentSize);
          payloadBuilder.add('vid', anonymizeSessionOr(memorizedVisitCount));
          payloadBuilder.add('sid', anonymizeSessionOr(memorizedSessionId));
          payloadBuilder.add('duid', anonymizeOr(domainUserIdFromIdCookie(idCookie))); // Always load from cookie as this is better etiquette than in-memory values
          payloadBuilder.add('uid', anonymizeOr(businessUserId));
          refreshUrl();
          payloadBuilder.add('refr', purify(customReferrer || configReferrerUrl));
          // Add the page URL last as it may take us over the IE limit (and we don't always need it)
          payloadBuilder.add('url', purify(configCustomUrl || locationHrefAlias));
          var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
          if (configSessionContext && (!configAnonymousTracking || configAnonymousSessionTracking)) {
            addSessionContextToPayload(payloadBuilder, clientSession);
          }
          // Update cookies
          if (configStateStorageStrategy != 'none') {
            setDomainUserIdCookie(idCookie);
            var sessionIdentifierPersisted = setSessionCookie();
            if ((!existingSession || isFirstEventInSession) && sessionIdentifierPersisted && onSessionUpdateCallback && !manualSessionUpdateCalled) {
              // Synchronously update the cookies to persist the new session ASAP
              cookieStorage.flush();
              onSessionUpdateCallback(clientSession);
              manualSessionUpdateCalled = false;
            }
          }
          lastEventTime = new Date().getTime();
        }
      };
    }
    function addSessionContextToPayload(payloadBuilder, clientSession) {
      var sessionContext = {
        schema: CLIENT_SESSION_SCHEMA,
        data: clientSession
      };
      payloadBuilder.addContextEntity(sessionContext);
    }
    /**
     * Expires current session and starts a new session.
     */
    function newSession() {
      // If cookies are enabled, base visit count and session ID on the cookies
      var idCookie = loadDomainUserIdCookie();
      // When cookies are enabled
      if (cookiesEnabledInIdCookie(idCookie)) {
        // When cookie/local storage is enabled - make a new session
        if (configStateStorageStrategy != 'none') {
          memorizedSessionId = startNewIdCookieSession(idCookie);
        } else {
          memorizedSessionId = sessionIdFromIdCookie(idCookie);
        }
        memorizedVisitCount = visitCountFromIdCookie(idCookie);
      } else {
        memorizedVisitCount++;
        memorizedSessionId = startNewIdCookieSession(idCookie, {
          memorizedVisitCount: memorizedVisitCount
        });
      }
      updateNowTsInIdCookie(idCookie);
      // Update cookies
      if (configStateStorageStrategy != 'none') {
        var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
        setDomainUserIdCookie(idCookie);
        var sessionIdentifierPersisted = setSessionCookie();
        // Synchronously update the cookies to persist the new session ASAP
        cookieStorage.flush();
        if (sessionIdentifierPersisted && onSessionUpdateCallback) {
          manualSessionUpdateCalled = true;
          onSessionUpdateCallback(clientSession);
        }
      }
      lastEventTime = new Date().getTime();
    }
    /**
     * Combine an array of unchanging contexts with the result of a context-creating function
     *
     * @param staticContexts - Array of custom contexts
     * @param contextCallback - Function returning an array of contexts
     */
    function finalizeContexts(staticContexts, contextCallback) {
      return (staticContexts || []).concat(contextCallback ? contextCallback() : []);
    }
    function logPageView(_a) {
      var title = _a.title,
        context = _a.context,
        timestamp = _a.timestamp,
        contextCallback = _a.contextCallback;
      refreshUrl();
      if (lastSentPageViewId && lastSentPageViewId == getPageViewId()) {
        // Do not reset pageViewId if a page view was not tracked yet or a different page view ID was used (in order to support multiple trackers with shared state)
        resetPageView();
      }
      lastSentPageViewId = getPageViewId();
      // So we know what document.title was at the time of trackPageView
      lastDocumentTitle = document.title;
      if (title) {
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = true;
      } else if (lastConfigTitleFromTrackPageView) {
        lastConfigTitle = null;
      }
      // Fixup page title
      var pageTitle = fixupTitle(lastConfigTitle || lastDocumentTitle);
      // Log page view
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["g" /* buildPageView */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: pageTitle,
        referrer: purify(customReferrer || configReferrerUrl)
      }), finalizeContexts(context, contextCallback), timestamp);
      // Send ping (to log that user has stayed on page)
      var now = new Date();
      var installingActivityTracking = false;
      if (activityTrackingConfig.enabled && !activityTrackingConfig.installed) {
        activityTrackingConfig.installed = true;
        installingActivityTracking = true;
        // Add mousewheel event handler, detect passive event listeners for performance
        var detectPassiveEvents_1 = {
          update: function update() {
            if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
              var passive_1 = false;
              var options = Object.defineProperty({}, 'passive', {
                get: function get() {
                  passive_1 = true;
                },
                set: function set() {}
              });
              // note: have to set and remove a no-op listener instead of null
              // (which was used previously), because Edge v15 throws an error
              // when providing a null callback.
              // https://github.com/rafrex/detect-passive-events/pull/3
              var noop = function noop() {};
              window.addEventListener('testPassiveEventSupport', noop, options);
              window.removeEventListener('testPassiveEventSupport', noop, options);
              detectPassiveEvents_1.hasSupport = passive_1;
            }
          }
        };
        detectPassiveEvents_1.update();
        // Detect available wheel event
        var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' // Modern browsers support "wheel"
        : document.onmousewheel !== undefined ? 'mousewheel' // Webkit and IE support at least "mousewheel"
        : 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
        if (Object.prototype.hasOwnProperty.call(detectPassiveEvents_1, 'hasSupport')) {
          addEventListener(document, wheelEvent, activityHandler, {
            passive: true
          });
        } else {
          addEventListener(document, wheelEvent, activityHandler);
        }
        // Capture our initial scroll points
        resetMaxScrolls();
        resetActivityMetricsState();
        // Add event handlers; cross-browser compatibility here varies significantly
        // @see http://quirksmode.org/dom/events
        var documentHandlers = ['click', 'mouseup', 'mousedown', 'mousemove', 'keypress', 'keydown', 'keyup', 'touchend', 'touchstart'];
        var windowHandlers = ['resize', 'focus', 'blur'];
        var listener = function listener(_, handler) {
          if (handler === void 0) {
            handler = activityHandler;
          }
          return function (ev) {
            return addEventListener(document, ev, handler);
          };
        };
        documentHandlers.forEach(listener(document));
        windowHandlers.forEach(listener(window));
        listener(window, scrollHandler)('scroll');
      }
      if (activityTrackingConfig.enabled && (resetActivityTrackingOnPageView || installingActivityTracking)) {
        // Periodic check for activity.
        lastActivityTime = now.getTime();
        resetActivityMetricsState();
        var key = void 0;
        for (key in activityTrackingConfig.configurations) {
          var config = activityTrackingConfig.configurations[key];
          if (config) {
            //Clear page ping heartbeat on new page view
            window.clearInterval(config.activityInterval);
            scheduleActivityInterval(config, context, contextCallback);
          }
        }
      }
    }
    function scheduleActivityInterval(config, context, contextCallback) {
      var executePagePing = function executePagePing(cb, context) {
        refreshUrl();
        var activityMetrics;
        if (isActivityMetricsEnabled()) {
          activityMetrics = getActivityMetrics();
          context = context.concat([{
            schema: ACTIVITY_METRICS_SCHEMA,
            data: activityMetrics
          }]);
        }
        cb({
          context: context,
          pageViewId: getPageViewId(),
          minXOffset: minXOffset,
          minYOffset: minYOffset,
          maxXOffset: maxXOffset,
          maxYOffset: maxYOffset,
          activityMetrics: activityMetrics
        });
        resetMaxScrolls();
        if (isActivityMetricsEnabled()) {
          resetActivityMetricsState();
        }
      };
      var timeout = function timeout() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configMinimumVisitLength > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      };
      var heartbeat = function heartbeat() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configHeartBeatTimer > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
      };
      if (config.configMinimumVisitLength === 0) {
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      } else {
        config.activityInterval = window.setTimeout(timeout, config.configMinimumVisitLength);
      }
    }
    /**
     * Configure the activity tracking and ensures integer values for min visit and heartbeat
     */
    function configureActivityTracking(configuration) {
      var minimumVisitLength = configuration.minimumVisitLength,
        heartbeatDelay = configuration.heartbeatDelay,
        callback = configuration.callback;
      if (isInteger(minimumVisitLength) && isInteger(heartbeatDelay)) {
        return {
          configMinimumVisitLength: minimumVisitLength * 1000,
          configHeartBeatTimer: heartbeatDelay * 1000,
          callback: callback,
          activityMetrics: configuration.activityMetrics
        };
      }
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].error('Activity tracking minimumVisitLength & heartbeatDelay must be integers');
      return undefined;
    }
    /**
     * Log that a user is still viewing a given page by sending a page ping.
     * Not part of the public API - only called from logPageView() above.
     */
    function logPagePing(_a) {
      var context = _a.context,
        minXOffset = _a.minXOffset,
        minYOffset = _a.minYOffset,
        maxXOffset = _a.maxXOffset,
        maxYOffset = _a.maxYOffset;
      var newDocumentTitle = document.title;
      if (newDocumentTitle !== lastDocumentTitle) {
        lastDocumentTitle = newDocumentTitle;
        lastConfigTitle = undefined;
      }
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["i" /* buildPagePing */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: fixupTitle(lastConfigTitle || lastDocumentTitle),
        referrer: purify(customReferrer || configReferrerUrl),
        minXOffset: cleanOffset(minXOffset),
        maxXOffset: cleanOffset(maxXOffset),
        minYOffset: cleanOffset(minYOffset),
        maxYOffset: cleanOffset(maxYOffset)
      }), context);
    }
    function disableActivityTrackingAction(actionKey) {
      var callbackConfiguration = activityTrackingConfig.configurations[actionKey];
      if ((callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.configMinimumVisitLength) === 0) {
        window.clearTimeout(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      } else {
        window.clearInterval(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      }
      activityTrackingConfig.configurations[actionKey] = undefined;
      if (!activityTrackingConfig.configurations.pagePing && !activityTrackingConfig.configurations.callback) {
        resetActivityMetricsState();
      }
    }
    var apiMethods = {
      getDomainSessionIndex: function getDomainSessionIndex() {
        return memorizedVisitCount;
      },
      getPageViewId: getPageViewId,
      getTabId: getTabId,
      newSession: newSession,
      getCookieName: function getCookieName(basename) {
        return getSnowplowCookieName(basename);
      },
      getUserId: function getUserId() {
        return businessUserId;
      },
      getDomainUserId: function getDomainUserId() {
        return loadDomainUserIdCookie()[1];
      },
      getDomainUserInfo: function getDomainUserInfo() {
        return loadDomainUserIdCookie();
      },
      setReferrerUrl: function setReferrerUrl(url) {
        customReferrer = url;
      },
      setCustomUrl: function setCustomUrl(url) {
        refreshUrl();
        configCustomUrl = resolveRelativeReference(locationHrefAlias, url);
      },
      setDocumentTitle: function setDocumentTitle(title) {
        // So we know what document.title was at the time of trackPageView
        lastDocumentTitle = document.title;
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = false;
      },
      discardHashTag: function discardHashTag(enableFilter) {
        configDiscardHashTag = enableFilter;
      },
      discardBrace: function discardBrace(enableFilter) {
        configDiscardBrace = enableFilter;
      },
      setCookiePath: function setCookiePath(path) {
        configCookiePath = path;
        updateDomainHash();
      },
      setVisitorCookieTimeout: function setVisitorCookieTimeout(timeout) {
        configVisitorCookieTimeout = timeout;
      },
      crossDomainLinker: function crossDomainLinker(crossDomainLinkerCriterion) {
        decorateLinks(crossDomainLinkerCriterion);
      },
      enableActivityTracking: function enableActivityTracking(configuration) {
        if (!activityTrackingConfig.configurations.pagePing) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.pagePing = configureActivityTracking(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, configuration), {
            callback: logPagePing
          }));
        }
      },
      enableActivityTrackingCallback: function enableActivityTrackingCallback(configuration) {
        if (!activityTrackingConfig.configurations.callback) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.callback = configureActivityTracking(configuration);
        }
      },
      disableActivityTracking: function disableActivityTracking() {
        disableActivityTrackingAction('pagePing');
      },
      disableActivityTrackingCallback: function disableActivityTrackingCallback() {
        disableActivityTrackingAction('callback');
      },
      updatePageActivity: function updatePageActivity() {
        activityHandler();
      },
      setOptOutCookie: function setOptOutCookie(name) {
        configOptOutCookie = name;
      },
      setUserId: function setUserId(userId) {
        businessUserId = userId;
      },
      setUserIdFromLocation: function setUserIdFromLocation(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, locationHrefAlias);
      },
      setUserIdFromReferrer: function setUserIdFromReferrer(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, configReferrerUrl);
      },
      setUserIdFromCookie: function setUserIdFromCookie(cookieName) {
        businessUserId = cookieStorage.getCookie(cookieName);
      },
      setCollectorUrl: function setCollectorUrl(collectorUrl) {
        outQueue.setCollectorUrl(asCollectorUrl(collectorUrl));
      },
      setBufferSize: function setBufferSize(newBufferSize) {
        outQueue.setBufferSize(newBufferSize);
      },
      flushBuffer: function flushBuffer(configuration) {
        if (configuration === void 0) {
          configuration = {};
        }
        outQueue.executeQueue();
        if (configuration.newBufferSize) {
          outQueue.setBufferSize(configuration.newBufferSize);
        }
      },
      trackPageView: function trackPageView(event) {
        if (event === void 0) {
          event = {};
        }
        logPageView(event);
      },
      preservePageViewId: function preservePageViewId() {
        _preservePageViewId = true;
      },
      preservePageViewIdForUrl: function preservePageViewIdForUrl(preserve) {
        _preservePageViewIdForUrl = preserve;
      },
      disableAnonymousTracking: function disableAnonymousTracking(configuration) {
        /*
          Flag for if the state storage strategy has changed and we are currently storing session state (anonymously or not).
          Because the strategy changes, the below call to initializeIdsAndCookies will fail to see that a session is currently in progress and start a new one.
          Detect this state, and once we've updated settings, bump the session cookie with the new strategy to ensure it exists before loading the ID cookie, which will resume the session.
        */
        var shouldResumeSession = (configuration === null || configuration === void 0 ? void 0 : configuration.stateStorageStrategy) &&
        // a new strategy was defined (otherwise will already resume)
        configuration.stateStorageStrategy !== configStateStorageStrategy && (
        // new strategy is different to old one (otherwise will already resume)
        !configAnonymousTracking || configAnonymousSessionTracking) &&
        // we were previously tracking session IDs (otherwise nothing to resume)
        getSnowplowCookieValue('ses'); // and we currently have a session in progress (otherwise we want a new session anyway)
        trackerConfiguration.anonymousTracking = false;
        toggleAnonymousTracking(configuration);
        if (shouldResumeSession) setSessionCookie(); // ensure session cookie exists with new strategy
        initializeIdsAndCookies();
        outQueue.executeQueue(); // There might be some events in the queue we've been unable to send in anonymous mode
      },
      enableAnonymousTracking: function enableAnonymousTracking(configuration) {
        var _a;
        trackerConfiguration.anonymousTracking = (_a = configuration && (configuration === null || configuration === void 0 ? void 0 : configuration.options)) !== null && _a !== void 0 ? _a : true;
        toggleAnonymousTracking(configuration);
        // Reset the page view, if not tracking the session, so can't stitch user into new events on the page view id
        if (!configAnonymousSessionTracking) {
          resetPageView();
        }
      },
      clearUserData: clearUserDataAndCookies
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, apiMethods), {
      id: trackerId,
      namespace: namespace,
      core: core,
      sharedState: state
    });
  };
  // Initialise the tracker
  var partialTracker = newTracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration),
    tracker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, partialTracker), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        tracker.core.addPlugin(configuration);
        (_b = (_a = configuration.plugin).activateBrowserPlugin) === null || _b === void 0 ? void 0 : _b.call(_a, tracker);
      }
    });
  // Initialise each plugin with the tracker
  browserPlugins.forEach(function (p) {
    var _a;
    (_a = p.activateBrowserPlugin) === null || _a === void 0 ? void 0 : _a.call(p, tracker);
  });
  return tracker;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var namedTrackers = {};
/**
 * Dispatch function to all specified trackers
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackers(trackers, fn) {
  try {
    getTrackers(trackers !== null && trackers !== void 0 ? trackers : allTrackerNames()).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Dispatch function to all specified trackers from the supplied collection
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param trackerCollection - The collection which the trackers will be selected from
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackersInCollection(trackers, trackerCollection, fn) {
  try {
    getTrackersFromCollection(trackers !== null && trackers !== void 0 ? trackers : Object.keys(trackerCollection), trackerCollection).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Checks if a tracker has been created for a particular identifier
 * @param trackerId - The unique identifier of the tracker
 */
function trackerExists(trackerId) {
  return namedTrackers.hasOwnProperty(trackerId);
}
/**
 * Creates a Tracker and adds it to the internal collection
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker, tracked with each event as `tna`
 * @param version - The current version of the tracker library
 * @param endpoint - The endpoint to send events to
 * @param sharedState - The instance of shared state to use for this tracker
 * @param configuration - The configuration to use for this tracker instance
 */
function addTracker(trackerId, namespace, version, endpoint, sharedState, configuration) {
  if (!namedTrackers.hasOwnProperty(trackerId)) {
    namedTrackers[trackerId] = Tracker(trackerId, namespace, version, endpoint, sharedState, configuration);
    return namedTrackers[trackerId];
  }
  return null;
}
/**
 * Gets a single instance of the internal tracker object
 * @param trackerId - The unique identifier of the tracker
 * @returns The tracker instance, or null if not found
 */
function getTracker(trackerId) {
  if (namedTrackers.hasOwnProperty(trackerId)) {
    return namedTrackers[trackerId];
  }
  __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].warn(trackerId + ' not configured');
  return null;
}
/**
 * Gets an array of tracker instances based on the list of identifiers
 * @param trackerIds - An array of unique identifiers of the trackers
 * @returns The tracker instances, or empty list if none found
 */
function getTrackers(trackerIds) {
  return getTrackersFromCollection(trackerIds, namedTrackers);
}
/**
 * Gets all the trackers as a object, keyed by their unique identifiers
 */
function allTrackers() {
  return namedTrackers;
}
/**
 * Returns all the unique tracker identifiers
 */
function allTrackerNames() {
  return Object.keys(namedTrackers);
}
function getTrackersFromCollection(trackerIds, trackerCollection) {
  var trackers = [];
  for (var _i = 0, trackerIds_1 = trackerIds; _i < trackerIds_1.length; _i++) {
    var id = trackerIds_1[_i];
    if (trackerCollection.hasOwnProperty(id)) {
      trackers.push(trackerCollection[id]);
    } else {
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].warn(id + ' not configured');
    }
  }
  return trackers;
}
/**
 * Write all pending cookies to the browser.
 * Useful if you track events just before the page is unloaded.
 * This call is not necessary if `synchronousCookieWrite` is set to `true`.
 */
function flushPendingCookies() {
  asyncCookieStorage.flush();
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Checks whether sessionStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasSessionStorage() {
  try {
    return !!window.sessionStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is accessible
 * sets and removes an item to handle private IOS5 browsing
 * (http://git.io/jFB2Xw)
 */
function localStorageAccessible() {
  var mod = 'modernizr';
  if (!hasLocalStorage()) {
    return false;
  }
  try {
    var ls = window.localStorage;
    ls.setItem(mod, mod);
    ls.removeItem(mod);
    return true;
  } catch (e) {
    return false;
  }
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * A set of variables which are shared among all initialised trackers
 */
var SharedState = /** @class */function () {
  function SharedState() {
    this.bufferFlushers = [];
    /* DOM Ready */
    this.hasLoaded = false;
    this.registeredOnLoadHandlers = [];
  }
  return SharedState;
}();
function createSharedState() {
  var sharedState = new SharedState(),
    documentAlias = document,
    windowAlias = window;
  /*
   * Handle page visibility event
   * Works everywhere except IE9
   */
  function visibilityChangeHandler() {
    if (documentAlias.visibilityState == 'hidden') {
      // Flush all POST queues
      sharedState.bufferFlushers.forEach(function (flusher) {
        flusher(false);
      });
    }
  }
  function flushBuffers() {
    // Flush all POST queues
    sharedState.bufferFlushers.forEach(function (flusher) {
      flusher(false);
    });
  }
  /*
   * Handler for onload event
   */
  function loadHandler() {
    var i;
    if (!sharedState.hasLoaded) {
      sharedState.hasLoaded = true;
      for (i = 0; i < sharedState.registeredOnLoadHandlers.length; i++) {
        sharedState.registeredOnLoadHandlers[i]();
      }
    }
    return true;
  }
  /*
   * Add onload or DOM ready handler
   */
  function addReadyListener() {
    if (documentAlias.addEventListener) {
      documentAlias.addEventListener('DOMContentLoaded', function ready() {
        documentAlias.removeEventListener('DOMContentLoaded', ready, false);
        loadHandler();
      });
    } else if (documentAlias.attachEvent) {
      documentAlias.attachEvent('onreadystatechange', function ready() {
        if (documentAlias.readyState === 'complete') {
          documentAlias.detachEvent('onreadystatechange', ready);
          loadHandler();
        }
      });
    }
    // fallback
    addEventListener(windowAlias, 'load', loadHandler, false);
  }
  /************************************************************
   * Constructor
   ************************************************************/
  // initialize the Snowplow singleton
  if (documentAlias.visibilityState) {
    // Flush for mobile and modern browsers
    addEventListener(documentAlias, 'visibilitychange', visibilityChangeHandler, false);
  }
  // Last attempt at flushing in beforeunload
  addEventListener(windowAlias, 'beforeunload', flushBuffers, false);
  if (document.readyState === 'loading') {
    addReadyListener();
  } else {
    loadHandler();
  }
  return sharedState;
}


/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOG; });
/* unused harmony export LOG_LEVEL */
/* unused harmony export buildAdClick */
/* unused harmony export buildAdConversion */
/* unused harmony export buildAdImpression */
/* unused harmony export buildAddToCart */
/* unused harmony export buildConsentGranted */
/* unused harmony export buildConsentWithdrawn */
/* unused harmony export buildEcommerceTransaction */
/* unused harmony export buildEcommerceTransactionItem */
/* unused harmony export buildFormFocusOrChange */
/* unused harmony export buildFormSubmission */
/* unused harmony export buildLinkClick */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return buildPagePing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildPageView; });
/* unused harmony export buildRemoveFromCart */
/* unused harmony export buildScreenView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return buildSelfDescribingEvent; });
/* unused harmony export buildSiteSearch */
/* unused harmony export buildSocialInteraction */
/* unused harmony export buildStructEvent */
/* unused harmony export getRuleParts */
/* unused harmony export getSchemaParts */
/* unused harmony export globalContexts */
/* unused harmony export isConditionalContextProvider */
/* unused harmony export isContextCallbackFunction */
/* unused harmony export isContextPrimitive */
/* unused harmony export isFilterProvider */
/* unused harmony export isJson */
/* unused harmony export isNonEmptyJson */
/* unused harmony export isRuleSet */
/* unused harmony export isRuleSetProvider */
/* unused harmony export isSelfDescribingJson */
/* unused harmony export isStringArray */
/* unused harmony export isValidRule */
/* unused harmony export isValidRuleSetArg */
/* unused harmony export matchSchemaAgainstRule */
/* unused harmony export matchSchemaAgainstRuleSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newEmitter; });
/* unused harmony export newEventStorePayload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newInMemoryEventStore; });
/* unused harmony export payloadBuilder */
/* unused harmony export payloadJsonProcessor */
/* unused harmony export pluginContexts */
/* unused harmony export removeEmptyProperties */
/* unused harmony export resolveDynamicContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackerCore; });
/* unused harmony export validateVendor */
/* unused harmony export validateVendorParts */
/* unused harmony export version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow JavaScript trackers v4.5.0 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */



var version$1 = "4.5.0";

/*
 * Copyright (c) 2013 Kevin van Zonneveld (http://kvz.io)
 * and Contributors (http://phpjs.org/authors)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/**
 * Decodes a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to decode
 * @returns The decoded string
 */
function base64urldecode(data) {
  if (!data) {
    return data;
  }
  var padding = 4 - data.length % 4;
  switch (padding) {
    case 2:
      data += '==';
      break;
    case 3:
      data += '=';
      break;
  }
  var b64Data = data.replace(/-/g, '+').replace(/_/g, '/');
  return base64decode(b64Data);
}
/**
 * Encodes a string into a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to encode
 * @returns The url safe Base 64 string
 */
function base64urlencode(data) {
  if (!data) {
    return data;
  }
  var enc = base64encode(data);
  return enc.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encode string as base64.
 * Any type can be passed, but will be stringified
 *
 * @param data - string to encode
 * @returns base64-encoded string
 */
function base64encode(data) {
  // discuss at: http://phpjs.org/functions/base64_encode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Bayron Guevara
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Rafał Kukawski (http://kukawski.pl)
  // bugfixed by: Pellentesque Malesuada
  // example 1: base64_encode('Kevin van Zonneveld');
  // returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
  // example 2: base64_encode('a');
  // returns 2: 'YQ=='
  // example 3: base64_encode('✓ à la mode');
  // returns 3: '4pyTIMOgIGxhIG1vZGU='
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0;
  var tmp_arr = [];
  if (!data) {
    return data;
  }
  data = unescape(encodeURIComponent(data));
  do {
    // pack three octets into four hexets
    o1 = data.charCodeAt(i++);
    o2 = data.charCodeAt(i++);
    o3 = data.charCodeAt(i++);
    bits = o1 << 16 | o2 << 8 | o3;
    h1 = bits >> 18 & 0x3f;
    h2 = bits >> 12 & 0x3f;
    h3 = bits >> 6 & 0x3f;
    h4 = bits & 0x3f;
    // use hexets to index into b64, and append result to encoded string
    tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
  } while (i < data.length);
  var enc = tmp_arr.join('');
  var r = data.length % 3;
  return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}
/**
 * Decode base64 to string
 *
 * @param data - base64 to string
 * @returns decoded string
 */
function base64decode(encodedData) {
  //  discuss at: http://locutus.io/php/base64_decode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Kevin van Zonneveld (http://kvz.io)
  //    input by: Aman Gupta
  //    input by: Brett Zamir (http://brett-zamir.me)
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  // bugfixed by: Pellentesque Malesuada
  // bugfixed by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Indigo744
  //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==')
  //   returns 1: 'Kevin van Zonneveld'
  //   example 2: base64_decode('YQ==')
  //   returns 2: 'a'
  //   example 3: base64_decode('4pyTIMOgIGxhIG1vZGU=')
  //   returns 3: '✓ à la mode'
  // decodeUTF8string()
  // Internal function to decode properly UTF8 string
  // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
  var decodeUTF8string = function decodeUTF8string(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  };
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0,
    dec = '';
  var tmpArr = [];
  if (!encodedData) {
    return encodedData;
  }
  encodedData += '';
  do {
    // unpack four hexets into three octets using index points in b64
    h1 = b64.indexOf(encodedData.charAt(i++));
    h2 = b64.indexOf(encodedData.charAt(i++));
    h3 = b64.indexOf(encodedData.charAt(i++));
    h4 = b64.indexOf(encodedData.charAt(i++));
    bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
    o1 = bits >> 16 & 0xff;
    o2 = bits >> 8 & 0xff;
    o3 = bits & 0xff;
    if (h3 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1);
    } else if (h4 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1, o2);
    } else {
      tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
    }
  } while (i < encodedData.length);
  dec = tmpArr.join('');
  return decodeUTF8string(dec.replace(/\0+$/, ''));
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
function payloadBuilder() {
  var dict = {},
    allJson = [],
    jsonForProcessing = [],
    contextEntitiesForProcessing = [];
  var processor;
  var add = function add(key, value) {
    if (value != null && value !== '') {
      // null also checks undefined
      dict[key] = value;
    }
  };
  var addDict = function addDict(dict) {
    for (var key in dict) {
      if (Object.prototype.hasOwnProperty.call(dict, key)) {
        add(key, dict[key]);
      }
    }
  };
  var addJson = function addJson(keyIfEncoded, keyIfNotEncoded, json) {
    if (json && isNonEmptyJson(json)) {
      var jsonWithKeys = {
        keyIfEncoded: keyIfEncoded,
        keyIfNotEncoded: keyIfNotEncoded,
        json: json
      };
      jsonForProcessing.push(jsonWithKeys);
      allJson.push(jsonWithKeys);
    }
  };
  var addContextEntity = function addContextEntity(entity) {
    contextEntitiesForProcessing.push(entity);
  };
  return {
    add: add,
    addDict: addDict,
    addJson: addJson,
    addContextEntity: addContextEntity,
    getPayload: function getPayload() {
      return dict;
    },
    getJson: function getJson() {
      return allJson;
    },
    withJsonProcessor: function withJsonProcessor(jsonProcessor) {
      processor = jsonProcessor;
    },
    build: function build() {
      processor === null || processor === void 0 ? void 0 : processor(this, jsonForProcessing, contextEntitiesForProcessing);
      return dict;
    }
  };
}
/**
 * A helper to build a Snowplow request from a set of name-value pairs, provided using the add methods.
 * Will base64 encode JSON, if desired, on build
 *
 * @returns The request builder, with add and build methods
 */
function payloadJsonProcessor(encodeBase64) {
  return function (payloadBuilder, jsonForProcessing, contextEntitiesForProcessing) {
    var add = function add(json, keyIfEncoded, keyIfNotEncoded) {
      var str = JSON.stringify(json);
      if (encodeBase64) {
        payloadBuilder.add(keyIfEncoded, base64urlencode(str));
      } else {
        payloadBuilder.add(keyIfNotEncoded, str);
      }
    };
    var getContextFromPayload = function getContextFromPayload() {
      var payload = payloadBuilder.getPayload();
      if (encodeBase64 ? payload.cx : payload.co) {
        return JSON.parse(encodeBase64 ? base64urldecode(payload.cx) : payload.co);
      }
      return undefined;
    };
    var combineContexts = function combineContexts(originalContext, newContext) {
      var context = originalContext || getContextFromPayload();
      if (context) {
        context.data = context.data.concat(newContext.data);
      } else {
        context = newContext;
      }
      return context;
    };
    var context = undefined;
    for (var _i = 0, jsonForProcessing_1 = jsonForProcessing; _i < jsonForProcessing_1.length; _i++) {
      var json = jsonForProcessing_1[_i];
      if (json.keyIfEncoded === 'cx') {
        context = combineContexts(context, json.json);
      } else {
        add(json.json, json.keyIfEncoded, json.keyIfNotEncoded);
      }
    }
    jsonForProcessing.length = 0;
    if (contextEntitiesForProcessing.length) {
      var newContext = {
        schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], contextEntitiesForProcessing, true)
      };
      context = combineContexts(context, newContext);
      contextEntitiesForProcessing.length = 0;
    }
    if (context) {
      add(context, 'cx', 'co');
    }
  };
}
/**
 * Is property a non-empty JSON?
 * @param property - Checks if object is non-empty json
 */
function isNonEmptyJson(property) {
  if (!isJson(property)) {
    return false;
  }
  for (var key in property) {
    if (Object.prototype.hasOwnProperty.call(property, key)) {
      return true;
    }
  }
  return false;
}
/**
 * Is property a JSON?
 * @param property - Checks if object is json
 */
function isJson(property) {
  return typeof property !== 'undefined' && property !== null && (property.constructor === {}.constructor || property.constructor === [].constructor);
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var label = 'Snowplow: ';
var LOG_LEVEL;
(function (LOG_LEVEL) {
  LOG_LEVEL[LOG_LEVEL["none"] = 0] = "none";
  LOG_LEVEL[LOG_LEVEL["error"] = 1] = "error";
  LOG_LEVEL[LOG_LEVEL["warn"] = 2] = "warn";
  LOG_LEVEL[LOG_LEVEL["debug"] = 3] = "debug";
  LOG_LEVEL[LOG_LEVEL["info"] = 4] = "info";
})(LOG_LEVEL || (LOG_LEVEL = {}));
var LOG = logger();
function logger(logLevel) {
  if (logLevel === void 0) {
    logLevel = LOG_LEVEL.warn;
  }
  function setLogLevel(level) {
    if (LOG_LEVEL[level]) {
      logLevel = level;
    } else {
      logLevel = LOG_LEVEL.warn;
    }
  }
  /**
   * Log errors, with or without error object
   */
  function error(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.error && typeof console !== 'undefined') {
      var logMsg = label + message + '\n';
      if (error) {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log warnings, with or without error object
   */
  function warn(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.warn && typeof console !== 'undefined') {
      var logMsg = label + message;
      if (error) {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log debug messages
   */
  function debug(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.debug && typeof console !== 'undefined') {
      console.debug.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  /**
   * Log info messages
   */
  function info(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.info && typeof console !== 'undefined') {
      console.info.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  return {
    setLogLevel: setLogLevel,
    warn: warn,
    error: error,
    debug: debug,
    info: info
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Contains helper functions to aid in the addition and removal of Global Contexts
 */
function globalContexts() {
  var globalPrimitives = [];
  var conditionalProviders = [];
  var namedPrimitives = {};
  var namedConditionalProviders = {};
  /**
   * Returns all applicable global contexts for a specified event
   * @param event - The event to check for applicable global contexts for
   * @returns An array of contexts
   */
  var assembleAllContexts = function assembleAllContexts(event) {
    var eventSchema = getUsefulSchema(event);
    var eventType = getEventType(event);
    var contexts = [];
    var generatedPrimitives = generatePrimitives(globalPrimitives.concat(Object.values(namedPrimitives)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedPrimitives);
    var generatedConditionals = generateConditionals(conditionalProviders.concat(Object.values(namedConditionalProviders)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedConditionals);
    return contexts;
  };
  return {
    getGlobalPrimitives: function getGlobalPrimitives() {
      return globalPrimitives.concat(Object.values(namedPrimitives));
    },
    getConditionalProviders: function getConditionalProviders() {
      return conditionalProviders.concat(Object.values(namedConditionalProviders));
    },
    addGlobalContexts: function addGlobalContexts(contexts) {
      if (Array.isArray(contexts)) {
        var acceptedConditionalContexts = [];
        var acceptedContextPrimitives = [];
        for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
          var context = contexts_1[_i];
          if (isConditionalContextProvider(context)) {
            acceptedConditionalContexts.push(context);
          } else if (isContextPrimitive(context)) {
            acceptedContextPrimitives.push(context);
          }
        }
        globalPrimitives = globalPrimitives.concat(acceptedContextPrimitives);
        conditionalProviders = conditionalProviders.concat(acceptedConditionalContexts);
      } else {
        for (var _a = 0, _b = Object.entries(contexts); _a < _b.length; _a++) {
          var _c = _b[_a],
            name_1 = _c[0],
            context = _c[1];
          if (isConditionalContextProvider(context)) {
            namedConditionalProviders[name_1] = context;
          } else if (isContextPrimitive(context)) {
            namedPrimitives[name_1] = context;
          }
        }
      }
    },
    clearGlobalContexts: function clearGlobalContexts() {
      conditionalProviders = [];
      globalPrimitives = [];
      namedConditionalProviders = {};
      namedPrimitives = {};
    },
    removeGlobalContexts: function removeGlobalContexts(contexts) {
      var _loop_1 = function _loop_1(context) {
        if (typeof context === 'string') {
          delete namedConditionalProviders[context];
          delete namedPrimitives[context];
        } else if (isConditionalContextProvider(context)) {
          conditionalProviders = conditionalProviders.filter(function (item) {
            return !compareProvider(context, item);
          });
        } else if (isContextPrimitive(context)) {
          globalPrimitives = globalPrimitives.filter(function (item) {
            return !compareProvider(context, item);
          });
        }
      };
      for (var _i = 0, contexts_2 = contexts; _i < contexts_2.length; _i++) {
        var context = contexts_2[_i];
        _loop_1(context);
      }
    },
    getApplicableContexts: function getApplicableContexts(event) {
      return assembleAllContexts(event);
    }
  };
}
function pluginContexts(plugins) {
  /**
   * Add common contexts to every event
   *
   * @param array - additionalContexts List of user-defined contexts
   * @returns userContexts combined with commonContexts
   */
  return {
    addPluginContexts: function addPluginContexts(additionalContexts) {
      var combinedContexts = additionalContexts ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], additionalContexts, true) : [];
      plugins.forEach(function (plugin) {
        try {
          if (plugin.contexts) {
            combinedContexts.push.apply(combinedContexts, plugin.contexts());
          }
        } catch (ex) {
          LOG.error('Error adding plugin contexts', ex);
        }
      });
      return combinedContexts;
    }
  };
}
/**
 * Find dynamic context generating functions and return their results to be merged into the static contexts
 * Combine an array of unchanging contexts with the result of a context-creating function
 *
 * @param dynamicOrStaticContexts - Array of custom context Objects or custom context generating functions
 * @param Parameters - to pass to dynamic context callbacks
 * @returns An array of Self Describing JSON context
 */
function resolveDynamicContext(dynamicOrStaticContexts) {
  var _a;
  var extraParams = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    extraParams[_i - 1] = arguments[_i];
  }
  return (_a = dynamicOrStaticContexts === null || dynamicOrStaticContexts === void 0 ? void 0 : dynamicOrStaticContexts.map(function (context) {
    if (typeof context === 'function') {
      try {
        return context.apply(void 0, extraParams);
      } catch (e) {
        //TODO: provide warning
        return undefined;
      }
    } else {
      return context;
    }
  }).filter(Boolean)) !== null && _a !== void 0 ? _a : [];
}
/**
 * Slices a schema into its composite parts. Useful for ruleset filtering.
 * @param input - A schema string
 * @returns The vendor, schema name, major, minor and patch information of a schema string
 */
function getSchemaParts(input) {
  var re = new RegExp('^iglu:([a-zA-Z0-9-_.]+)/([a-zA-Z0-9-_]+)/jsonschema/([1-9][0-9]*)-(0|[1-9][0-9]*)-(0|[1-9][0-9]*)$');
  var matches = re.exec(input);
  if (matches !== null) return matches.slice(1, 6);
  return undefined;
}
/**
 * Validates the vendor section of a schema string contains allowed wildcard values
 * @param parts - Array of parts from a schema string
 * @returns Whether the vendor validation parts are a valid combination
 */
function validateVendorParts(parts) {
  if (parts[0] === '*' || parts[1] === '*') {
    return false; // no wildcard in first or second part
  }
  if (parts.slice(2).length > 0) {
    var asterisk = false;
    for (var _i = 0, _a = parts.slice(2); _i < _a.length; _i++) {
      var part = _a[_i];
      if (part === '*')
        // mark when we've found a wildcard
        asterisk = true;else if (asterisk)
        // invalid if alpha parts come after wildcard
        return false;
    }
    return true;
  } else if (parts.length == 2) return true;
  return false;
}
/**
 * Validates the vendor part of a schema string is valid for a rule set
 * @param input - Vendor part of a schema string
 * @returns Whether the vendor validation string is valid
 */
function validateVendor(input) {
  var parts = input.split('.');
  if (parts && parts.length > 1) return validateVendorParts(parts);
  return false;
}
/**
 * Checks for validity of input and returns all the sections of a schema string that are used to match rules in a ruleset
 * @param input - A Schema string
 * @returns The sections of a schema string that are used to match rules in a ruleset
 */
function getRuleParts(input) {
  var re = new RegExp('^iglu:((?:(?:[a-zA-Z0-9-_]+|\\*).)+(?:[a-zA-Z0-9-_]+|\\*))/([a-zA-Z0-9-_.]+|\\*)/jsonschema/([1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)$');
  var matches = re.exec(input);
  if (matches !== null && validateVendor(matches[1])) return matches.slice(1, 6);
  return undefined;
}
/**
 * Ensures the rules specified in a schema string of a ruleset are valid
 * @param input - A Schema string
 * @returns if there rule is valid
 */
function isValidRule(input) {
  var ruleParts = getRuleParts(input);
  if (ruleParts) {
    var vendor = ruleParts[0];
    return ruleParts.length === 5 && validateVendor(vendor);
  }
  return false;
}
/**
 * Check if a variable is an Array containing only strings
 * @param input - The variable to validate
 * @returns True if the input is an array containing only strings
 */
function isStringArray(input) {
  return Array.isArray(input) && input.every(function (x) {
    return typeof x === 'string';
  });
}
/**
 * Validates whether a rule set is an array of valid ruleset strings
 * @param input - The Array of rule set arguments
 * @returns True is the input is an array of valid rules
 */
function isValidRuleSetArg(input) {
  if (isStringArray(input)) return input.every(function (x) {
    return isValidRule(x);
  });else if (typeof input === 'string') return isValidRule(input);
  return false;
}
/**
 * Check if a variable is a valid, non-empty Self Describing JSON
 * @param input - The variable to validate
 * @returns True if a valid Self Describing JSON
 */
function isSelfDescribingJson(input) {
  var sdj = input;
  if (isNonEmptyJson(sdj)) if ('schema' in sdj && 'data' in sdj) return typeof sdj.schema === 'string' && _typeof(sdj.data) === 'object';
  return false;
}
/**
 * Validates if the input object contains the expected properties of a ruleset
 * @param input - The object containing a rule set
 * @returns True if a valid rule set
 */
function isRuleSet(input) {
  var ruleSet = input;
  var ruleCount = 0;
  if (input != null && _typeof(input) === 'object' && !Array.isArray(input)) {
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'accept')) {
      if (isValidRuleSetArg(ruleSet['accept'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'reject')) {
      if (isValidRuleSetArg(ruleSet['reject'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    // if either 'reject' or 'accept' or both exists,
    // we have a valid ruleset
    return ruleCount > 0 && ruleCount <= 2;
  }
  return false;
}
/**
 * Validates if the function can be a valid context generator function
 * @param input - The function to be validated
 */
function isContextCallbackFunction(input) {
  return typeof input === 'function' && input.length <= 1;
}
/**
 * Validates if the function can be a valid context primitive function or self describing json
 * @param input - The function or orbject to be validated
 * @returns True if either a Context Generator or Self Describing JSON
 */
function isContextPrimitive(input) {
  return isContextCallbackFunction(input) || isSelfDescribingJson(input);
}
/**
 * Validates if an array is a valid shape to be a Filter Provider
 * @param input - The Array of Context filter callbacks
 */
function isFilterProvider(input) {
  if (Array.isArray(input)) {
    if (input.length === 2) {
      if (Array.isArray(input[1])) {
        return isContextCallbackFunction(input[0]) && input[1].every(isContextPrimitive);
      }
      return isContextCallbackFunction(input[0]) && isContextPrimitive(input[1]);
    }
  }
  return false;
}
/**
 * Validates if an array is a valid shape to be an array of rule sets
 * @param input - The Array of Rule Sets
 */
function isRuleSetProvider(input) {
  if (Array.isArray(input) && input.length === 2) {
    if (!isRuleSet(input[0])) return false;
    if (Array.isArray(input[1])) return input[1].every(isContextPrimitive);
    return isContextPrimitive(input[1]);
  }
  return false;
}
/**
 * Checks if an input array is either a filter provider or a rule set provider
 * @param input - An array of filter providers or rule set providers
 * @returns Whether the array is a valid {@link ConditionalContextProvider}
 */
function isConditionalContextProvider(input) {
  return isFilterProvider(input) || isRuleSetProvider(input);
}
/**
 * Checks if a given schema matches any rules within the provided rule set
 * @param ruleSet - The rule set containing rules to match schema against
 * @param schema - The schema to be matched against the rule set
 */
function matchSchemaAgainstRuleSet(ruleSet, schema) {
  var rejectCount = 0;
  var acceptCount = 0;
  var acceptRules = ruleSet['accept'];
  if (Array.isArray(acceptRules)) {
    if (ruleSet.accept.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      acceptCount++;
    }
  } else if (typeof acceptRules === 'string') {
    if (matchSchemaAgainstRule(acceptRules, schema)) {
      acceptCount++;
    }
  }
  var rejectRules = ruleSet['reject'];
  if (Array.isArray(rejectRules)) {
    if (ruleSet.reject.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      rejectCount++;
    }
  } else if (typeof rejectRules === 'string') {
    if (matchSchemaAgainstRule(rejectRules, schema)) {
      rejectCount++;
    }
  }
  if (acceptCount > 0 && rejectCount === 0) {
    return true;
  } else if (acceptCount === 0 && rejectCount > 0) {
    return false;
  }
  return false;
}
/**
 * Checks if a given schema matches a specific rule from a rule set
 * @param rule - The rule to match schema against
 * @param schema - The schema to be matched against the rule
 */
function matchSchemaAgainstRule(rule, schema) {
  if (!isValidRule(rule)) return false;
  var ruleParts = getRuleParts(rule);
  var schemaParts = getSchemaParts(schema);
  if (ruleParts && schemaParts) {
    if (!matchVendor(ruleParts[0], schemaParts[0])) return false;
    for (var i = 1; i < 5; i++) {
      if (!matchPart(ruleParts[i], schemaParts[i])) return false;
    }
    return true; // if it hasn't failed, it passes
  }
  return false;
}
function matchVendor(rule, vendor) {
  // rule and vendor must have same number of elements
  var vendorParts = vendor.split('.');
  var ruleParts = rule.split('.');
  if (vendorParts && ruleParts) {
    if (vendorParts.length !== ruleParts.length) return false;
    for (var i = 0; i < ruleParts.length; i++) {
      if (!matchPart(vendorParts[i], ruleParts[i])) return false;
    }
    return true;
  }
  return false;
}
function matchPart(rule, schema) {
  // parts should be the string nested between slashes in the URI: /example/
  return rule && schema && rule === '*' || rule === schema;
}
// Returns the "useful" schema, i.e. what would someone want to use to identify events.
// For some events this is the 'e' property but for unstructured events, this is the
// 'schema' from the 'ue_px' field.
function getUsefulSchema(sb) {
  var eventJson = sb.getJson();
  for (var _i = 0, eventJson_1 = eventJson; _i < eventJson_1.length; _i++) {
    var json = eventJson_1[_i];
    if (json.keyIfEncoded === 'ue_px' && _typeof(json.json['data']) === 'object') {
      var schema = json.json['data']['schema'];
      if (typeof schema == 'string') {
        return schema;
      }
    }
  }
  return '';
}
function getEventType(payloadBuilder) {
  var eventType = payloadBuilder.getPayload()['e'];
  return typeof eventType === 'string' ? eventType : '';
}
function buildGenerator(generator, event, eventType, eventSchema) {
  var contextGeneratorResult = undefined;
  try {
    // try to evaluate context generator
    var args = {
      event: event.getPayload(),
      eventType: eventType,
      eventSchema: eventSchema
    };
    contextGeneratorResult = generator(args);
    // determine if the produced result is a valid SDJ
    if (Array.isArray(contextGeneratorResult) && contextGeneratorResult.every(isSelfDescribingJson)) {
      return contextGeneratorResult;
    } else if (isSelfDescribingJson(contextGeneratorResult)) {
      return contextGeneratorResult;
    } else {
      return undefined;
    }
  } catch (error) {
    contextGeneratorResult = undefined;
  }
  return contextGeneratorResult;
}
function normalizeToArray(input) {
  if (Array.isArray(input)) {
    return input;
  }
  return Array.of(input);
}
function generatePrimitives(contextPrimitives, event, eventType, eventSchema) {
  var _a;
  var normalizedInputs = normalizeToArray(contextPrimitives);
  var partialEvaluate = function partialEvaluate(primitive) {
    var result = evaluatePrimitive(primitive, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInputs.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}
function evaluatePrimitive(contextPrimitive, event, eventType, eventSchema) {
  if (isSelfDescribingJson(contextPrimitive)) {
    return [contextPrimitive];
  } else if (isContextCallbackFunction(contextPrimitive)) {
    var generatorOutput = buildGenerator(contextPrimitive, event, eventType, eventSchema);
    if (isSelfDescribingJson(generatorOutput)) {
      return [generatorOutput];
    } else if (Array.isArray(generatorOutput)) {
      return generatorOutput;
    }
  }
  return undefined;
}
function evaluateProvider(provider, event, eventType, eventSchema) {
  if (isFilterProvider(provider)) {
    var filter = provider[0];
    var filterResult = false;
    try {
      var args = {
        event: event.getPayload(),
        eventType: eventType,
        eventSchema: eventSchema
      };
      filterResult = filter(args);
    } catch (error) {
      filterResult = false;
    }
    if (filterResult === true) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  } else if (isRuleSetProvider(provider)) {
    if (matchSchemaAgainstRuleSet(provider[0], eventSchema)) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  }
  return [];
}
function compareProviderPart(a, b) {
  if (typeof a === 'function') return a === b;
  return JSON.stringify(a) === JSON.stringify(b);
}
function compareProvider(a, b) {
  if (isConditionalContextProvider(a)) {
    if (!isConditionalContextProvider(b)) return false;
    var ruleA = a[0],
      primitivesA = a[1];
    var ruleB = b[0],
      primitivesB_1 = b[1];
    if (!compareProviderPart(ruleA, ruleB)) return false;
    if (Array.isArray(primitivesA)) {
      if (!Array.isArray(primitivesB_1)) return false;
      if (primitivesA.length !== primitivesB_1.length) return false;
      return primitivesA.reduce(function (matches, a, i) {
        return matches && compareProviderPart(a, primitivesB_1[i]);
      }, true);
    } else {
      if (Array.isArray(primitivesB_1)) return false;
      return compareProviderPart(primitivesA, primitivesB_1);
    }
  } else if (isContextPrimitive(a)) {
    if (!isContextPrimitive(b)) return false;
    return compareProviderPart(a, b);
  }
  return false;
}
function generateConditionals(providers, event, eventType, eventSchema) {
  var _a;
  var normalizedInput = normalizeToArray(providers);
  var partialEvaluate = function partialEvaluate(provider) {
    var result = evaluateProvider(provider, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInput.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}

/**
 * Create a new EventStorePayload
 */
function newEventStorePayload(_a) {
  var payload = _a.payload,
    _b = _a.svrAnon,
    svrAnon = _b === void 0 ? false : _b;
  return {
    payload: payload,
    svrAnon: svrAnon
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Transform optional/old-behavior number timestamp into`Timestamp` ADT
 *
 * @param timestamp - optional number or timestamp object
 * @returns correct timestamp object
 */
function getTimestamp(timestamp) {
  if (timestamp == null) {
    return {
      type: 'dtm',
      value: new Date().getTime()
    };
  } else if (typeof timestamp === 'number') {
    return {
      type: 'dtm',
      value: timestamp
    };
  } else if (timestamp.type === 'ttm') {
    // We can return timestamp here, but this is safer fallback
    return {
      type: 'ttm',
      value: timestamp.value
    };
  } else {
    return {
      type: 'dtm',
      value: timestamp.value || new Date().getTime()
    };
  }
}
/**
 * Create a tracker core object
 *
 * @param base64 - Whether to base 64 encode contexts and self describing event JSONs
 * @param corePlugins - The core plugins to be processed with each event
 * @param callback - Function applied to every payload dictionary object
 * @returns Tracker core
 */
function trackerCore(configuration) {
  if (configuration === void 0) {
    configuration = {};
  }
  function newCore(base64, corePlugins, callback) {
    var pluginContextsHelper = pluginContexts(corePlugins),
      globalContextsHelper = globalContexts();
    var encodeBase64 = base64,
      payloadPairs = {}; // Dictionary of key-value pairs which get added to every payload, e.g. tracker version
    /**
     * Wraps an array of custom contexts in a self-describing JSON
     *
     * @param contexts - Array of custom context self-describing JSONs
     * @returns Outer JSON
     */
    function completeContexts(contexts) {
      if (contexts && contexts.length) {
        return {
          schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
          data: contexts
        };
      }
      return undefined;
    }
    /**
     * Adds all global contexts to a contexts array
     *
     * @param pb - PayloadData
     * @param contexts - Custom contexts relating to the event
     */
    function attachGlobalContexts(pb, contexts) {
      var applicableContexts = globalContextsHelper.getApplicableContexts(pb);
      var returnedContexts = [];
      if (contexts && contexts.length) {
        returnedContexts.push.apply(returnedContexts, contexts);
      }
      if (applicableContexts && applicableContexts.length) {
        returnedContexts.push.apply(returnedContexts, applicableContexts);
      }
      return returnedContexts;
    }
    /**
     * Gets called by every trackXXX method
     * Adds context and payloadPairs name-value pairs to the payload
     * Applies the callback to the built payload
     *
     * @param pb - Payload
     * @param context - Custom contexts relating to the event
     * @param timestamp - Timestamp of the event
     * @returns Payload after the callback is applied or undefined if the event is skipped
     */
    function track(pb, context, timestamp) {
      if (!active) {
        LOG.error('Track called on deactivated tracker');
        return undefined;
      }
      pb.withJsonProcessor(payloadJsonProcessor(encodeBase64));
      pb.add('eid', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_uuid__["a" /* v4 */])());
      pb.addDict(payloadPairs);
      var tstamp = getTimestamp(timestamp);
      pb.add(tstamp.type, tstamp.value.toString());
      var allContexts = attachGlobalContexts(pb, pluginContextsHelper.addPluginContexts(context));
      var wrappedContexts = completeContexts(allContexts);
      if (wrappedContexts !== undefined) {
        pb.addJson('cx', 'co', wrappedContexts);
      }
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.beforeTrack) {
            plugin.beforeTrack(pb);
          }
        } catch (ex) {
          LOG.error('Plugin beforeTrack', ex);
        }
      });
      // Call the filter on plugins to determine if the event should be tracked
      var skip = corePlugins.find(function (plugin) {
        try {
          return plugin.filter && plugin.filter(pb.build()) === false;
        } catch (ex) {
          LOG.error('Plugin filter', ex);
          return false;
        }
      });
      if (skip) {
        return undefined;
      }
      if (typeof callback === 'function') {
        callback(pb);
      }
      var finalPayload = pb.build();
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.afterTrack) {
            plugin.afterTrack(finalPayload);
          }
        } catch (ex) {
          LOG.error('Plugin afterTrack', ex);
        }
      });
      return finalPayload;
    }
    /**
     * Set a persistent key-value pair to be added to every payload
     *
     * @param key - Field name
     * @param value - Field value
     */
    function addPayloadPair(key, value) {
      payloadPairs[key] = value;
    }
    var core = {
      track: track,
      addPayloadPair: addPayloadPair,
      getBase64Encoding: function getBase64Encoding() {
        return encodeBase64;
      },
      setBase64Encoding: function setBase64Encoding(encode) {
        encodeBase64 = encode;
      },
      addPayloadDict: function addPayloadDict(dict) {
        for (var key in dict) {
          if (Object.prototype.hasOwnProperty.call(dict, key)) {
            payloadPairs[key] = dict[key];
          }
        }
      },
      resetPayloadPairs: function resetPayloadPairs(dict) {
        payloadPairs = isJson(dict) ? dict : {};
      },
      setTrackerVersion: function setTrackerVersion(version) {
        addPayloadPair('tv', version);
      },
      setTrackerNamespace: function setTrackerNamespace(name) {
        addPayloadPair('tna', name);
      },
      setAppId: function setAppId(appId) {
        addPayloadPair('aid', appId);
      },
      setPlatform: function setPlatform(value) {
        addPayloadPair('p', value);
      },
      setUserId: function setUserId(userId) {
        addPayloadPair('uid', userId);
      },
      setScreenResolution: function setScreenResolution(width, height) {
        addPayloadPair('res', width + 'x' + height);
      },
      setViewport: function setViewport(width, height) {
        addPayloadPair('vp', width + 'x' + height);
      },
      setColorDepth: function setColorDepth(depth) {
        addPayloadPair('cd', depth);
      },
      setTimezone: function setTimezone(timezone) {
        addPayloadPair('tz', timezone);
      },
      setLang: function setLang(lang) {
        addPayloadPair('lang', lang);
      },
      setIpAddress: function setIpAddress(ip) {
        addPayloadPair('ip', ip);
      },
      setUseragent: function setUseragent(useragent) {
        addPayloadPair('ua', useragent);
      },
      addGlobalContexts: function addGlobalContexts(contexts) {
        globalContextsHelper.addGlobalContexts(contexts);
      },
      clearGlobalContexts: function clearGlobalContexts() {
        globalContextsHelper.clearGlobalContexts();
      },
      removeGlobalContexts: function removeGlobalContexts(contexts) {
        globalContextsHelper.removeGlobalContexts(contexts);
      }
    };
    return core;
  }
  var active = true;
  var base64 = configuration.base64,
    corePlugins = configuration.corePlugins,
    callback = configuration.callback,
    plugins = corePlugins !== null && corePlugins !== void 0 ? corePlugins : [],
    partialCore = newCore(base64 !== null && base64 !== void 0 ? base64 : true, plugins, callback),
    core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, partialCore), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        var plugin = configuration.plugin;
        plugins.push(plugin);
        (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
        (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
      },
      deactivate: function deactivate() {
        plugins.forEach(function (plugin) {
          var _a;
          (_a = plugin.deactivatePlugin) === null || _a === void 0 ? void 0 : _a.call(plugin, core);
        });
        plugins.length = 0;
        active = false;
      }
    });
  plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
    var _a, _b;
    (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
    (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
  });
  return core;
}
/**
 * Build a self-describing event
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - Contains the properties and schema location for the event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSelfDescribingEvent(event) {
  var _a = event.event,
    schema = _a.schema,
    data = _a.data,
    pb = payloadBuilder();
  var ueJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/unstruct_event/jsonschema/1-0-0',
    data: {
      schema: schema,
      data: data
    }
  };
  pb.add('e', 'ue');
  pb.addJson('ue_px', 'ue_pr', ueJson);
  return pb;
}
/**
 * Build a Page View Event
 * Represents a Page View, which is typically fired as soon as possible when a web page
 * is loaded within the users browser. Often also fired on "virtual page views" within
 * Single Page Applications (SPA).
 *
 * @param event - Contains the properties for the Page View event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPageView(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    pb = payloadBuilder();
  pb.add('e', 'pv'); // 'pv' for Page View
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  return pb;
}
/**
 * Build a Page Ping Event
 * Fires when activity tracking is enabled in the browser.
 * Tracks same information as the last tracked Page View and includes scroll
 * information from the current page view
 *
 * @param event - Contains the properties for the Page Ping event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPagePing(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    minXOffset = event.minXOffset,
    maxXOffset = event.maxXOffset,
    minYOffset = event.minYOffset,
    maxYOffset = event.maxYOffset,
    pb = payloadBuilder();
  pb.add('e', 'pp'); // 'pp' for Page Ping
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  if (minXOffset && !isNaN(Number(minXOffset))) pb.add('pp_mix', minXOffset.toString());
  if (maxXOffset && !isNaN(Number(maxXOffset))) pb.add('pp_max', maxXOffset.toString());
  if (minYOffset && !isNaN(Number(minYOffset))) pb.add('pp_miy', minYOffset.toString());
  if (maxYOffset && !isNaN(Number(maxYOffset))) pb.add('pp_may', maxYOffset.toString());
  return pb;
}
/**
 * Build a Structured Event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - Contains the properties for the Structured event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildStructEvent(event) {
  var category = event.category,
    action = event.action,
    label = event.label,
    property = event.property,
    value = event.value,
    pb = payloadBuilder();
  pb.add('e', 'se'); // 'se' for Structured Event
  pb.add('se_ca', category);
  pb.add('se_ac', action);
  pb.add('se_la', label);
  pb.add('se_pr', property);
  pb.add('se_va', value == null ? undefined : value.toString());
  return pb;
}
/**
 * Build an Ecommerce Transaction Event
 * Allows for tracking common ecommerce events, this event is usually used when
 * a consumer completes a transaction.
 *
 * @param event - Contains the properties for the Ecommerce Transactoion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransaction(event) {
  var orderId = event.orderId,
    total = event.total,
    affiliation = event.affiliation,
    tax = event.tax,
    shipping = event.shipping,
    city = event.city,
    state = event.state,
    country = event.country,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'tr'); // 'tr' for Transaction
  pb.add('tr_id', orderId);
  pb.add('tr_af', affiliation);
  pb.add('tr_tt', total);
  pb.add('tr_tx', tax);
  pb.add('tr_sh', shipping);
  pb.add('tr_ci', city);
  pb.add('tr_st', state);
  pb.add('tr_co', country);
  pb.add('tr_cu', currency);
  return pb;
}
/**
 * Build an Ecommerce Transaction Item Event
 * Related to the {@link buildEcommerceTransaction}
 * Each Ecommerce Transaction may contain one or more EcommerceTransactionItem events
 *
 * @param event - Contains the properties for the Ecommerce Transaction Item event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransactionItem(event) {
  var orderId = event.orderId,
    sku = event.sku,
    price = event.price,
    name = event.name,
    category = event.category,
    quantity = event.quantity,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'ti'); // 'tr' for Transaction Item
  pb.add('ti_id', orderId);
  pb.add('ti_sk', sku);
  pb.add('ti_nm', name);
  pb.add('ti_ca', category);
  pb.add('ti_pr', price);
  pb.add('ti_qu', quantity);
  pb.add('ti_cu', currency);
  return pb;
}
/**
 * Build a Scren View Event
 * Similar to a Page View but less focused on typical web properties
 * Often used for mobile applications as the user is presented with
 * new views as they performance navigation events
 *
 * @param event - Contains the properties for the Screen View event. One or more properties must be included.
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildScreenView(event) {
  var name = event.name,
    id = event.id;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/screen_view/jsonschema/1-0-0',
      data: removeEmptyProperties({
        name: name,
        id: id
      })
    }
  });
}
/**
 * Build a Link Click Event
 * Used when a user clicks on a link on a webpage, typically an anchor tag `<a>`
 *
 * @param event - Contains the properties for the Link Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildLinkClick(event) {
  var targetUrl = event.targetUrl,
    elementId = event.elementId,
    elementClasses = event.elementClasses,
    elementTarget = event.elementTarget,
    elementContent = event.elementContent;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/link_click/jsonschema/1-0-1',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      elementId: elementId,
      elementClasses: elementClasses,
      elementTarget: elementTarget,
      elementContent: elementContent
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Impression Event
 * Used to track an advertisement impression
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Impression event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdImpression(event) {
  var impressionId = event.impressionId,
    costModel = event.costModel,
    cost = event.cost,
    targetUrl = event.targetUrl,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0',
    data: removeEmptyProperties({
      impressionId: impressionId,
      costModel: costModel,
      cost: cost,
      targetUrl: targetUrl,
      bannerId: bannerId,
      zoneId: zoneId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Click Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdClick(event) {
  var targetUrl = event.targetUrl,
    clickId = event.clickId,
    costModel = event.costModel,
    cost = event.cost,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    impressionId = event.impressionId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_click/jsonschema/1-0-0',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      clickId: clickId,
      costModel: costModel,
      cost: cost,
      bannerId: bannerId,
      zoneId: zoneId,
      impressionId: impressionId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Conversion Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Conversion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdConversion(event) {
  var conversionId = event.conversionId,
    costModel = event.costModel,
    cost = event.cost,
    category = event.category,
    action = event.action,
    property = event.property,
    initialValue = event.initialValue,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_conversion/jsonschema/1-0-0',
    data: removeEmptyProperties({
      conversionId: conversionId,
      costModel: costModel,
      cost: cost,
      category: category,
      action: action,
      property: property,
      initialValue: initialValue,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Social Interaction Event
 * Social tracking will be used to track the way users interact
 * with Facebook, Twitter and Google + widgets
 * e.g. to capture “like this” or “tweet this” events.
 *
 * @param event - Contains the properties for the Social Interaction event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSocialInteraction(event) {
  var action = event.action,
    network = event.network,
    target = event.target;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/social_interaction/jsonschema/1-0-0',
    data: removeEmptyProperties({
      action: action,
      network: network,
      target: target
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Add To Cart Event
 * For tracking users adding items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Add To Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAddToCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/add_to_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Remove From Cart Event
 * For tracking users removing items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Remove From Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildRemoveFromCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/remove_from_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Form Focus or Change Form Event based on schema property
 * When a user focuses on a form element or when a user makes a
 * change to a form element.
 *
 * @param event - Contains the properties for the Form Focus or Change Form event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormFocusOrChange(event) {
  var event_schema = '';
  var schema = event.schema,
    formId = event.formId,
    elementId = event.elementId,
    nodeName = event.nodeName,
    elementClasses = event.elementClasses,
    value = event.value,
    type = event.type;
  var event_data = {
    formId: formId,
    elementId: elementId,
    nodeName: nodeName,
    elementClasses: elementClasses,
    value: value
  };
  if (schema === 'change_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0';
    event_data.type = type;
  } else if (schema === 'focus_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0';
    event_data.elementType = type;
  }
  return buildSelfDescribingEvent({
    event: {
      schema: event_schema,
      data: removeEmptyProperties(event_data, {
        value: true
      })
    }
  });
}
/**
 * Build a Form Submission Event
 * Used to track when a user submits a form
 *
 * @param event - Contains the properties for the Form Submission event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormSubmission(event) {
  var formId = event.formId,
    formClasses = event.formClasses,
    elements = event.elements;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
      data: removeEmptyProperties({
        formId: formId,
        formClasses: formClasses,
        elements: elements
      })
    }
  });
}
/**
 * Build a Site Search Event
 * Used when a user performs a search action on a page
 *
 * @param event - Contains the properties for the Site Search event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSiteSearch(event) {
  var terms = event.terms,
    filters = event.filters,
    totalResults = event.totalResults,
    pageResults = event.pageResults;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0',
      data: removeEmptyProperties({
        terms: terms,
        filters: filters,
        totalResults: totalResults,
        pageResults: pageResults
      })
    }
  });
}
/**
 * Build a Consent Withdrawn Event
 * Used for tracking when a user withdraws their consent
 *
 * @param event - Contains the properties for the Consent Withdrawn event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentWithdrawn(event) {
  var all = event.all,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_withdrawn/jsonschema/1-0-0',
        data: removeEmptyProperties({
          all: all
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Build a Consent Granted Event
 * Used for tracking when a user grants their consent
 *
 * @param event - Contains the properties for the Consent Granted event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentGranted(event) {
  var expiry = event.expiry,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_granted/jsonschema/1-0-0',
        data: removeEmptyProperties({
          expiry: expiry
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - JSON object to clean
 * @param exemptFields - Set of fields which should not be removed even if empty
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event, exemptFields) {
  if (exemptFields === void 0) {
    exemptFields = {};
  }
  var ret = {};
  for (var k in event) {
    if (exemptFields[k] || event[k] !== null && typeof event[k] !== 'undefined') {
      ret[k] = event[k];
    }
  }
  return ret;
}
function newInMemoryEventStore(_a) {
  var _b = _a.maxSize,
    maxSize = _b === void 0 ? 1000 : _b,
    _c = _a.events,
    events = _c === void 0 ? [] : _c;
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], events, true);
  var count = function count() {
    return Promise.resolve(store.length);
  };
  return {
    count: count,
    add: function add(payload) {
      store.push(payload);
      while (store.length > maxSize) {
        store.shift();
      }
      return count();
    },
    removeHead: function removeHead(count) {
      for (var i = 0; i < count; i++) {
        store.shift();
      }
      return Promise.resolve();
    },
    iterator: function iterator() {
      var index = 0;
      // copy the store to prevent mutation
      var events = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true);
      return {
        next: function next() {
          if (index < events.length) {
            return Promise.resolve({
              value: events[index++],
              done: false
            });
          }
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
      };
    },
    getAll: function getAll() {
      return Promise.resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true));
    },
    getAllPayloads: function getAllPayloads() {
      return Promise.resolve(store.map(function (e) {
        return e.payload;
      }));
    }
  };
}
var PAYLOAD_DATA_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4';

/**
 * Enclose an array of events in a self-describing payload_data JSON string
 *
 * @param array - events Batch of events
 * @returns string payload_data self-describing JSON
 */
function encloseInPayloadDataEnvelope(events) {
  return JSON.stringify({
    schema: PAYLOAD_DATA_SCHEMA,
    data: events
  });
}
/**
 * Attaches the STM field to outbound POST events.
 *
 * @param events - the events to attach the STM to
 */
function attachStmToEvent(events) {
  var stm = new Date().getTime().toString();
  for (var i = 0; i < events.length; i++) {
    events[i]['stm'] = stm;
  }
  return events;
}
function newEmitterRequest(_a) {
  var endpoint = _a.endpoint,
    _b = _a.protocol,
    protocol = _b === void 0 ? 'https' : _b,
    port = _a.port,
    _c = _a.eventMethod,
    eventMethod = _c === void 0 ? 'post' : _c,
    customHeaders = _a.customHeaders,
    connectionTimeout = _a.connectionTimeout,
    _d = _a.keepalive,
    keepalive = _d === void 0 ? false : _d,
    _e = _a.postPath,
    postPath = _e === void 0 ? '/com.snowplowanalytics.snowplow/tp2' : _e,
    _f = _a.useStm,
    useStm = _f === void 0 ? true : _f,
    _g = _a.maxPostBytes,
    maxPostBytes = _g === void 0 ? 40000 : _g,
    _h = _a.credentials,
    credentials = _h === void 0 ? 'include' : _h;
  var events = [];
  var usePost = eventMethod.toLowerCase() === 'post';
  var timer;
  var abortController;
  function countBytes() {
    var count = events.reduce(function (acc, event) {
      return acc + (usePost ? event.getPOSTRequestBytesCount() : event.getGETRequestBytesCount());
    }, 0);
    if (usePost) {
      count += 88; // 88 bytes for the payload_data envelope
    }
    return count;
  }
  function countEvents() {
    return events.length;
  }
  function getServerAnonymizationOfExistingEvents() {
    return events.length > 0 ? events[0].getServerAnonymization() : undefined;
  }
  function addEvent(event) {
    if (events.length > 0 && getServerAnonymizationOfExistingEvents() !== event.getServerAnonymization()) {
      return false;
    } else {
      events.push(event);
      return true;
    }
  }
  function getEvents() {
    return events;
  }
  function isFull() {
    if (usePost) {
      return countBytes() >= maxPostBytes;
    } else {
      return events.length >= 1;
    }
  }
  function createHeaders() {
    var headers = new Headers();
    if (usePost) {
      headers.append('Content-Type', 'application/json; charset=UTF-8');
    }
    if (customHeaders) {
      Object.keys(customHeaders).forEach(function (key) {
        headers.append(key, customHeaders[key]);
      });
    }
    if (getServerAnonymizationOfExistingEvents()) {
      headers.append('SP-Anonymous', '*');
    }
    return headers;
  }
  function getFullCollectorUrl() {
    var collectorUrl = endpoint;
    if (!endpoint.includes('://')) {
      collectorUrl = "".concat(protocol, "://").concat(endpoint);
    }
    if (port) {
      collectorUrl = "".concat(collectorUrl, ":").concat(port);
    }
    var path = usePost ? postPath : '/i';
    return collectorUrl + path;
  }
  function makeRequest(url, options) {
    closeRequest(false);
    abortController = new AbortController();
    timer = setTimeout(function () {
      var reason = 'Request timed out';
      console.error(reason);
      timer = undefined;
      closeRequest(false, reason);
    }, connectionTimeout !== null && connectionTimeout !== void 0 ? connectionTimeout : 5000);
    var requestOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      headers: createHeaders(),
      signal: abortController.signal,
      keepalive: keepalive,
      credentials: credentials
    }, options);
    var request = new Request(url, requestOptions);
    return request;
  }
  function makePostRequest() {
    var batch = attachStmToEvent(events.map(function (event) {
      return event.getPOSTRequestBody();
    }));
    return makeRequest(getFullCollectorUrl(), {
      method: 'POST',
      body: encloseInPayloadDataEnvelope(batch)
    });
  }
  function makeGetRequest() {
    if (events.length !== 1) {
      throw new Error('Only one event can be sent in a GET request');
    }
    var event = events[0];
    var url = event.getGETRequestURL(getFullCollectorUrl(), useStm);
    return makeRequest(url, {
      method: 'GET'
    });
  }
  function toRequest() {
    if (events.length === 0) {
      return undefined;
    }
    if (usePost) {
      return makePostRequest();
    } else {
      return makeGetRequest();
    }
  }
  function closeRequest(successful, reason) {
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    if (abortController !== undefined) {
      var controller = abortController;
      abortController = undefined;
      if (!successful) {
        controller.abort(reason);
      }
    }
  }
  return {
    addEvent: addEvent,
    getEvents: getEvents,
    toRequest: toRequest,
    countBytes: countBytes,
    countEvents: countEvents,
    isFull: isFull,
    closeRequest: closeRequest
  };
}

/**
 * Count the number of bytes a string will occupy when UTF-8 encoded
 * Taken from http://stackoverflow.com/questions/2848462/count-bytes-in-textarea-using-javascript/
 *
 * @param s - The string
 * @returns number Length of s in bytes when UTF-8 encoded
 */
function getUTF8Length(s) {
  var len = 0;
  for (var i = 0; i < s.length; i++) {
    var code = s.charCodeAt(i);
    if (code <= 0x7f) {
      len += 1;
    } else if (code <= 0x7ff) {
      len += 2;
    } else if (code >= 0xd800 && code <= 0xdfff) {
      // Surrogate pair: These take 4 bytes in UTF-8 and 2 chars in UCS-2
      // (Assume next char is the other [valid] half and just skip it)
      len += 4;
      i++;
    } else if (code < 0xffff) {
      len += 3;
    } else {
      len += 4;
    }
  }
  return len;
}
/*
  * Convert a dictionary to a querystring
  * The context field is the last in the querystring
  */
function getQuerystring(request) {
  var lowPriorityKeys = {
    co: true,
    cx: true
  };
  var args = [];
  for (var key in request) {
    if (request.hasOwnProperty(key) && !lowPriorityKeys[key]) {
      args.push(key + '=' + encodeURIComponent(request[key]));
    }
  }
  for (var contextKey in lowPriorityKeys) {
    if (request.hasOwnProperty(contextKey) && lowPriorityKeys[contextKey]) {
      args.push(contextKey + '=' + encodeURIComponent(request[contextKey]));
    }
  }
  return '?' + args.join('&');
}
/*
  * Convert numeric fields to strings to match payload_data schema
  */
function preparePostBody(request) {
  var cleanedRequest = Object.keys(request).map(function (k) {
    return [k, request[k]];
  }).reduce(function (acc, _a) {
    var key = _a[0],
      value = _a[1];
    acc[key] = value.toString();
    return acc;
  }, {});
  return cleanedRequest;
}
function newEmitterEvent(eventStorePayload) {
  var querystring = null;
  var postBody = null;
  var byteCountGET = null;
  var byteCountPOST = null;
  function getPayload() {
    return eventStorePayload.payload;
  }
  function getServerAnonymization() {
    var _a;
    return (_a = eventStorePayload.svrAnon) !== null && _a !== void 0 ? _a : false;
  }
  function getCachedQuerystring(payload) {
    if (querystring === null) {
      querystring = getQuerystring(payload);
    }
    return querystring;
  }
  function getGETRequestURL(collectorUrl, useStm) {
    var querystring = getCachedQuerystring(getPayload());
    if (useStm) {
      return collectorUrl + querystring.replace('?', '?stm=' + new Date().getTime() + '&');
    }
    return collectorUrl + querystring;
  }
  function getGETRequestBytesCount() {
    if (byteCountGET === null) {
      var querystring_1 = getCachedQuerystring(getPayload());
      byteCountGET = getUTF8Length(querystring_1);
    }
    return byteCountGET;
  }
  function getPOSTRequestBody() {
    if (postBody === null) {
      postBody = preparePostBody(getPayload());
    }
    return postBody;
  }
  function getPOSTRequestBytesCount() {
    if (byteCountPOST === null) {
      byteCountPOST = getUTF8Length(JSON.stringify(getPOSTRequestBody()));
    }
    return byteCountPOST;
  }
  return {
    getPayload: getPayload,
    getServerAnonymization: getServerAnonymization,
    getGETRequestURL: getGETRequestURL,
    getGETRequestBytesCount: getGETRequestBytesCount,
    getPOSTRequestBody: getPOSTRequestBody,
    getPOSTRequestBytesCount: getPOSTRequestBytesCount
  };
}
function newEmitter(_a) {
  var endpoint = _a.endpoint,
    _b = _a.eventMethod,
    eventMethod = _b === void 0 ? 'post' : _b,
    postPath = _a.postPath,
    protocol = _a.protocol,
    port = _a.port,
    _c = _a.maxPostBytes,
    maxPostBytes = _c === void 0 ? 40000 : _c,
    maxGetBytes = _a.maxGetBytes,
    _d = _a.bufferSize,
    bufferSize = _d === void 0 ? 1 : _d,
    customHeaders = _a.customHeaders,
    serverAnonymization = _a.serverAnonymization,
    connectionTimeout = _a.connectionTimeout,
    keepalive = _a.keepalive,
    idService = _a.idService,
    _e = _a.dontRetryStatusCodes,
    dontRetryStatusCodes = _e === void 0 ? [] : _e,
    _f = _a.retryStatusCodes,
    retryStatusCodes = _f === void 0 ? [] : _f,
    _g = _a.retryFailedRequests,
    retryFailedRequests = _g === void 0 ? true : _g,
    onRequestFailure = _a.onRequestFailure,
    onRequestSuccess = _a.onRequestSuccess,
    _h = _a.customFetch,
    customFetch = _h === void 0 ? fetch : _h,
    useStm = _a.useStm,
    _j = _a.eventStore,
    eventStore = _j === void 0 ? newInMemoryEventStore({}) : _j,
    credentials = _a.credentials;
  var idServiceCalled = false;
  var flushInProgress = false;
  var usePost = eventMethod.toLowerCase() === 'post';
  dontRetryStatusCodes = dontRetryStatusCodes.concat([400, 401, 403, 410, 422]);
  function shouldRetryForStatusCode(statusCode) {
    // success, don't retry
    if (statusCode >= 200 && statusCode < 300) {
      return false;
    }
    if (!retryFailedRequests) {
      return false;
    }
    // retry if status code among custom user-supplied retry codes
    if (retryStatusCodes.includes(statusCode)) {
      return true;
    }
    // retry if status code *not* among the don't retry codes
    return !dontRetryStatusCodes.includes(statusCode);
  }
  function callOnRequestSuccess(payloads, response) {
    if (onRequestSuccess !== undefined) {
      setTimeout(function () {
        try {
          onRequestSuccess === null || onRequestSuccess === void 0 ? void 0 : onRequestSuccess(payloads, response);
        } catch (e) {
          LOG.error('Error in onRequestSuccess', e);
        }
      }, 0);
    }
  }
  function callOnRequestFailure(failure, response) {
    if (onRequestFailure !== undefined) {
      setTimeout(function () {
        try {
          onRequestFailure === null || onRequestFailure === void 0 ? void 0 : onRequestFailure(failure, response);
        } catch (e) {
          LOG.error('Error in onRequestFailure', e);
        }
      }, 0);
    }
  }
  function executeRequest(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var fetchRequest, payloads, response, willRetry, e_1, message;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            fetchRequest = request.toRequest();
            if (fetchRequest === undefined) {
              throw new Error('Empty batch');
            }
            payloads = request.getEvents().map(function (event) {
              return event.getPayload();
            });
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4 /*yield*/, customFetch(fetchRequest)];
          case 2:
            response = _a.sent();
            return [4 /*yield*/, response.text()];
          case 3:
            _a.sent(); // wait for the response to be fully read
            request.closeRequest(true);
            if (response.ok) {
              callOnRequestSuccess(payloads, response);
              return [2 /*return*/, {
                success: true,
                retry: false,
                status: response.status
              }];
            } else {
              willRetry = shouldRetryForStatusCode(response.status);
              callOnRequestFailure({
                events: payloads,
                status: response.status,
                message: response.statusText,
                willRetry: willRetry
              }, response);
              return [2 /*return*/, {
                success: false,
                retry: willRetry,
                status: response.status
              }];
            }
          case 4:
            e_1 = _a.sent();
            request.closeRequest(false);
            message = typeof e_1 === 'string' ? e_1 : e_1 ? e_1.message : 'Unknown error';
            callOnRequestFailure({
              events: payloads,
              message: message,
              willRetry: true
            });
            return [2 /*return*/, {
              success: false,
              retry: true
            }];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function newEmitterRequestWithConfig() {
    return newEmitterRequest({
      endpoint: endpoint,
      protocol: protocol,
      port: port,
      eventMethod: eventMethod,
      customHeaders: customHeaders,
      connectionTimeout: connectionTimeout,
      keepalive: keepalive,
      maxPostBytes: maxPostBytes,
      useStm: useStm,
      credentials: credentials,
      postPath: postPath
    });
  }
  function shouldSkipEventStore(emitterEvent) {
    var eventTooBigWarning = function eventTooBigWarning(bytes, maxBytes) {
      return LOG.warn('Event (' + bytes + 'B) too big, max is ' + maxBytes);
    };
    if (usePost) {
      var bytes = emitterEvent.getPOSTRequestBytesCount() + 88; // 88 bytes for the payload_data envelope
      var tooBig = bytes > maxPostBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxPostBytes);
      }
      return tooBig;
    } else {
      if (maxGetBytes === undefined) {
        return false;
      }
      var bytes = emitterEvent.getGETRequestBytesCount();
      var tooBig = bytes > maxGetBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxGetBytes);
      }
      return tooBig;
    }
  }
  function callIdService() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(idService && !idServiceCalled)) return [3 /*break*/, 2];
            idServiceCalled = true;
            request = new Request(idService, {
              method: 'GET'
            });
            return [4 /*yield*/, customFetch(request)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  }
  function flush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var e_2;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!flushInProgress) return [3 /*break*/, 5];
            flushInProgress = true;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, continueFlush()];
          case 2:
            _a.sent();
            return [3 /*break*/, 5];
          case 3:
            e_2 = _a.sent();
            LOG.error('Error sending events', e_2);
            return [3 /*break*/, 5];
          case 4:
            flushInProgress = false;
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function continueFlush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request, eventStoreIterator, _a, value, done, event_1, _b, success, retry, status;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4 /*yield*/, callIdService()];
          case 1:
            _c.sent();
            request = newEmitterRequestWithConfig();
            eventStoreIterator = eventStore.iterator();
            _c.label = 2;
          case 2:
            if (request.isFull()) {
              return [3 /*break*/, 4];
            }
            return [4 /*yield*/, eventStoreIterator.next()];
          case 3:
            _a = _c.sent(), value = _a.value, done = _a.done;
            if (done || value === undefined) {
              return [3 /*break*/, 4];
            }
            event_1 = newEmitterEvent(value);
            if (!request.addEvent(event_1)) {
              return [3 /*break*/, 4];
            }
            return [3 /*break*/, 2];
          case 4:
            if (request.countEvents() === 0) {
              return [2 /*return*/];
            }
            return [4 /*yield*/, executeRequest(request)];
          case 5:
            _b = _c.sent(), success = _b.success, retry = _b.retry, status = _b.status;
            if (!(success || !retry)) return [3 /*break*/, 7];
            if (!success) {
              LOG.error("Status ".concat(status, ", will not retry."));
            }
            return [4 /*yield*/, eventStore.removeHead(request.countEvents())];
          case 6:
            _c.sent();
            _c.label = 7;
          case 7:
            if (!success) return [3 /*break*/, 9];
            return [4 /*yield*/, continueFlush()];
          case 8:
            _c.sent();
            _c.label = 9;
          case 9:
            return [2 /*return*/];
        }
      });
    });
  }
  function input(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var eventStorePayload, event, request, count;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            eventStorePayload = newEventStorePayload({
              payload: payload,
              svrAnon: serverAnonymization
            });
            event = newEmitterEvent(eventStorePayload);
            if (!shouldSkipEventStore(event)) return [3 /*break*/, 2];
            request = newEmitterRequestWithConfig();
            request.addEvent(event);
            return [4 /*yield*/, executeRequest(request)];
          case 1:
            _a.sent();
            return [3 /*break*/, 5];
          case 2:
            return [4 /*yield*/, eventStore.add(eventStorePayload)];
          case 3:
            count = _a.sent();
            if (!(count >= bufferSize)) return [3 /*break*/, 5];
            return [4 /*yield*/, flush()];
          case 4:
            _a.sent();
            _a.label = 5;
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function setCollectorUrl(url) {
    endpoint = url;
  }
  function setAnonymousTracking(at) {
    serverAnonymization = at;
  }
  function setBufferSize(bs) {
    bufferSize = bs;
  }
  return {
    flush: flush,
    input: input,
    setCollectorUrl: setCollectorUrl,
    setAnonymousTracking: setAnonymousTracking,
    setBufferSize: setBufferSize
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var version = version$1;


/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node;
  var clockseq = options.clockseq;

  // v1 only: Use cached `node` and `clockseq` values
  if (!options._v6) {
    if (!node) {
      node = _nodeId;
    }
    if (clockseq == null) {
      clockseq = _clockseq;
    }
  }

  // Handle cases where we need entropy.  We do this lazily to minimize issues
  // related to insufficient system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    // Randomize node
    if (node == null) {
      node = [seedBytes[0], seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];

      // v1 only: cache node value for reuse
      if (!_nodeId && !options._v6) {
        // per RFC4122 4.5: Set MAC multicast bit (v1 only)
        node[0] |= 0x01; // Set multicast bit

        _nodeId = node;
      }
    }

    // Randomize clockseq
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
      if (_clockseq === undefined && !options._v6) {
        _clockseq = clockseq;
      }
    }
  }

  // v1 & v6 timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so time is
  // handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : Date.now();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }
  return buf || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(b);
}
/* harmony default export */ __webpack_exports__["a"] = (v1);

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = v1ToV6;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



/**
 * Convert a v1 UUID to a v6 UUID
 *
 * @param {string|Uint8Array} uuid - The v1 UUID to convert to v6
 * @returns {string|Uint8Array} The v6 UUID as the same type as the `uuid` arg
 * (string or Uint8Array)
 */
function v1ToV6(uuid) {
  var v1Bytes = typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse_js__["a" /* default */])(uuid) : uuid;
  var v6Bytes = _v1ToV6(v1Bytes);
  return typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(v6Bytes) : v6Bytes;
}

// Do the field transformation needed for v1 -> v6
function _v1ToV6(v1Bytes) {
  var randomize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Uint8Array.of((v1Bytes[6] & 0x0f) << 4 | v1Bytes[7] >> 4 & 0x0f, (v1Bytes[7] & 0x0f) << 4 | (v1Bytes[4] & 0xf0) >> 4, (v1Bytes[4] & 0x0f) << 4 | (v1Bytes[5] & 0xf0) >> 4, (v1Bytes[5] & 0x0f) << 4 | (v1Bytes[0] & 0xf0) >> 4, (v1Bytes[0] & 0x0f) << 4 | (v1Bytes[1] & 0xf0) >> 4, (v1Bytes[1] & 0x0f) << 4 | (v1Bytes[2] & 0xf0) >> 4, 0x60 | v1Bytes[2] & 0x0f, v1Bytes[3], v1Bytes[8], v1Bytes[9], v1Bytes[10], v1Bytes[11], v1Bytes[12], v1Bytes[13], v1Bytes[14], v1Bytes[15]);
}

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony export (immutable) */ __webpack_exports__["a"] = v35;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringify_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(4);


function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];
  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }
  return bytes;
}
var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }
    if (typeof namespace === 'string') {
      namespace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(namespace);
    }
    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    }

    // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`
    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;
    if (buf) {
      offset = offset || 0;
      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }
      return buf;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stringify_js__["a" /* unsafeStringify */])(bytes);
  }

  // Function#name is not settable on some platforms (#270)
  try {
    generateUUID.name = name;
  } catch (err) {}

  // For CommonJS default export support
  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {(function() {
  var crypt = __webpack_require__(46),
      utf8 = __webpack_require__(17).utf8,
      bin = __webpack_require__(17).bin,

  // The core
  sha1 = function (message) {
    // Convert to byte array
    if (message.constructor == String)
      message = utf8.stringToBytes(message);
    else if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();

    // otherwise assume byte array

    var m  = crypt.bytesToWords(message),
        l  = message.length * 8,
        w  = [],
        H0 =  1732584193,
        H1 = -271733879,
        H2 = -1732584194,
        H3 =  271733878,
        H4 = -1009589776;

    // Padding
    m[l >> 5] |= 0x80 << (24 - l % 32);
    m[((l + 64 >>> 9) << 4) + 15] = l;

    for (var i = 0; i < m.length; i += 16) {
      var a = H0,
          b = H1,
          c = H2,
          d = H3,
          e = H4;

      for (var j = 0; j < 80; j++) {

        if (j < 16)
          w[j] = m[i + j];
        else {
          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
          w[j] = (n << 1) | (n >>> 31);
        }

        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
                j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 :
                j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 :
                j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 :
                         (H1 ^ H2 ^ H3) - 899497514);

        H4 = H3;
        H3 = H2;
        H2 = (H1 << 30) | (H1 >>> 2);
        H1 = H0;
        H0 = t;
      }

      H0 += a;
      H1 += b;
      H2 += c;
      H3 += d;
      H4 += e;
    }

    return [H0, H1, H2, H3, H4];
  },

  // Public API
  api = function (message, options) {
    var digestbytes = crypt.wordsToBytes(sha1(message));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

  api._blocksize = 16;
  api._digestsize = 20;

  module.exports = api;
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackPsykhePdpView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackPsykhePlpView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackPsykhePlpClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackPsykheAddToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackPsykheTransaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



var tracker;
function initTracker() {
  if (!window.rcProps.enablePsykheTracking) {
    tracker = null;
  }
  if (tracker === undefined) {
    var PSYKHE_BASE_URL = 'https://api.psykhe.dev';
    var POST_PATH = '/v1/collector';
    var clientIdentifier = 'fwrd';
    var cookieName = '_psykhe_';
    var cookieDomain = document.location.hostname;
    var stateStorageStrategy = 'cookieAndLocalStorage';
    var _seedSnowplowDomainUs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["a" /* seedSnowplowDomainUserId */])(window.rcProps.browserId, {
        cookieName: cookieName,
        cookieDomain: cookieDomain,
        stateStorageStrategy: stateStorageStrategy
      }),
      seeded = _seedSnowplowDomainUs.seeded;
    tracker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker__["a" /* newTracker */])('psykhe-ai', PSYKHE_BASE_URL, {
      appId: clientIdentifier,
      appVersion: '1.0.0',
      postPath: POST_PATH,
      cookieName: '_psykhe_',
      cookieDomain: document.location.hostname,
      stateStorageStrategy: 'cookieAndLocalStorage',
      cookieSecure: true,
      cookieSameSite: 'Lax',
      keepalive: true,
      credentials: 'include',
      bufferSize: 1,
      contexts: {
        session: true,
        // mandatory session context
        webPage: true,
        // optional
        browser: true // optional
      },
      plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["b" /* PsykheSnowplowEcommercePlugin */])()]
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["c" /* setEcommerceUser */])({
      is_guest: window.rcProps.isGuest,
      id: window.rcProps.userId
    });
  }
  return tracker;
}
var trackPsykhePdpView = function trackPsykhePdpView(code, name, price) {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["d" /* trackProductView */])({
      product_id: code,
      variant_id: code,
      name: name,
      price: price,
      currency: 'USD'
    });
  }
};
var trackPsykhePlpView = function trackPsykhePlpView() {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["e" /* trackProductListView */])({
      name: window.rcProps.plp.psykheCategory,
      products: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-plp-container').toArray().map(function (el, index) {
        var $el = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(el);
        var code = $el.attr('id');
        return {
          product_id: code,
          variant_id: code,
          name: $el.data('product-name'),
          price: parseFloat($el.data('priceUsd')),
          currency: 'USD',
          position: index + 1
        };
      })
    });
  }
};
var trackPsykhePlpClick = function trackPsykhePlpClick($plpContainer) {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["f" /* trackListClick */])({
      productList: window.rcProps.plp.psykheCategory,
      product: {
        product_id: $plpContainer.attr('id'),
        variant_id: $plpContainer.attr('id'),
        name: $plpContainer.data('product-name'),
        price: parseFloat($plpContainer.data('priceUsd')),
        currency: 'USD',
        position: _toConsumableArray($plpContainer.parent().children()).indexOf($plpContainer[0]) + 1
      }
    });
  }
};
var trackPsykheAddToCart = function trackPsykheAddToCart(code, atbResponse) {
  if (initTracker() && atbResponse) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["g" /* trackAddToCart */])({
      cart_id: window.rcProps.browserId,
      total_value: parseFloat(atbResponse.msg33),
      currency: 'USD',
      products: [{
        product_id: code,
        variant_id: code,
        name: atbResponse.msg31,
        price: parseFloat(atbResponse.msg15),
        currency: 'USD',
        quantity: 1
      }]
    });
  }
};
var trackPsykheTransaction = function trackPsykheTransaction(transaction) {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["h" /* trackTransaction */])(transaction);
  }
};

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plp_manage_refine_menu__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pdp_bis_and_so__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_wishlist__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_init_side_panel__ = __webpack_require__(76);





window.rcProps.setupBisAndSo = __WEBPACK_IMPORTED_MODULE_2__pdp_bis_and_so__["a" /* default */];
window.initWishlist = initWishlist;
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  initWishlist(true);
});
function initWishlist(refineMenuRequired) {
  if (refineMenuRequired) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__modules_init_side_panel__["a" /* initSidePanel */])();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bis-and-so-link').click(function (e) {
    e.preventDefault();
    var link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: link,
      triggerOpen: true,
      type: 'full',
      onComplete: window.rcProps.setupBisAndSo
    });
  });
}

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addToBag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_psykhe__ = __webpack_require__(20);


function addToBag(productcode, size, returnElement, showConfirmation, addlData) {
  if (size == undefined || size == '') {
    return;
  }
  if (window.hasReachedBagLimit(productcode, size, 1)) {
    return;
  }
  if (typeof window.gaAddToCartActionWithAjax === 'function') {
    window.gaAddToCartActionWithAjax('add', productcode, size, 1);
  }
  insertCordialAddToBagFromDisplayProduct(productcode, size);
  if (typeof insertFacebookAddToCart === 'function') {
    window.insertFacebookAddToCart(productcode, null);
  }
  if (typeof insertTiktokAddToCart === "function") {
    insertTiktokAddToCart(productcode);
  }
  if (typeof iPinYouAddtoCart === 'function') {
    window.iPinYouAddtoCart(productcode);
  }
  if (typeof insertCriteoAddToCart === 'function') {
    insertCriteoAddToCart(productcode);
  }
  if (typeof insertKakaoAddToCart === 'function') {
    insertKakaoAddToCart(productcode);
  }
  if (typeof insertRTBHouseAddToCart === 'function') {
    insertRTBHouseAddToCart(productcode);
  }
  if (typeof insertTaboolaAddToCart === 'function') {
    insertTaboolaAddToCart("add", productcode);
  }
  if (typeof brazeAddToCart === 'function') {
    if (window.rcProps && window.rcProps.pdp) {
      brazeAddToCart('add', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
    } else if (addlData) {
      brazeAddToCart('add', productcode, addlData.name, size, addlData.imageurl, addlData.pdpurl, addlData.price, addlData.currency, addlData.department, addlData.color, addlData.brand, addlData.category, addlData.cat1);
    }
  }
  var pdpData = window.rcProps.pdp || {};
  var isMens = pdpData.d == 'Mens';
  var dept = window.rcProps && window.rcProps.department ? window.rcProps.department : "";
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    colorSelect: productcode,
    sizeSelect: size,
    isMens: isMens,
    count: 1,
    d: dept,
    sectionURL: pdpData.sectionURL
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/AddItemToBag.jsp", data, function (res) {
    var result = parseRtn(res);
    if (result && result.reCAPTCHA) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: "/fw/dialog/VerifyHuman.jsp?mobile=true",
        type: "full",
        open: null,
        cache: false,
        overlayClose: true,
        closeButton: false,
        triggerOpen: true,
        onClose: function onClose() {
          if (window.rcProps && typeof window.rcProps.ReCAPTCHARestore == 'function') {
            window.rcProps.ReCAPTCHARestore();
            window.rcProps.ReCAPTCHARestore = "";
          }
        }
      });
      return;
    }
    if (typeof window.insertPageTrackForMobile === 'function') {
      window.insertPageTrackForMobile(true);
    }
    if (showConfirmation === undefined || showConfirmation === true) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#product-added-confirmation-container').length) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get("/fw/content/product/productAddedConfirmationModal", {
          code: productcode,
          size: size
        }, function (markup) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-added-confirmation-container").html(markup);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            open: "product-added-confirmation",
            triggerOpen: true,
            triggerElement: returnElement ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(returnElement.target) : null,
            onOpen: function onOpen() {
              var dataType = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-added-confirmation").data('type');
              if (dataType === 'toast') {
                var jsCarouselCtlAtb = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-carousel-ctl-atb");
                jsCarouselCtlAtb.not('.slick-initialized').slick({
                  arrows: false,
                  lazyLoad: 'ondemand',
                  slidesToShow: 3,
                  slidesToScroll: 2,
                  accessibility: true
                });
              }
            }
          });
        });
      } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#top-modal').length > 0) {
        //wishlist.jsp page
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: 'top-modal',
          triggerOpen: true
        });
      } else if (window.rcProps.shoppingBag) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('shoppingbag.wishlist.added.to.bag');
      }
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: "POST",
      url: "/fw/mobile/AjaxUserShoppingBag.jsp",
      success: function success(response) {
        var responseObj = eval('(' + response + ')');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shopping_bag_count").html(responseObj);
        if (typeof insertGoogleRemarketingAddToCart === 'function') {
          insertGoogleRemarketingAddToCart();
        }
        if (typeof addToCartYahoo === 'function') {
          addToCartYahoo(productcode);
        }
      }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_psykhe__["b" /* trackPsykheAddToCart */])(productcode, result);
  });
}
function insertCordialAddToBagFromDisplayProduct(code, size) {
  var pdpData = window.rcProps.pdp || {};
  var cartItems = new Array();
  var cartItem = {};
  cartItem.productCode = code;
  cartItem.productName = pdpData.productName;
  cartItem.productCategory = pdpData.categoryName;
  cartItem.brandName = pdpData.brandName;
  cartItem.price = pdpData.price;
  cartItem.images = [pdpData.imageUrl];
  cartItem.size = size;
  cartItem.description = pdpData.description;
  cartItem.url = pdpData.url;
  cartItem.department = pdpData.department;
  cartItem.cat1 = pdpData.cat1;
  cartItems.push(cartItem);
  if (typeof window.insertCordialAddToCart === 'function') {
    window.insertCordialAddToCart(cartItems);
  }
}

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PsykheSnowplowEcommercePlugin;
/* unused harmony export trackCheckoutStep */
/* harmony export (immutable) */ __webpack_exports__["d"] = trackProductListView;
/* harmony export (immutable) */ __webpack_exports__["c"] = trackProductView;
/* harmony export (immutable) */ __webpack_exports__["e"] = trackListClick;
/* unused harmony export trackSiteSearch */
/* harmony export (immutable) */ __webpack_exports__["f"] = trackAddToCart;
/* unused harmony export trackRemoveFromCart */
/* harmony export (immutable) */ __webpack_exports__["g"] = trackTransaction;
/* unused harmony export trackRefund */
/* unused harmony export trackProductDwellTime */
/* unused harmony export setPageType */
/* harmony export (immutable) */ __webpack_exports__["b"] = setEcommerceUser;
/* unused harmony export withRecommendIdCtx */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schemata_js__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["context", "timestamp"],
  _excluded2 = ["context", "timestamp"],
  _excluded3 = ["context", "timestamp", "resultProducts"],
  _excluded4 = ["context", "timestamp", "products"],
  _excluded5 = ["context", "timestamp", "products"],
  _excluded6 = ["context", "timestamp", "products"],
  _excluded7 = ["context", "timestamp", "products"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }



var _trackers = {};
/* Scheduled to include Page and User */
var _context = {};
/**
 * Adds ecommerce tracking
 */
function PsykheSnowplowEcommercePlugin() {
  var trackerId;
  return {
    activateBrowserPlugin: function activateBrowserPlugin(tracker) {
      trackerId = tracker.id;
      _trackers[trackerId] = tracker;
      _context[trackerId] = [];
    },
    contexts: function contexts() {
      return _context[trackerId] || [];
    }
  };
}
/**
 * Track a checkout step
 *
 * @param checkoutStep - The checkout step index and the attributes the user filled in.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackCheckoutStep(checkoutStep) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _checkoutStep$context = checkoutStep.context,
    context = _checkoutStep$context === void 0 ? [] : _checkoutStep$context,
    timestamp = checkoutStep.timestamp,
    checkoutStepAttributes = _objectWithoutProperties(checkoutStep, _excluded);
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["a" /* CHECKOUT_STEP_SCHEMA */],
    data: _objectSpread({}, checkoutStepAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'checkout_step'
    }), context, timestamp);
  });
}
/**
 * Track a product list view
 *
 * @param listView - The list name along with the products which were viewed by the visitor.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackProductListView(listView) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _listView$context = listView.context,
    context = _listView$context === void 0 ? [] : _listView$context,
    timestamp = listView.timestamp,
    _listView$products = listView.products,
    products = _listView$products === void 0 ? [] : _listView$products,
    name = listView.name;
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'list_view',
      name: name
    }), context, timestamp);
  });
}
/**
 * Track a product view/detail
 *
 * @param productView - The product which was viewed in a product detail page.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackProductView(productView) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _productView$context = productView.context,
    context = _productView$context === void 0 ? [] : _productView$context,
    timestamp = productView.timestamp,
    product = _objectWithoutProperties(productView, _excluded2);
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
    data: _objectSpread({}, product)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'product_view'
    }), context, timestamp);
  });
}
function trackListClick(listClickEvent) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _listClickEvent$conte = listClickEvent.context,
    context = _listClickEvent$conte === void 0 ? [] : _listClickEvent$conte,
    timestamp = listClickEvent.timestamp,
    productList = listClickEvent.productList,
    product = listClickEvent.product;
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
    data: _objectSpread({}, product)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'list_click',
      name: productList
    }), context, timestamp);
  });
}
/**
 * Track site search
 *
 * @param siteSearch - The search which was requested by the visitor.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackSiteSearch(siteSearch) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _siteSearch$context = siteSearch.context,
    context = _siteSearch$context === void 0 ? [] : _siteSearch$context,
    timestamp = siteSearch.timestamp,
    _siteSearch$resultPro = siteSearch.resultProducts,
    resultProducts = _siteSearch$resultPro === void 0 ? [] : _siteSearch$resultPro,
    search = _objectWithoutProperties(siteSearch, _excluded3);
  resultProducts.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["c" /* SEARCH_SCHEMA */],
    data: _objectSpread({}, search)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'site_search'
    }), context, timestamp);
  });
}
/**
 * Track a product addition to cart
 *
 * @param cart - The product/s which was/were added to the cart and the total value of the cart after the product was added.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackAddToCart(cart) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _cart$context = cart.context,
    context = _cart$context === void 0 ? [] : _cart$context,
    timestamp = cart.timestamp,
    _cart$products = cart.products,
    products = _cart$products === void 0 ? [] : _cart$products,
    cartAttributes = _objectWithoutProperties(cart, _excluded4);
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["d" /* CART_SCHEMA */],
    data: _objectSpread({}, cartAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'add_to_cart'
    }), context, timestamp);
  });
}
/**
 * Track removal of products from cart
 *
 * @param cart - The product/s which were removed from the cart and the total value of the cart after the product was removed.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackRemoveFromCart(cart) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _cart$context2 = cart.context,
    context = _cart$context2 === void 0 ? [] : _cart$context2,
    timestamp = cart.timestamp,
    _cart$products2 = cart.products,
    products = _cart$products2 === void 0 ? [] : _cart$products2,
    cartAttributes = _objectWithoutProperties(cart, _excluded5);
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["d" /* CART_SCHEMA */],
    data: _objectSpread({}, cartAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'remove_from_cart'
    }), context, timestamp);
  });
}
/**
 * Track a transaction event
 *
 * @param transaction - The transaction information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackTransaction(transaction) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var totalQuantity = 0;
  var _transaction$context = transaction.context,
    context = _transaction$context === void 0 ? [] : _transaction$context,
    timestamp = transaction.timestamp,
    _transaction$products = transaction.products,
    products = _transaction$products === void 0 ? [] : _transaction$products,
    transactionAttributes = _objectWithoutProperties(transaction, _excluded6);
  products.forEach(function (product) {
    /* If `total_quantity` is not provided, we calculate it from individual product quantities. */
    if (product.quantity) {
      totalQuantity += product.quantity;
    }
    context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: product
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["e" /* TRANSACTION_SCHEMA */],
    data: _objectSpread({
      total_quantity: totalQuantity || undefined
    }, transactionAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'transaction'
    }), context, timestamp);
  });
}
/**
 * Track a refund event
 *
 * @param refund - The refund information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackRefund(refund) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _refund$context = refund.context,
    context = _refund$context === void 0 ? [] : _refund$context,
    timestamp = refund.timestamp,
    _refund$products = refund.products,
    products = _refund$products === void 0 ? [] : _refund$products,
    refundAttributes = _objectWithoutProperties(refund, _excluded7);
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: product
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["f" /* REFUND_SCHEMA */],
    data: _objectSpread({}, refundAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'refund'
    }), context, timestamp);
  });
}
function trackProductDwellTime(productDwellTime) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _productDwellTime$con = productDwellTime.context,
    context = _productDwellTime$con === void 0 ? [] : _productDwellTime$con,
    timestamp = productDwellTime.timestamp;
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
    data: _objectSpread({}, productDwellTime.product)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["b" /* buildDwellTimeEvent */])({
      type: productDwellTime.pageType,
      duration: productDwellTime.duration
    }), context, timestamp);
  });
}
/**
 * Set Ecommerce Page context
 *
 * @param context - The ecommerce page context to be stored
 * @param trackers - The tracker identifiers which the context will be stored
 */
function setPageType(context) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var type = context.type,
    language = context.language,
    locale = context.locale;
  trackers.forEach(function (trackerId) {
    if (_context[trackerId]) {
      _context[trackerId] = removeContext(_context[trackerId], __WEBPACK_IMPORTED_MODULE_2__schemata_js__["g" /* PAGE_SCHEMA */]);
      _context[trackerId].push({
        schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["g" /* PAGE_SCHEMA */],
        data: {
          type: type,
          language: language,
          locale: locale
        }
      });
    }
  });
}
/**
 * Set Ecommerce User context
 *
 * @param context - The ecommerce user context to be stored
 * @param trackers - The tracker identifiers which the context will be stored
 */
function setEcommerceUser(context) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var id = context.id,
    is_guest = context.is_guest,
    email = context.email;
  trackers.forEach(function (trackerId) {
    if (_context[trackerId]) {
      _context[trackerId] = removeContext(_context[trackerId], __WEBPACK_IMPORTED_MODULE_2__schemata_js__["h" /* USER_SCHEMA */]);
      _context[trackerId].push({
        schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["h" /* USER_SCHEMA */],
        data: {
          id: id,
          is_guest: is_guest,
          email: email
        }
      });
    }
  });
}
/**
 * Attaches a recommendation ID context for events coming from PSYKHE AI.
 * This should be used when tracking user interaction with products returned
 * by PSYKHE recommendations or search results to support downstream attribution.
 *
 * @param recommendationId - The identifier of the recommendation session.
 * @returns A context object to be passed in the `context` array of tracking events.
 */
function withRecommendIdCtx(recommendationId) {
  return {
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["i" /* PSYKHE_RECOMMENDATIONS_SCHEMA */],
    data: {
      id: recommendationId
    }
  };
}
/**
 * Return a new array with the context matching the `schemaToRemove` removed from the array.
 * Used in cases where we want only one type of the said context on the context array for a tracker.
 */
function removeContext(trackerContext, schemaToRemove) {
  return trackerContext.filter(function (context) {
    return context.schema !== schemaToRemove;
  });
}

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildEcommerceActionEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildDwellTimeEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schemata_js__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Build an Ecommerce Action Event
 * For tracking ecommerce actions
 *
 * @param event - Contains the properties for Cart related events
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceActionEvent(event) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["g" /* buildSelfDescribingEvent */])({
    event: {
      schema: __WEBPACK_IMPORTED_MODULE_1__schemata_js__["j" /* ECOMMERCE_ACTION_SCHEMA */],
      data: removeEmptyProperties(_objectSpread({}, event))
    }
  });
}
function buildDwellTimeEvent(event) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["g" /* buildSelfDescribingEvent */])({
    event: {
      schema: __WEBPACK_IMPORTED_MODULE_1__schemata_js__["k" /* PSYKHE_PRODUCT_DWELL_TIME_SCHEMA */],
      data: removeEmptyProperties(_objectSpread({}, event))
    }
  });
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - Object to clean
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event) {
  var ret = {};
  for (var k in event) {
    if (event[k] !== null && typeof event[k] !== 'undefined') {
      ret[k] = event[k];
    }
  }
  return ret;
}

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = seedSnowplowDomainUserId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sha1__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__ = __webpack_require__(11);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var DEFAULT_COOKIE_NAME = '_sp_';
var DEFAULT_COOKIE_PATH = '/';
var DEFAULT_COOKIE_SAME_SITE = 'Lax';
var DEFAULT_COOKIE_SECURE = true;
var DEFAULT_VISITOR_COOKIE_TIMEOUT = 63072000;
var DEFAULT_SESSION_COOKIE_TIMEOUT = 1800;
// Mirrors Snowplow Browser Tracker 4.5.0 internals:
// - state key naming from `getSnowplowCookieName` in tracker/index.ts
// - id value shape from `parseIdCookie` in tracker/id_cookie.ts
// Re-check those files when upgrading @snowplow/browser-tracker-core.
// https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/index.ts
// https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts
/**
 * Seeds Snowplow's first-party visitor state before `newTracker` runs so the
 * browser tracker reuses a caller-provided domain_userid.
 */
function seedSnowplowDomainUserId(domainUserId) {
  var _options$stateStorage, _options$cookieName, _options$cookieSameSi, _options$cookieSecure, _options$discoverRoot, _options$cookieLifeti, _options$sessionCooki;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  assertBrowserEnvironment();
  assertValidDomainUserId(domainUserId);
  var stateStorageStrategy = (_options$stateStorage = options.stateStorageStrategy) !== null && _options$stateStorage !== void 0 ? _options$stateStorage : 'cookieAndLocalStorage';
  if (stateStorageStrategy === 'none') {
    return {
      seeded: false,
      storage: 'none'
    };
  }
  var cookieNamePrefix = (_options$cookieName = options.cookieName) !== null && _options$cookieName !== void 0 ? _options$cookieName : DEFAULT_COOKIE_NAME;
  // Falsy fallback (not nullish), matching Snowplow's `configCookiePath || '/'`: an empty
  // cookiePath must coerce to '/', otherwise the domain hash diverges from newTracker().
  var cookiePath = options.cookiePath || DEFAULT_COOKIE_PATH;
  var cookieSameSite = (_options$cookieSameSi = options.cookieSameSite) !== null && _options$cookieSameSi !== void 0 ? _options$cookieSameSi : DEFAULT_COOKIE_SAME_SITE;
  var cookieSecure = (_options$cookieSecure = options.cookieSecure) !== null && _options$cookieSecure !== void 0 ? _options$cookieSecure : DEFAULT_COOKIE_SECURE;
  // Mirror Snowplow's resolution exactly: discover the root domain only when the caller left
  // cookieDomain falsy (undefined or ''), via the same `&& !configCookieDomain` guard.
  var discoverRootDomain = (_options$discoverRoot = options.discoverRootDomain) !== null && _options$discoverRoot !== void 0 ? _options$discoverRoot : options.cookieDomain === undefined;
  var cookieDomain = options.cookieDomain;
  if (discoverRootDomain && !cookieDomain) {
    cookieDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["a" /* findRootDomain */])(cookieSameSite, cookieSecure);
  }
  // Snowplow hashes `(configCookieDomain || domainAlias) + (configCookiePath || '/')`, where
  // domainAlias is the fixupUrl-normalized hostname (handles translate/cache hosts), not the raw one.
  var domainAlias = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["b" /* fixupDomain */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["c" /* fixupUrl */])(window.location.hostname, window.location.href, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["d" /* getReferrer */])())[0]);
  var domainHash = __WEBPACK_IMPORTED_MODULE_0_sha1___default()("".concat(cookieDomain || domainAlias).concat(cookiePath)).slice(0, 4);
  var idStateName = "".concat(cookieNamePrefix, "id.").concat(domainHash);
  var sessionStateName = "".concat(cookieNamePrefix, "ses.").concat(domainHash);
  var storage = stateStorageStrategy === 'localStorage' ? 'localStorage' : 'cookie';
  if (!options.overwriteExisting && getStateValue(idStateName, storage)) {
    return {
      seeded: false,
      storage: storage,
      idStateName: idStateName,
      sessionStateName: sessionStateName
    };
  }
  var state = buildInitialSnowplowState(domainUserId);
  var visitorTtl = (_options$cookieLifeti = options.cookieLifetime) !== null && _options$cookieLifeti !== void 0 ? _options$cookieLifeti : DEFAULT_VISITOR_COOKIE_TIMEOUT;
  var sessionTtl = (_options$sessionCooki = options.sessionCookieTimeout) !== null && _options$sessionCooki !== void 0 ? _options$sessionCooki : DEFAULT_SESSION_COOKIE_TIMEOUT;
  var idStateSeeded;
  var sessionStateSeeded;
  if (storage === 'localStorage') {
    idStateSeeded = writeLocalStorage(idStateName, state.idCookie, visitorTtl);
    sessionStateSeeded = writeLocalStorage(sessionStateName, '*', sessionTtl);
  } else {
    var cookieOptions = {
      ttl: visitorTtl,
      path: cookiePath,
      domain: cookieDomain,
      sameSite: cookieSameSite,
      secure: cookieSecure
    };
    var sessionCookieOptions = _objectSpread(_objectSpread({}, cookieOptions), {}, {
      ttl: sessionTtl
    });
    idStateSeeded = writeCookie(idStateName, state.idCookie, cookieOptions);
    sessionStateSeeded = writeCookie(sessionStateName, '*', sessionCookieOptions);
  }
  var seeded = idStateSeeded && sessionStateSeeded;
  return {
    seeded: seeded,
    storage: storage,
    idStateName: idStateName,
    sessionStateName: sessionStateName
  };
}
function buildInitialSnowplowState(domainUserId) {
  var nowTs = Math.round(Date.now() / 1000);
  // Snowplow uses `uuid` v4 for generated domain/session/page identifiers.
  // We use the same package so the seeded session id matches Snowplow's format.
  // https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts#L32
  var sessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_uuid__["a" /* v4 */])();
  // This is the serialized form produced by Snowplow's `serializeIdCookie`.
  // It intentionally excludes the leading "cookies enabled" marker, because
  // Snowplow adds that only while parsing the persisted value.
  // Source:
  // https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts#L62-L135
  // https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts#L245-L253
  var parsedIdCookie = ['0',
  // cookieDisabled: "0" means storage is enabled
  domainUserId, nowTs, 1, nowTs, undefined, sessionId, '', '', undefined, 0];
  return {
    idCookie: parsedIdCookie.slice(1).join('.')
  };
}
function getStateValue(name, storage) {
  if (storage === 'localStorage') {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["e" /* attemptGetLocalStorage */])(name);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["f" /* cookie */])(name);
}
function writeLocalStorage(name, value, ttl) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["g" /* attemptWriteLocalStorage */])(name, value, ttl);
}
function writeCookie(name, value, options) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["f" /* cookie */])(name, value, options.ttl, options.path, options.domain, options.sameSite, options.secure);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["f" /* cookie */])(name) === value;
}
function assertBrowserEnvironment() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    throw new Error('seedSnowplowDomainUserId must be called in a browser before Snowplow newTracker is initialized.');
  }
}
function assertValidDomainUserId(domainUserId) {
  if (!domainUserId) {
    throw new Error('Snowplow domain_userid must not be empty.');
  }
  if (domainUserId.includes('.')) {
    throw new Error('Snowplow domain_userid must not contain dots because Snowplow stores it in a dot-delimited value.');
  }
  if (/[\s;]/.test(domainUserId)) {
    throw new Error('Snowplow domain_userid must not contain whitespace or semicolons.');
  }
}

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_js__ = __webpack_require__(25);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_user_id_js__ = __webpack_require__(27);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__domain_user_id_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(29);
/* unused harmony namespace reexport */




/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageType */
var PageType;
(function (PageType) {
  // Product List Page / collection page
  PageType["PLP"] = "plp";
  // Product Detail Page
  PageType["PDP"] = "pdp";
})(PageType || (PageType = {}));

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__max_js__ = __webpack_require__(31);
/* unused harmony reexport MAX */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nil_js__ = __webpack_require__(34);
/* unused harmony reexport NIL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_js__ = __webpack_require__(4);
/* unused harmony reexport parse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringify_js__ = __webpack_require__(1);
/* unused harmony reexport stringify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__v1_js__ = __webpack_require__(14);
/* unused harmony reexport v1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__v1ToV6_js__ = __webpack_require__(15);
/* unused harmony reexport v1ToV6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__v3_js__ = __webpack_require__(37);
/* unused harmony reexport v3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__v4_js__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__v5_js__ = __webpack_require__(39);
/* unused harmony reexport v5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__v6_js__ = __webpack_require__(40);
/* unused harmony reexport v6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__v6ToV1_js__ = __webpack_require__(41);
/* unused harmony reexport v6ToV1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__v7_js__ = __webpack_require__(42);
/* unused harmony reexport v7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validate_js__ = __webpack_require__(5);
/* unused harmony reexport validate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__version_js__ = __webpack_require__(43);
/* unused harmony reexport version */















/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addGlobalContexts */
/* unused harmony export addPlugin */
/* unused harmony export clearGlobalContexts */
/* unused harmony export clearUserData */
/* unused harmony export crossDomainLinker */
/* unused harmony export disableActivityTracking */
/* unused harmony export disableActivityTrackingCallback */
/* unused harmony export disableAnonymousTracking */
/* unused harmony export discardBrace */
/* unused harmony export discardHashTag */
/* unused harmony export enableActivityTracking */
/* unused harmony export enableActivityTrackingCallback */
/* unused harmony export enableAnonymousTracking */
/* unused harmony export flushBuffer */
/* unused harmony export newSession */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newTracker; });
/* unused harmony export preservePageViewId */
/* unused harmony export removeGlobalContexts */
/* unused harmony export setBufferSize */
/* unused harmony export setCollectorUrl */
/* unused harmony export setCookiePath */
/* unused harmony export setCustomUrl */
/* unused harmony export setDocumentTitle */
/* unused harmony export setOptOutCookie */
/* unused harmony export setReferrerUrl */
/* unused harmony export setUserId */
/* unused harmony export setUserIdFromCookie */
/* unused harmony export setUserIdFromLocation */
/* unused harmony export setUserIdFromReferrer */
/* unused harmony export setVisitorCookieTimeout */
/* unused harmony export trackPageView */
/* unused harmony export trackSelfDescribingEvent */
/* unused harmony export trackStructEvent */
/* unused harmony export updatePageActivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__ = __webpack_require__(12);
/* unused harmony reexport SharedState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__ = __webpack_require__(8);
/* unused harmony reexport version */
/*!
 * Browser tracker for Snowplow v4.8.2 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */






/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Expires current session and starts a new session.
 *
 * @param trackers - The tracker identifiers which will have their session refreshed
 */
function newSession(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.newSession();
  });
}
/**
 * Override referrer
 *
 * @param url - Custom Referrer which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setReferrerUrl(url, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setReferrerUrl(url);
  });
}
/**
 * Override url
 *
 * @param url - Custom URL which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setCustomUrl(url, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setCustomUrl(url);
  });
}
/**
 * Override document.title
 *
 * @param title - Document title which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setDocumentTitle(title, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setDocumentTitle(title);
  });
}
/**
 * Strip hash tag (or anchor) from URL
 *
 * @param enable - Whether to enable stripping of hash
 * @param trackers - The tracker identifiers which will be configured
 */
function discardHashTag(enable, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.discardHashTag(enable);
  });
}
/**
 * Strip braces from URL
 *
 * @param enable - Whther to enable stripping of braces
 * @param trackers - The tracker identifiers which will be configured
 */
function discardBrace(enable, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.discardBrace(enable);
  });
}
/**
 * Set first-party cookie path
 *
 * @param path - The path which will be used when setting cookies
 * @param trackers - The tracker identifiers which will be configured
 */
function setCookiePath(path, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setCookiePath(path);
  });
}
/**
 * Set visitor cookie timeout (in seconds)
 *
 * @param timeout - The timeout until cookies will expire
 * @param trackers - The tracker identifiers which will be configured
 */
function setVisitorCookieTimeout(timeout, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setVisitorCookieTimeout(timeout);
  });
}
/**
 * Enable querystring decoration for links passing a filter
 *
 * @param crossDomainLinker - Function used to determine which links to decorate
 * @param trackers - The tracker identifiers which will be configured
 */
function crossDomainLinker(crossDomainLinkerCriterion, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.crossDomainLinker(crossDomainLinkerCriterion);
  });
}
/**
 * Enables page activity tracking (sends page pings to the Collector regularly).
 *
 * @param configuration - The activity tracking configuration
 * @param trackers - The tracker identifiers which will be configured
 */
function enableActivityTracking(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.enableActivityTracking(configuration);
  });
}
/**
 * Enables page activity tracking (replaces collector ping with callback).
 *
 * @param configuration - The activity tracking callback configuration
 * @param trackers - The tracker identifiers which will be configured
 */
function enableActivityTrackingCallback(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.enableActivityTrackingCallback(configuration);
  });
}
/**
 * Disables page activity tracking.
 *
 * @param trackers - The tracker identifiers the activity tracking will be disabled.
 */
function disableActivityTracking(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.disableActivityTracking();
  });
}
/**
 * Disables page activity tracking callback.
 *
 * @param trackers - The tracker identifiers the activity tracking callback will be disabled.
 */
function disableActivityTrackingCallback(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.disableActivityTrackingCallback();
  });
}
/**
 * Triggers the activityHandler manually to allow external user defined activity. i.e. While watching a video
 *
 * @param trackers - The tracker identifiers which will be updated
 */
function updatePageActivity(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.updatePageActivity();
  });
}
/**
 * Sets the opt out cookie.
 *
 * @param name - of the opt out cookie
 * @param trackers - The tracker identifiers which will be configured
 */
function setOptOutCookie(name, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setOptOutCookie(name);
  });
}
/**
 * Set the business-defined user ID for this user.
 *
 * @param userId - The business-defined user ID
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserId(userId, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserId(userId);
  });
}
/**
 * Set the business-defined user ID for this user using the location querystring.
 *
 * @param querystringField - Name of a querystring name-value pair
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromLocation(querystringField, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserIdFromLocation(querystringField);
  });
}
/**
 * Set the business-defined user ID for this user using the referrer querystring.
 *
 * @param querystringField - Name of a querystring name-value pair
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromReferrer(querystringField, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserIdFromReferrer(querystringField);
  });
}
/**
 * Set the business-defined user ID for this user to the value of a cookie.
 *
 * @param cookieName - Name of the cookie whose value will be assigned to businessUserId
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromCookie(cookieName, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserIdFromCookie(cookieName);
  });
}
/**
 * Specify the Snowplow collector URL. Specific http or https to force it
 * or leave it off to match the website protocol.
 *
 * @param collectorUrl - The collector URL, with or without protocol
 * @param trackers - The tracker identifiers which will be configured
 */
function setCollectorUrl(collectorUrl, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setCollectorUrl(collectorUrl);
  });
}
/**
 * Set the buffer size
 * Can be useful if you want to stop batching requests to ensure events start
 * sending closer to event creation
 *
 * @param newBufferSize - The value with which to update the bufferSize to
 * @param trackers - The tracker identifiers which will be flushed
 */
function setBufferSize(newBufferSize, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setBufferSize(newBufferSize);
  });
}
/**
 * Send all events in the outQueue
 * Only need to use this when sending events with a bufferSize of at least 2
 *
 * @param configuration - The configuration to use following flushing the buffer
 * @param trackers - The tracker identifiers which will be flushed
 */
function flushBuffer(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.flushBuffer(configuration);
  });
}
/**
 * Track a visit to a web page
 *
 * @param event - The Page View Event properties
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackPageView(event, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.trackPageView(event);
  });
}
/**
 * Track a structured event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - The Structured Event properties
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackStructEvent(event, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__["a" /* buildStructEvent */])(event), event.context, event.timestamp);
  });
}
/**
 * Track a self-describing event happening on this page.
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackSelfDescribingEvent(event, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__["b" /* buildSelfDescribingEvent */])({
      event: event.event
    }), event.context, event.timestamp);
  });
}
/**
 * All provided contexts will be sent with every event
 *
 * @param contexts - An array of contexts or conditional contexts
 * @param trackers - The tracker identifiers which the global contexts will be added to
 */
function addGlobalContexts(contexts, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.addGlobalContexts(contexts);
  });
}
/**
 * All provided contexts will no longer be sent with every event
 *
 * @param contexts - An array of contexts or conditional contexts
 * @param trackers - The tracker identifiers which the global contexts will be remove from
 */
function removeGlobalContexts(contexts, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.removeGlobalContexts(contexts);
  });
}
/**
 * Clear all global contexts that are sent with events
 *
 * @param trackers - The tracker identifiers which the global contexts will be cleared from
 */
function clearGlobalContexts(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.clearGlobalContexts();
  });
}
/**
 * Stop regenerating `pageViewId` (available from `web_page` context)
 *
 * @param trackers - The tracker identifiers which the event will preserve their Page View Ids
 */
function preservePageViewId(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.preservePageViewId();
  });
}
/**
 * Disables anonymous tracking if active (ie. tracker initialized with `anonymousTracking`)
 * For stateStorageStrategy override, uses supplied value first,
 * falls back to one defined in initial config, otherwise uses cookieAndLocalStorage.
 *
 * @param configuration - The configuration for disabling anonymous tracking
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function disableAnonymousTracking(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.disableAnonymousTracking(configuration);
  });
}
/**
 * Enables anonymous tracking (ie. tracker initialized without `anonymousTracking`)
 *
 * @param configuration - The configuration for enabling anonymous tracking
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function enableAnonymousTracking(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.enableAnonymousTracking(configuration);
  });
}
/**
 * Clears all cookies and local storage containing user and session identifiers
 *
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function clearUserData(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.clearUserData(configuration);
  });
}
/**
 * Add a plugin into the plugin collection after trackers have already been initialised
 *
 * @param configuration - The plugin to add
 * @param trackers - The tracker identifiers which the plugin will be added to
 */
function addPlugin(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.addPlugin(configuration);
  });
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var state = typeof window !== 'undefined' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["b" /* createSharedState */])() : undefined;
/**
 * Initialise a new tracker
 *
 * @param trackerId - The tracker id - also known as tracker namespace
 * @param endpoint - Collector endpoint in the form collector.mysite.com
 * @param configuration - The initialisation options of the tracker
 */
function newTracker(trackerId, endpoint, configuration) {
  if (state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["c" /* addTracker */])(trackerId, trackerId, "js-".concat(__WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__["c" /* version */]), endpoint, state, configuration);
  } else {
    return undefined;
  }
}


/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ('ffffffff-ffff-ffff-ffff-ffffffffffff');

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);
    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}

/*
 * Convert an array of little-endian words to an array of bytes
 */
function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';
  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }
  return output;
}

/**
 * Calculate output length with padding and bit length
 */
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;
  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }
  return output;
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ __webpack_exports__["a"] = ({
  randomUUID: randomUUID
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ('00000000-0000-0000-0000-000000000000');

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i);

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;
    case 1:
      return x ^ y ^ z;
    case 2:
      return x & y ^ x & z ^ y & z;
    case 3:
      return x ^ y ^ z;
  }
}
function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}
function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];
    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }
    M[_i] = arr;
  }
  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);
    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }
    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }
    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }
  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}
/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__(32);


var v3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v3);

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__native_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rng_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringify_js__ = __webpack_require__(1);



function v4(options, buf, offset) {
  if (__WEBPACK_IMPORTED_MODULE_0__native_js__["a" /* default */].randomUUID && !buf && !options) {
    return __WEBPACK_IMPORTED_MODULE_0__native_js__["a" /* default */].randomUUID();
  }
  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_1__rng_js__["a" /* default */])();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stringify_js__["a" /* unsafeStringify */])(rnds);
}
/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__(36);


var v5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v5);

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(5);

function parse(uuid) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }
  var v;
  var arr = new Uint8Array(16);

  // Parse ########-....-....-....-............
  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff;

  // Parse ........-####-....-....-............
  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff;

  // Parse ........-....-####-....-............
  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff;

  // Parse ........-....-....-####-............
  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff;

  // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}
/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringify_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v1_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v1ToV6_js__ = __webpack_require__(15);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}




/**
 *
 * @param {object} options
 * @param {Uint8Array=} buf
 * @param {number=} offset
 * @returns
 */
function v6() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var buf = arguments.length > 1 ? arguments[1] : undefined;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  // v6 is v1 with different field layout, so we start with a v1 UUID, albeit
  // with slightly different behavior around how the clock_seq and node fields
  // are randomized, which is why we call v1 with _v6: true.
  var bytes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__v1_js__["a" /* default */])(_objectSpread(_objectSpread({}, options), {}, {
    _v6: true
  }), new Uint8Array(16));

  // Reorder the fields to v6 layout.
  bytes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__v1ToV6_js__["a" /* default */])(bytes);

  // Return as a byte array if requested
  if (buf) {
    for (var i = 0; i < 16; i++) {
      buf[offset + i] = bytes[i];
    }
    return buf;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stringify_js__["a" /* unsafeStringify */])(bytes);
}

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



/**
 * Convert a v6 UUID to a v1 UUID
 *
 * @param {string|Uint8Array} uuid - The v6 UUID to convert to v6
 * @returns {string|Uint8Array} The v1 UUID as the same type as the `uuid` arg
 * (string or Uint8Array)
 */
function v6ToV1(uuid) {
  var v6Bytes = typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse_js__["a" /* default */])(uuid) : uuid;
  var v1Bytes = _v6ToV1(v6Bytes);
  return typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(v1Bytes) : v1Bytes;
}

// Do the field transformation needed for v6 -> v1
function _v6ToV1(v6Bytes) {
  return Uint8Array.of((v6Bytes[3] & 0x0f) << 4 | v6Bytes[4] >> 4 & 0x0f, (v6Bytes[4] & 0x0f) << 4 | (v6Bytes[5] & 0xf0) >> 4, (v6Bytes[5] & 0x0f) << 4 | v6Bytes[6] & 0x0f, v6Bytes[7], (v6Bytes[1] & 0x0f) << 4 | (v6Bytes[2] & 0xf0) >> 4, (v6Bytes[2] & 0x0f) << 4 | (v6Bytes[3] & 0xf0) >> 4, 0x10 | (v6Bytes[0] & 0xf0) >> 4, (v6Bytes[0] & 0x0f) << 4 | (v6Bytes[1] & 0xf0) >> 4, v6Bytes[8], v6Bytes[9], v6Bytes[10], v6Bytes[11], v6Bytes[12], v6Bytes[13], v6Bytes[14], v6Bytes[15]);
}

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



/**
 * UUID V7 - Unix Epoch time-based UUID
 *
 * The IETF has published RFC9562, introducing 3 new UUID versions (6,7,8). This
 * implementation of V7 is based on the accepted, though not yet approved,
 * revisions.
 *
 * RFC 9562:https://www.rfc-editor.org/rfc/rfc9562.html Universally Unique
 * IDentifiers (UUIDs)

 *
 * Sample V7 value:
 * https://www.rfc-editor.org/rfc/rfc9562.html#name-example-of-a-uuidv7-value
 *
 * Monotonic Bit Layout: RFC rfc9562.6.2 Method 1, Dedicated Counter Bits ref:
 *     https://www.rfc-editor.org/rfc/rfc9562.html#section-6.2-5.1
 *
 *   0                   1                   2                   3 0 1 2 3 4 5 6
 *   7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |                          unix_ts_ms                           |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |          unix_ts_ms           |  ver  |        seq_hi         |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |var|               seq_low               |        rand         |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |                             rand                              |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *
 * seq is a 31 bit serialized counter; comprised of 12 bit seq_hi and 19 bit
 * seq_low, and randomly initialized upon timestamp change. 31 bit counter size
 * was selected as any bitwise operations in node are done as _signed_ 32 bit
 * ints. we exclude the sign bit.
 */

var _seqLow = null;
var _seqHigh = null;
var _msecs = 0;
function v7(options, buf, offset) {
  options = options || {};

  // initialize buffer and pointer
  var i = buf && offset || 0;
  var b = buf || new Uint8Array(16);

  // rnds is Uint8Array(16) filled with random bytes
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

  // milliseconds since unix epoch, 1970-01-01 00:00
  var msecs = options.msecs !== undefined ? options.msecs : Date.now();

  // seq is user provided 31 bit counter
  var seq = options.seq !== undefined ? options.seq : null;

  // initialize local seq high/low parts
  var seqHigh = _seqHigh;
  var seqLow = _seqLow;

  // check if clock has advanced and user has not provided msecs
  if (msecs > _msecs && options.msecs === undefined) {
    _msecs = msecs;

    // unless user provided seq, reset seq parts
    if (seq !== null) {
      seqHigh = null;
      seqLow = null;
    }
  }

  // if we have a user provided seq
  if (seq !== null) {
    // trim provided seq to 31 bits of value, avoiding overflow
    if (seq > 0x7fffffff) {
      seq = 0x7fffffff;
    }

    // split provided seq into high/low parts
    seqHigh = seq >>> 19 & 0xfff;
    seqLow = seq & 0x7ffff;
  }

  // randomly initialize seq
  if (seqHigh === null || seqLow === null) {
    seqHigh = rnds[6] & 0x7f;
    seqHigh = seqHigh << 8 | rnds[7];
    seqLow = rnds[8] & 0x3f; // pad for var
    seqLow = seqLow << 8 | rnds[9];
    seqLow = seqLow << 5 | rnds[10] >>> 3;
  }

  // increment seq if within msecs window
  if (msecs + 10000 > _msecs && seq === null) {
    if (++seqLow > 0x7ffff) {
      seqLow = 0;
      if (++seqHigh > 0xfff) {
        seqHigh = 0;

        // increment internal _msecs. this allows us to continue incrementing
        // while staying monotonic. Note, once we hit 10k milliseconds beyond system
        // clock, we will reset breaking monotonicity (after (2^31)*10000 generations)
        _msecs++;
      }
    }
  } else {
    // resetting; we have advanced more than
    // 10k milliseconds beyond system clock
    _msecs = msecs;
  }
  _seqHigh = seqHigh;
  _seqLow = seqLow;

  // [bytes 0-5] 48 bits of local timestamp
  b[i++] = _msecs / 0x10000000000 & 0xff;
  b[i++] = _msecs / 0x100000000 & 0xff;
  b[i++] = _msecs / 0x1000000 & 0xff;
  b[i++] = _msecs / 0x10000 & 0xff;
  b[i++] = _msecs / 0x100 & 0xff;
  b[i++] = _msecs & 0xff;

  // [byte 6] - set 4 bits of version (7) with first 4 bits seq_hi
  b[i++] = seqHigh >>> 4 & 0x0f | 0x70;

  // [byte 7] remaining 8 bits of seq_hi
  b[i++] = seqHigh & 0xff;

  // [byte 8] - variant (2 bits), first 6 bits seq_low
  b[i++] = seqLow >>> 13 & 0x3f | 0x80;

  // [byte 9] 8 bits seq_low
  b[i++] = seqLow >>> 5 & 0xff;

  // [byte 10] remaining 5 bits seq_low, 3 bits random
  b[i++] = seqLow << 3 & 0xff | rnds[10] & 0x07;

  // [bytes 11-15] always random
  b[i++] = rnds[11];
  b[i++] = rnds[12];
  b[i++] = rnds[13];
  b[i++] = rnds[14];
  b[i++] = rnds[15];
  return buf || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(b);
}
/* unused harmony default export */ var _unused_webpack_default_export = (v7);

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(5);

function version(uuid) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }
  return parseInt(uuid.slice(14, 15), 16);
}
/* unused harmony default export */ var _unused_webpack_default_export = (version);

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(44)
var ieee754 = __webpack_require__(47)
var isArray = __webpack_require__(48)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ 47:
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regex_js__ = __webpack_require__(35);

function validate(uuid) {
  return typeof uuid === 'string' && __WEBPACK_IMPORTED_MODULE_0__regex_js__["a" /* default */].test(uuid);
}
/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var wishlistModule = function () {
  function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
      return url;
    } else {
      return url;
    }
  }
  function addToWishList(productcode, isOneSize) {
    var size = '';
    if (isOneSize == 'true') {
      size = 'all';
    } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="size-options"]:checked').length) {
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="size-options"]:checked').val();
    }
    var b_id = 'fm_plp_' + productcode;
    var _btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + b_id);
    var email = '';
    var sectionUrl = '';
    var sessionId = '';
    var canGuestsHaveFavorites = false;
    var wishlistTagId = '';
    var department = window.rcProps.department;
    if (typeof window.rcProps.wishlist != "undefined") {
      email = window.rcProps.wishlist.email;
      sectionUrl = window.rcProps.wishlist.sectionurl;
      sessionId = window.rcProps.wishlist.sessionID;
      wishlistTagId = window.rcProps.wishlist.wishlistTagId;
      canGuestsHaveFavorites = window.rcProps.wishlist.canGuestsHaveFavorites;
      department = department || window.rcProps.pdp.department;
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".favorite-button-pdp").length > 0) {
        _btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".favorite-button-pdp");
      }
    }
    if (!email && !canGuestsHaveFavorites) {
      var wishlistTagIdPair = wishlistTagId + '=' + b_id;
      var wishlistReturnUrl = window.location.pathname + window.location.search;
      if (wishlistReturnUrl.includes(wishlistTagId)) wishlistReturnUrl = removeURLParameter(wishlistReturnUrl, wishlistTagId);
      if (wishlistReturnUrl.includes('?')) {
        wishlistReturnUrl = wishlistReturnUrl + '&' + wishlistTagIdPair;
      } else {
        wishlistReturnUrl = wishlistReturnUrl + '?' + wishlistTagIdPair;
      }
      var signInCreateAccountPage = '/fw/addToWishList.jsp?code=' + productcode + '&size=' + size + '&sectionURL=' + encodeURIComponent(sectionUrl) + '&sessionID=' + sessionId + '&redirect=true&mobile=true&returnUrl=' + encodeURIComponent(wishlistReturnUrl) + '&d=' + department;
      var signInCreateAccount = '/fw/mobile/Login.jsp?returnURL=' + encodeURIComponent(signInCreateAccountPage);
      showWishListPopup(signInCreateAccount);
    } else {
      var datastring = '&code=' + productcode + '&size=' + size + '&qty=1&sectionURL=' + encodeURIComponent(sectionUrl) + '&d=' + department;
      if (_btn.hasClass("favorite-button--active")) {
        datastring = datastring + "&cond=remove";
      } else {
        var wishlistCountUpdater = new WishlistCountUpdater();
        if (wishlistCountUpdater.showWishListMaxRestrictionPopup()) {
          return;
        }
      }
      var postUrl = "/fw/mobile/ajaxAddToWishlist.jsp?" + datastring;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: "POST",
        url: postUrl,
        success: function success(ajaxResponse) {
          try {
            var responseObject = JSON.parse(ajaxResponse.trim());
            if (responseObject.maxPopup) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('count', responseObject.data);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('limit', responseObject.limit);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wish-max-popup-div').empty().append(responseObject.maxPopup);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                triggerOpen: true,
                open: "restrict-favorites"
              });
              return;
            }
          } catch (e) {}
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wish_nav_mpdp").css("display", "none");

          //wishlist button in plp
          var wishlistNotifyText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlistNotifyText");
          if (_btn.hasClass("favorite-button--active")) {
            wishlistNotifyText.text(wishlistNotifyText.data("wishlistadded"));
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wishlist-link').removeClass('u-hide');
            _btn.removeClass("favorite-button--active");
            if (typeof gaUpdateWishList === 'function') {
              gaUpdateWishList('remove', productcode);
            }
            if (typeof insertCordialUpdateWishList === 'function') {
              insertCordialUpdateWishList('remove', productcode);
            }
            if (typeof taboolaWishListAction === 'function') {
              taboolaWishListAction("remove", productcode);
            }
            if (typeof brazeAddToFavorites === 'function') {
              if (window.rcProps.pdp !== undefined) {
                brazeAddToFavorites('remove', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
              } else {
                brazeAddToFavorites('remove', productcode, _btn.data('name'), _btn.data('size'), _btn.data('imageurl'), _btn.data('pdpurl'), _btn.data('price'), _btn.data('currency'), _btn.data('department'), _btn.data('color'), _btn.data('brand'), _btn.data('category'), _btn.data('cat1'));
              }
            }
          } else {
            wishlistNotifyText.text(wishlistNotifyText.data("wishlistremoved"));
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wishlist-link').addClass('u-hide');
            _btn.addClass("favorite-button--active");
            if (typeof gaUpdateWishList === 'function') {
              gaUpdateWishList('add', productcode);
            }
            if (typeof iPinYouHeartItem === 'function') {
              iPinYouHeartItem(productcode);
            }
            if (typeof insertRTBHouseHeartItem === 'function') {
              insertRTBHouseHeartItem(productcode);
            }
            if (typeof insertCordialUpdateWishList === 'function') {
              insertCordialUpdateWishList('add', productcode);
            }
            if (typeof taboolaWishListAction === 'function') {
              taboolaWishListAction("add", productcode);
            }
            if (typeof brazeAddToFavorites === 'function') {
              if (window.rcProps.pdp !== undefined) {
                brazeAddToFavorites('add', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
              } else {
                brazeAddToFavorites('add', productcode, _btn.data('name'), _btn.data('size'), _btn.data('imageurl'), _btn.data('pdpurl'), _btn.data('price'), _btn.data('currency'), _btn.data('department'), _btn.data('color'), _btn.data('brand'), _btn.data('category'), _btn.data('cat1'));
              }
            }
          }
          if (typeof window.rcProps.wishlist != "undefined") {
            updateFavoritesMessage(_btn);
          }
          //Update header wishlist count
          var wishlistCountUpdater = new WishlistCountUpdater();
          wishlistCountUpdater.updateCount();
        }
      });
    }
  }
  function updateFavoritesMessage(favBtn) {
    if (!favBtn || favBtn.length == 0) return;
    var favoriteMsg = window.rcProps.wishlist.favoriteMsg;
    var unfavoriteMsg = window.rcProps.wishlist.unfavoriteMsg;
    var favoriteNote = window.rcProps.wishlist.favoriteNote;
    var unfavoriteNote = window.rcProps.wishlist.unfavoriteNote;
    var notificationContainer = '.js-favorite-notify';
    var productDescription = favBtn.data('product-description');

    // Set messaging based on current data attribute value and rcProps values
    var favMessage = "";
    favMessage += favoriteMsg;
    favMessage += productDescription;
    var unFavMessage = "";
    unFavMessage += unfavoriteMsg;
    unFavMessage += productDescription;
    var favNotification = "";
    favNotification += productDescription;
    favNotification += favoriteNote;
    var unFavNotification = "";
    unFavNotification += productDescription;
    unFavNotification += unfavoriteNote;
    var isFav = !favBtn.hasClass('favorite-button--active');
    if (isFav) {
      favBtn.find('.u-screen-reader').html(favMessage);
      favBtn.parent().find(notificationContainer).html(unFavNotification);
    } else {
      favBtn.find('.u-screen-reader').html(unFavMessage);
      favBtn.parent().find(notificationContainer).html(favNotification);
    }
  }
  function showWishListPopup(signInCreateAccount) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "/fw/content/wishlist/login?href=" + encodeURIComponent(signInCreateAccount),
      type: "top",
      triggerOpen: true
    });
  }
  function checkWihlistTagId() {
    if (!window.rcProps || !window.rcProps.wishlist) return;
    var wishlistTagId = window.rcProps.wishlist.wishlistTagId;
    if (window.location.search.includes(wishlistTagId)) {
      var urlparts = window.location.search.split('?');
      if (urlparts.length >= 2) {
        var pars = urlparts[1].split(/[&;]/g);
        for (var i = 0; i < pars.length; i++) {
          console.log('pars[i] = ' + pars[i]);
          if (pars[i].includes(wishlistTagId)) {
            var pair = pars[i].split('=');
            if (pair.length > 0) {
              console.log('pair[1] = ' + pair[1]);
              console.log('document.getElementById(pair[1]) = ' + document.getElementById(pair[1]));
              if (document.getElementById(pair[1])) {
                console.log('scrollIntoView');
                document.getElementById(pair[1]).scrollIntoView();
              }
            }
          }
        }
      }
    }
  }
  return {
    checkWihlistTagId: checkWihlistTagId,
    bindWishListEvent: function bindWishListEvent() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').off('click').on('click', function (e) {
        var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
        var oneSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('oneSize');
        if (typeof code !== "undefined") {
          addToWishList(code, oneSize);
          iPinYouHeartItem(code);
        }
      });
    }
  };
}();
/* harmony default export */ __webpack_exports__["a"] = (wishlistModule);

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logEngagement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function logEngagement(url, module, action, params) {
  if (!url) {
    url = window.location.href;
  }
  if (params) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + (typeof params === 'string' || params instanceof String ? params : __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(params));
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: url,
      module: module,
      action: action
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderPdpSocialProof; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderPlpSocialProof; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderCartSocialProof; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mustache__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mustache__);


var DEFAULT_ANIMATE_PARAMS = {
  outCss: {
    opacity: 0
  },
  inCss: {
    opacity: 1
  },
  fade: 750,
  hold: 1500,
  keep: true
};
var PageType = Object.freeze({
  PDP: {
    name: 'PDP',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sp-wrapper');
    },
    animateParams: {
      keep: false
    }
  },
  PLP: {
    name: 'PLP',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(code, " .sp-wrapper"));
    }
  },
  CART: {
    name: 'CART',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("tr[data-code='".concat(code, "'] .sp-wrapper"));
    },
    title: false
  }
});
function render(pageType, codes) {
  var urlParams = new URLSearchParams(window.location.search);
  var forceParam = window.rcProps.socialProof.forceParam;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "".concat(window.rcProps.socialProof.href, "?").concat(forceParam, "=").concat(urlParams.get(forceParam) || ''),
    method: 'POST',
    data: JSON.stringify({
      type: pageType.name,
      codes: Array.isArray(codes) ? codes : [codes]
    }),
    dataType: 'json',
    contentType: 'application/json'
  }).done(function (result) {
    var animateParams = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(DEFAULT_ANIMATE_PARAMS, pageType.animateParams);
    result.forEach(function (socialProof) {
      if (socialProof.productCode) {
        var promise = Promise.resolve();
        var _loop = function _loop() {
          var message = socialProof.messages[i];
          var $container = pageType.getContainer(socialProof.productCode).first();
          if ($container.length) {
            promise = promise.then(function () {
              return new Promise(function (resolve) {
                var $message = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(message.message).css(animateParams.outCss);
                if (pageType.title === false) {
                  $message.find('.sp-title').hide();
                }
                $container.append($message.animate(animateParams.inCss, animateParams.fade, function () {
                  if (!animateParams.keep) {
                    setTimeout(function () {
                      $message.css(animateParams.outCss);
                      setTimeout(function () {
                        $container.empty();
                        resolve();
                      }, animateParams.fade);
                    }, animateParams.hold);
                  }
                }));
              });
            });
          }
        };
        for (var i = 0; i < socialProof.messages.length; i++) {
          _loop();
        }
      }
    });
  }).fail(function (error) {
    console.error(error);
  });
}
var renderPdpSocialProof = function renderPdpSocialProof(codes) {
  return render(PageType.PDP, codes);
};
var renderPlpSocialProof = function renderPlpSocialProof(codes) {
  return render(PageType.PLP, codes);
};
var renderCartSocialProof = function renderCartSocialProof(codes) {
  return render(PageType.CART, codes);
};

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUpBisAndSo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_to_bag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_log_engagement__ = __webpack_require__(54);



function manageElementsVisibility($form, isPDP) {
  $form.find('.js-notification-r-in-stock').hide();
  $form.find('.js-shop-revolve-instock').hide();
  if (isPDP) {
    $form.find('.js-oos-special-order').show();
    $form.find('.js-oos-notify-me').hide();
  }
}
function setUpBisAndSo(returnElement) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bis-phone').mask('(000) 000-0000');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="bis-size-options"], input[name="so-size-options"]').change(function (e) {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var isPDP = el.closest('.js-details-container').length;
    var $form = isPDP ? el.closest('.js-details-container') : el.parents('form');
    var $contactFields = $form.find('.js-contact-div');
    var instock = el.data('instock');
    var revolveInStock = el.data('revolve');
    var revolvePreorder = el.data('revolvePreorder');
    var preorder = el.data('preorder');
    var eligibleForSpecialOrder = el.data('eligibleForSpecialOrder');
    var isSpecialOrderForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('name') === 'so-size-options';
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.notification').hide();
    var sizeLabel = $form.find('.js-size-selection-label');
    sizeLabel.removeClass("u-error");
    sizeLabel.removeClass("pdp__des-info--unselected");
    if (el.data('preorder') === true) {
      sizeLabel.html(el.data('size-label') + ' (' + el.data('preorder-text') + ')');
    } else {
      sizeLabel.html(el.data('size-label'));
    }
    if (instock) {
      $form.find('.js-notification-instock').show();
      $form.find('.notify-me__cta button').hide();
      $contactFields.hide();
      $form.find('.notify-me__auto-order').hide();
      $form.find('.js-add-to-bag').show();
      manageElementsVisibility($form, isPDP);
    } else if (preorder) {
      $form.find('.js-notification-preorder').show();
      $form.find('.notify-me__cta button').hide();
      $contactFields.show();
      $form.find('.notify-me__auto-order').show();
      $form.find('.js-notify-me').show();
      manageElementsVisibility($form, isPDP);
    } else if (isSpecialOrderForm && !eligibleForSpecialOrder) {
      $form.find('.js-notification-unavailable').show();
      $form.find('.notify-me__cta button').hide();
      $contactFields.hide();
      $form.find('.notify-me__auto-order').show();
      $form.find('.js-special-order').show();
      manageElementsVisibility($form, isPDP);
    } else if (!instock && (revolveInStock || revolvePreorder)) {
      $form.find('.js-notification-instock').hide();
      $form.find('.notify-me__cta button').hide();
      $contactFields.hide();
      $form.find('.notify-me__auto-order').hide();
      $form.find('.js-add-to-bag').hide();
      // UX-16481 - mock - update/remove comment once finalized
      $form.find('.js-notification-r-in-stock').show();
      $form.find('.js-shop-revolve-instock').show();
      if (isPDP) {
        $form.find('.js-oos-special-order').hide();
        $form.find('.js-oos-notify-me').show();
      }
      if (revolvePreorder) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cross-site-preorder").removeClass('u-hide');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cross-site-shop").addClass("u-hide");
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cross-site-shop").removeClass("u-hide");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cross-site-preorder").addClass('u-hide');
      }
    } else {
      $form.find('.notify-me__cta button').hide();
      $form.find('.notify-me__auto-order').show();
      manageElementsVisibility($form, isPDP);
      if (isSpecialOrderForm) {
        $form.find('.js-special-order').show();
        $contactFields.hide();
        $form.find('.js-email-div').show();
      } else {
        $form.find('.js-notify-me').show();
        $contactFields.show();
      }
    }
  });
  var notifyMeForms = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notify-me-form');
  notifyMeForms.unbind('submit').submit(function (e) {
    e.preventDefault();
    var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var sizeLabel = $form.find('.js-size-selection-label');
    var hasError = false;
    var checkedInput = $form.find('input[name="bis-size-options"]:checked');
    if (checkedInput.length == 0) {
      sizeLabel.html(sizeLabel.data('select-error-text'));
      sizeLabel.addClass("u-error");
      hasError = true;
    }
    var size = checkedInput.val();
    if (!isAddToBag($form)) {
      var email = $form.find(':input[name="email"]').val();
      if (!validateEmail(email) || !email) {
        $form.find(':input[name="email"]').closest('.field').addClass('is-error');
        hasError = true;
      } else {
        $form.find(':input[name="email"]').closest('.field').removeClass('is-error');
      }
      var phone = $form.find(':input[name="phone"]').val();
      if (!!phone && !validatePhone(phone)) {
        $form.find(':input[name="phone"]').closest('.field').addClass('is-error');
        hasError = true;
      } else {
        $form.find(':input[name="phone"]').closest('.field').removeClass('is-error');
      }
    }
    if (hasError) return;
    var code = $form.find(':input[name="code"]').val();
    var phone = $form.find(':input[name="phone"]').val();
    if (isAddToBag($form)) {
      //do add to bag
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__add_to_bag__["a" /* default */])(code, size, returnElement);
    } else {
      //do notify me
      submitNotifyMe(code, size, email, phone, function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-confirmation-email').html(email);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: 'bis-confirmation',
          triggerOpen: true,
          type: 'notification'
        });
      }, $form.data('embeddedPdp') ? 'embedded' : '');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#special-order-form').submit(function (e) {
    e.preventDefault();
    var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var hasError = false;
    var sizeLabel = $form.find('.js-size-selection-label');
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="so-size-options"]:checked').length == 0) {
      sizeLabel.html(sizeLabel.data('select-error-text'));
      sizeLabel.addClass("u-error");
      hasError = true;
    }
    var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="so-size-options"]:checked').val();
    if (!isAddToBag($form)) {
      var emailField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-email');
      var email = emailField.val();
      if (!validateEmail(email)) {
        emailField.closest('.field').addClass('is-error');
        hasError = true;
      } else {
        emailField.closest('.field').removeClass('is-error');
      }
      var phone = $form.find(':input[name="phone"]').val();
      if (!!phone && !validatePhone(phone)) {
        $form.find(':input[name="phone"]').closest('.field').addClass('is-error');
        hasError = true;
      } else {
        $form.find(':input[name="phone"]').closest('.field').removeClass('is-error');
      }
    }
    if (hasError) return;
    var code = $form.find(':input[name="code"]').val();
    var phone = $form.find(':input[name="phone"]').val();
    var autoOrder = $form.find('#so-auto-order').is(":checked");
    if (isAddToBag($form)) {
      //do add to bag
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__add_to_bag__["a" /* default */])(code, size, returnElement);
    } else if (isNotifyMe($form)) {
      //do notify me
      submitNotifyMe(code, size, email, phone, function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-confirmation-email').html(email);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: 'bis-confirmation',
          triggerOpen: true,
          type: 'notification'
        });
      });
    } else {
      //do special order
      var notEligible = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-unavailable').is(':visible');
      if (notEligible) {
        submitSpecialOrder(code, size, email, autoOrder, function () {
          submitNotifyMe(code, size, email, '', function () {
            showSoComfirmation();
          });
        });
      } else {
        submitSpecialOrder(code, size, email, autoOrder, function () {
          showSoComfirmation();
        });
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-revolve-instock').on('click', function (event) {
    event.preventDefault();
    var sizeType = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('sizeType');
    var selectedSize;
    if (sizeType == 'so') {
      selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="so-size-options"]:checked');
    } else {
      selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="bis-size-options"]:checked');
    }
    if (selectedSize.length > 0) {
      var sizeValue = selectedSize.val();
      var productCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
      var baseURL = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('href');
      var dynamicURL = baseURL + '&size=' + sizeValue + '&code=' + productCode;
      window.open(dynamicURL, '_blank');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="bis-size-options"]:checked').trigger('change');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="so-size-options"]:checked').trigger('change');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs__link').click(function () {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('resize.showOnOverflow');
    }, 100);
  });
}
function isAddToBag(formObj) {
  return formObj.find('.js-add-to-bag').is(':visible');
}
function isNotifyMe(formObj) {
  return formObj.find('.js-notify-me').is(':visible');
}
function showSoComfirmation() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    open: 'so-confirmation',
    triggerOpen: true,
    type: 'notification'
  });
}
function submitNotifyMe(code, size, email, phone, callback, sourceForTracking) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    size: size,
    email: email,
    phone: phone,
    code: code,
    fw: true,
    isMobile: true
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function (msg) {
    if (callback) {
      callback();
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__modules_log_engagement__["a" /* default */])(window.location.href, (sourceForTracking ? sourceForTracking + ' ' : '') + 'notify me', 'submitted');
  });
}
function submitSpecialOrder(code, size, email, autoOrder, callback) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    SOProductCode: code,
    SOSize: size,
    SOUserEmail: email,
    SOAutoOrder: autoOrder
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/fw/SubmitSpecialOrderInquiry.jsp", data, function () {
    if (callback) {
      callback();
    }
  });
}
function validateEmail(emailStr) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(emailStr);
}
function validatePhone(phoneStr) {
  return /^\(\d{3}\) \d{3}-\d{4}$/.test(phoneStr);
}

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false Mustache: true*/

(function defineMustache (global, factory) {
  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
    factory(exports); // CommonJS
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
  } else {
    global.Mustache = {};
    factory(global.Mustache); // script, wsh, asp
  }
}(this, function mustacheFactory (mustache) {

  var objectToString = Object.prototype.toString;
  var isArray = Array.isArray || function isArrayPolyfill (object) {
    return objectToString.call(object) === '[object Array]';
  };

  function isFunction (object) {
    return typeof object === 'function';
  }

  /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */
  function typeStr (obj) {
    return isArray(obj) ? 'array' : typeof obj;
  }

  function escapeRegExp (string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
  }

  /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */
  function hasProperty (obj, propName) {
    return obj != null && typeof obj === 'object' && (propName in obj);
  }

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var regExpTest = RegExp.prototype.test;
  function testRegExp (re, string) {
    return regExpTest.call(re, string);
  }

  var nonSpaceRe = /\S/;
  function isWhitespace (string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };

  function escapeHtml (string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
      return entityMap[s];
    });
  }

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   */
  function parseTemplate (template, tags) {
    if (!template)
      return [];

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace () {
      if (hasTag && !nonSpace) {
        while (spaces.length)
          delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var openingTagRe, closingTagRe, closingCurlyRe;
    function compileTags (tagsToCompile) {
      if (typeof tagsToCompile === 'string')
        tagsToCompile = tagsToCompile.split(spaceRe, 2);

      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error('Invalid tags: ' + tagsToCompile);

      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
    }

    compileTags(tags || mustache.tags);

    var scanner = new Scanner(template);

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(openingTagRe);

      if (value) {
        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push([ 'text', chr, start, start + 1 ]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n')
            stripSpace();
        }
      }

      // Match the opening tag.
      if (!scanner.scan(openingTagRe))
        break;

      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === '{') {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = '&';
      } else {
        value = scanner.scanUntil(closingTagRe);
      }

      // Match the closing tag.
      if (!scanner.scan(closingTagRe))
        throw new Error('Unclosed tag at ' + scanner.pos);

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);

        if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        compileTags(value);
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();

    if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens (tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens (tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      switch (token[0]) {
        case '#':
        case '^':
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case '/':
          section = sections.pop();
          section[5] = token[2];
          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner (string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function eos () {
    return this.tail === '';
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function scan (re) {
    var match = this.tail.match(re);

    if (!match || match.index !== 0)
      return '';

    var string = match[0];

    this.tail = this.tail.substring(string.length);
    this.pos += string.length;

    return string;
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function scanUntil (re) {
    var index = this.tail.search(re), match;

    switch (index) {
      case -1:
        match = this.tail;
        this.tail = '';
        break;
      case 0:
        match = '';
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context (view, parentContext) {
    this.view = view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function push (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function lookup (name) {
    var cache = this.cache;

    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this, names, index, lookupHit = false;

      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;
          names = name.split('.');
          index = 0;

          /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           **/
          while (value != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit = hasProperty(value, names[index]);

            value = value[names[index++]];
          }
        } else {
          value = context.view[name];
          lookupHit = hasProperty(context.view, name);
        }

        if (lookupHit)
          break;

        context = context.parent;
      }

      cache[name] = value;
    }

    if (isFunction(value))
      value = value.call(this.view);

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer () {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function clearCache () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function parse (template, tags) {
    var cache = this.cache;
    var tokens = cache[template];

    if (tokens == null)
      tokens = cache[template] = parseTemplate(template, tags);

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   */
  Writer.prototype.render = function render (template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
    var buffer = '';

    var token, symbol, value;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      value = undefined;
      token = tokens[i];
      symbol = token[0];

      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
      else if (symbol === '&') value = this.unescapedValue(token, context);
      else if (symbol === 'name') value = this.escapedValue(token, context);
      else if (symbol === 'text') value = this.rawValue(token);

      if (value !== undefined)
        buffer += value;
    }

    return buffer;
  };

  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
    var self = this;
    var buffer = '';
    var value = context.lookup(token[1]);

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    function subRender (template) {
      return self.render(template, context, partials);
    }

    if (!value) return;

    if (isArray(value)) {
      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
      }
    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== 'string')
        throw new Error('Cannot use higher-order sections without the original template');

      // Extract the portion of the original template that the section contains.
      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

      if (value != null)
        buffer += value;
    } else {
      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
    }
    return buffer;
  };

  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
    var value = context.lookup(token[1]);

    // Use JavaScript's definition of falsy. Include empty arrays.
    // See https://github.com/janl/mustache.js/issues/186
    if (!value || (isArray(value) && value.length === 0))
      return this.renderTokens(token[4], context, partials, originalTemplate);
  };

  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
    if (!partials) return;

    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null)
      return this.renderTokens(this.parse(value), context, partials, value);
  };

  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return value;
  };

  Writer.prototype.escapedValue = function escapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return mustache.escape(value);
  };

  Writer.prototype.rawValue = function rawValue (token) {
    return token[1];
  };

  mustache.name = 'mustache.js';
  mustache.version = '2.3.2';
  mustache.tags = [ '{{', '}}' ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function clearCache () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function parse (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  mustache.render = function render (template, view, partials) {
    if (typeof template !== 'string') {
      throw new TypeError('Invalid template! Template should be a "string" ' +
                          'but "' + typeStr(template) + '" was given as the first ' +
                          'argument for mustache#render(template, view, partials)');
    }

    return defaultWriter.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.,
  /*eslint-disable */ // eslint wants camel cased function name
  mustache.to_html = function to_html (template, view, partials, send) {
    /*eslint-enable*/

    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

  return mustache;
}));


/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["c"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* harmony export (immutable) */ __webpack_exports__["b"] = __spreadArray;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/* unused harmony export __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
        var ar = [];
        for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;

}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while (r = env.stack.pop()) {
            try {
                if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
                if (r.dispose) {
                    var result = r.dispose.call(r.value);
                    if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
                }
                else s |= 1;
            }
            catch (e) {
                fail(e);
            }
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
        });
    }
    return path;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SELECTORS */
/* harmony export (immutable) */ __webpack_exports__["a"] = manageRefineMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plpswatches__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_social_proof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_psykhe__ = __webpack_require__(20);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }





var SELECTORS = {
  sortBy: '#sortby',
  clearFilter: '.clear_filters',
  doneFilter: '#done_filters',
  filterClickable: '.plp-filter-clickable',
  catFilter: '#category',
  dateFilter: '#newarrivals',
  designerFilter: '#alldesigners',
  departmentFilter: '#department',
  filterItemSelect: '.filters__item-select',
  refineButton: '#refine-filters-button'
};
var FILTER_NAMES = ['designer', 'category', 'size', 'color', 'heel', 'price'];
var FILTERS_PARAM_NAME = 'filters';
var FILTERS_APPLIED_DELIMITER = "-";
var COLOR_FILTER = '#allcolors';
var SIZE_FILTER = '#allsizes';
var HEEL_FILTER = '#heel';
var PRICE_FILTER = '#allprices';
var CONDITION_FILTER = '#condition-select';
var CATEGORIES_FILTER = '#allcategories';
var FILTER_IDS = "".concat(SELECTORS.designerFilter, ", ").concat(COLOR_FILTER, ", ").concat(SIZE_FILTER, ", ") + "".concat(SELECTORS.catFilter, ", ").concat(CONDITION_FILTER, ", ").concat(HEEL_FILTER, ", ").concat(CATEGORIES_FILTER, ", ").concat(PRICE_FILTER);
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  window.onpopstate = function () {
    updateContent(location.pathname + location.search);
  };
  if (!isWishlistPage() && !isPersonalShopPage()) {
    dynamicallyDisableFilters();
    updateDropdownNavUrlsOnLoad();
  }
});
function manageRefineMenu() {
  // left the department selector separate here to maintain existing behavior but changed to use common `const` value
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(FILTER_IDS + ", ".concat(SELECTORS.departmentFilter)).on('change', function () {
    uncheckSelectAllOption(this);
    loadBrandsURL(this, null, true, true);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.clearFilter).click(function (event) {
    event.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(FILTER_IDS).prop('selectedIndex', 0).each(function () {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("multiple")) {
        setLabel(this);
      }
    });
    var curDep = getQueryParamValues(window.location.href, 'd')[0];
    setFilterOptionSelectedByValue(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department'), curDep);
    loadBrandsURL(this, null, true, true);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sortBy).change(function () {
    loadBrandsURL(this, null, true);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.catFilter).change(function () {
    loadBrandsURL(this);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.dateFilter).change(function () {
    var safeUrl = prepareForSafeRemove(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('input:checked').data('url'));
    var url = safeRemoveParam(safeUrl, 'fromSidePanel');
    location.href = safeConcat(url, 'fromSidePanel=true');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.filterClickable).click(function (e) {
    e.preventDefault();
    loadBrandsURL(this);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.filterItemSelect).change(function (e) {
    setLabel(this);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.doneFilter).click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.refineButton).click();
  });
  reloadBindJs();
}
function uncheckSelectAllOption(elem) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem);
  var refineValue = $el.val();
  if (refineValue && refineValue.length > 1 && !refineValue[0]) {
    $el.find('.select_all').removeAttr('selected').prop("selected", false);
  }
}
function setLabel(elem) {
  var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem); // select
  var elParent = $elem[0].closest('.filters__item'); // label (parent)
  var selectedLabel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elParent).data('selected-label'); // label's data value
  var isDepartment = selectedLabel == 'Department';
  var elValue = $elem.find(":selected").text().trim();
  var labelCopy = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elParent).children('.filters__item-copy')[0]; // label span(1st child)
  var numSelectedOptions = Array.isArray($elem.val()) && $elem.val().filter(function (option) {
    return !!option;
  }).length; // selects values amount - might need
  if (numSelectedOptions) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(labelCopy).text("".concat(selectedLabel, " (").concat(numSelectedOptions, ")"));
  } else if (isDepartment) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(labelCopy).text("".concat(selectedLabel, " (").concat(elValue, ")"));
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(labelCopy).text(selectedLabel);
  }
}
function setFilterOptionSelectedByValue(filterElement, value) {
  if (value && filterElement.find('option[value="' + value + '"]').length > 0) {
    filterElement.val(value);
  }
}
function getSingleItemOption(element) {
  return element && element.length ? element.val() : '';
}
function getMultiItemOptions(element) {
  if (element && element.length > 0) {
    if (window.rcProps.sidebarHref) {
      var checkedValues = [];
      element.find('input[type="checkbox"]:checked').each(function () {
        checkedValues.push(this.value);
      });
      return checkedValues;
    } else {
      // Remove empty values (i.e., the "All" value) if there are other values
      // Customer will have clear all filters or de-select filters to get back the "All" value
      var options = element.val();
      if (options && options.length > 1) {
        var rtn = [];
        for (var i = 0; i < options.length; i++) {
          if (options[i] != '') rtn.push(options[i]);
        }
        options = rtn;
      }
      return options;
    }
  } else {
    return [''];
  }
}
function getQueryParamValues(url, param) {
  var result = [];
  if (url) {
    var paramsAndValues = url.slice(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < paramsAndValues.length; i++) {
      if (paramsAndValues[i]) {
        var paramAndValue = paramsAndValues[i].split('=');
        if (2 == paramAndValue.length && param == paramAndValue[0]) {
          result.push(paramAndValue[1]);
        }
      }
    }
  }
  return result;
}
window.dynamicallyEnableDisableFilters = function (filterMenuList) {
  if (!filterMenuList) return -1;
  for (var j = 0; j < filterMenuList.length; j++) {
    var filterMenu = filterMenuList[j];
    if (!filterMenu || !filterMenu.idForHTML || !filterMenu.filterMenuList) continue;
    var filterId = filterMenu.idForHTML;
    var isSelected = false;
    for (var i = 0; i < filterMenu.filterMenuList.length; i++) {
      var filterObj = filterMenu.filterMenuList[i];
      if (filterObj) {
        var option = window.rcProps.sidebarHref ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(filterId, " input[value=\"").concat(filterObj.value, "\"]")) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(filterId, " option[value=\"").concat(filterObj.value, "\"]"));
        if (option.length) {
          var propToCheck = window.rcProps.sidebarHref ? 'checked' : 'selected';
          if (filterObj.disabled && option.prop(propToCheck)) {
            option.prop(propToCheck, false);
            option.trigger("change");
            return;
          } else {
            option.prop("disabled", filterObj.disabled);
            option.prop(propToCheck, filterObj.selected);
            if (filterObj.selected == true) {
              isSelected = true;
            }
          }
        }
      }
    }
    if (!isSelected) {
      var selectAllOption = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + filterId + ' .select_all');
      if (selectAllOption.length) {
        selectAllOption.prop('selected', true);
      }
    }
  }
};
window.reloadBindJs = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pagination').click(function (e) {
    e.preventDefault();
    loadBrandsURL(this);
  });
  __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].checkWihlistTagId();
  __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].bindWishListEvent();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__plpswatches__["a" /* default */])();
};
function dynamicallyDisableFilters() {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    url: location.pathname + location.search,
    isMen: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#isMen').length ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#isMen').val() : 'false'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: window.rcProps.filteredPlpContentsUrl,
    data: data,
    dataType: 'json',
    type: 'POST',
    success: function success(data) {
      if (data.filterMenuList) {
        for (var j = 0; j < data.filterMenuList.length; j++) {
          var filterMenu = data.filterMenuList[j];
          if (!filterMenu || !filterMenu.idForHTML || !filterMenu.filterMenuList) {
            continue;
          }
          var filterId = filterMenu.idForHTML;
          for (var i = 0; i < filterMenu.filterMenuList.length; i++) {
            var filterObj = filterMenu.filterMenuList[i];
            if (!filterObj) {
              continue;
            }
            var option = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + filterId + ' option[value="' + filterObj.value + '"]');
            if (option.length && filterObj.disabled && option.prop("selected")) {
              option.prop("selected", false);
              option.trigger("change");
              return;
            }
          }
        }
      }
    }
  });
}
function ContentUpdate(pdpUrl) {
  var isWishList = isWishlistPage();
  var isPersonalShop = isPersonalShopPage();
  var canceled = false;
  this.go = function () {
    var data = {};
    var ajaxEndpoint;
    if (isWishList) {
      ajaxEndpoint = pdpUrl.replace(/^[^?]*/, '/fw/mobile/WishListContent.jsp');
    } else if (isPersonalShop) {
      ajaxEndpoint = pdpUrl.replace(/^[^?]*/, '/ajax' + window.location.pathname);
    } else {
      ajaxEndpoint = window.rcProps.filteredPlpContentsUrl;
      data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        url: pdpUrl,
        isMen: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#isMen').length ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#isMen').val() : 'false'
      });
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: ajaxEndpoint,
      data: data,
      dataType: isWishList ? 'text' : 'json',
      type: 'POST',
      success: function success(data, status, xhr) {
        if (!canceled) {
          if (isWishList) {
            var $htmlData = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseHTML(data));
            var extraData = JSON.parse($htmlData.filter('#ajax-response-data').add($htmlData.find('#ajax-response-data')).text());
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("html, body").hasClass("page-constrain")) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.refineButton).click();
            }
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#productsList').html(data);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-item-count').html(extraData.productCountStr);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-overlay').fixedOverlay();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy();
            dynamicallyEnableDisableFilters(extraData.filterMenuList);
            reloadBindJs();
          } else if (isPersonalShop) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("html, body").hasClass("page-constrain")) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.refineButton).click();
            }
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-product-list').html(data.products);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-item-count').html(data.productCountStr);
            dynamicallyEnableDisableFilters(data.filterMenuList);
            reloadBindJs();
          } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-product-list').html(data.plpMarkup);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-pagination-wrapper-ajax').html(data.paginationMarkup);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-item-count').html(data.productCountStr);
            dynamicallyEnableDisableFilters(data.filterMenuList);
            reloadBindJs();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_social_proof__["a" /* renderPlpSocialProof */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-container').toArray().map(function (el) {
              return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).prop('id');
            }));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__modules_psykhe__["c" /* trackPsykhePlpView */])();
          }
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#refine-filters-button.js-toggle-display').toggleDisplay();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#clear_filters').show();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("html").animate({
            scrollTop: 0
          }, 'fast');
          insertPageTrackForMobile(false, null, pdpUrl);
        }
      },
      error: function error() {
        window.location.assign(pdpUrl);
      }
    });
    return this;
  };
  this.cancel = function () {
    canceled = true;
  };
}
var updateContent = function () {
  var pending = null;
  return function (pdpUrl) {
    if (pending) {
      pending.cancel();
      pending = null;
    }
    pending = new ContentUpdate(pdpUrl).go();
    return pending;
  };
}();
function getUrlParams(currentUrl, featuredSort) {
  var departmentFromForm = window.rcProps.sidebarHref ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department input:checked').val() : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department').val();
  return {
    path: currentUrl,
    sortBy: featuredSort ? featuredSort : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortby option:selected').length > 0 ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortby option:selected').val() : [''],
    catFilter: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#category').val(),
    department: departmentFromForm || getQueryParamValues(currentUrl, 'd')[0],
    designers: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners').length ? getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners')) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchdesigner').length ? getSingleItemOption(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchdesigner')) : getQueryParamValues(window.location.href, 'designer'),
    sizes: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allsizes')),
    colors: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allcolors')),
    heels: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#heel')),
    prices: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allprices')),
    conditions: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#condition-select')),
    category: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(CATEGORIES_FILTER)),
    featuredCodes: getQueryParamValues(currentUrl, 'featuredCodes'),
    arrivalDate: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals').length > 0 ? window.rcProps.sidebarHref ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals input:checked').val() : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals').prop('value') : '',
    pageNum: parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pageNum_param').val())
  };
}
function getUrlParamsFromUrl(currentUrl) {
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var base = window.location.origin;
  var url = new URL(currentUrl, base);
  var params = new URLSearchParams(url.search);
  var result = {
    path: urlParams.path,
    sortBy: urlParams.sortBy,
    catFilter: urlParams.catFilter,
    department: urlParams.department,
    designers: Object.assign([], urlParams.designers),
    sizes: Object.assign([], urlParams.sizes),
    colors: Object.assign([], urlParams.colors),
    prices: Object.assign([], urlParams.prices),
    heels: Object.assign([], urlParams.heels),
    conditions: Object.assign([], urlParams.conditions),
    category: Object.assign([], urlParams.category),
    featuredCodes: urlParams.featuredCodes,
    arrivalDate: urlParams.arrivalDate,
    pageNum: urlParams.pageNum
  };

  // Helper: merge array field without duplicates
  var mergeArray = function mergeArray(arr, val) {
    if (!arr.includes(val)) {
      arr.push(val);
    }

    // Filter empty values in-place
    arr.splice.apply(arr, [0, arr.length].concat(_toConsumableArray(arr.filter(function (v) {
      return v != null && v.toString().trim() !== '';
    }))));
  };
  params.forEach(function (value, key) {
    switch (key.toLowerCase()) {
      case 'designer':
        mergeArray(result.designers, value);
        break;
      case 'size':
        mergeArray(result.sizes, value);
        break;
      case 'color':
        mergeArray(result.colors, value);
        break;
      case 'price':
        mergeArray(result.prices, value);
        break;
      case 'heel':
        mergeArray(result.heels, value);
        break;
      case 'condition':
        mergeArray(result.conditions, value);
        break;
      default:
        // ignore everything else
        break;
    }
  });
  return result;
}
function isWishlistPage() {
  return window.location.href.indexOf("WishList.jsp") > -1;
}
function isPersonalShopPage() {
  return window.location.href.indexOf("PersonalShop.jsp") > -1;
}
function isSearchPage() {
  return window.location.href.indexOf('SearchResults.jsp') > -1;
}
function isNewPage() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals').length > 0;
}
function getCustomUrl() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department').find(":selected").data("href");
}
function loadBrandsURL(elem, featuredSort, resetToPageOne, appendParamsToDropdownNav) {
  if (elem === 'undefined') return;
  var currentUrl = window.location.href;
  if (elem.id === 'sortby') {
    currentUrl = removeURLParameter(currentUrl, 'featuredCodes');
  }
  var urlParams = getUrlParams(currentUrl, featuredSort);
  var isNew = isNewPage();
  var isWishList = isWishlistPage();
  var isPersonalShop = isPersonalShopPage();
  var selectFromCategory = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).closest('div').prop('id') === 'plp_filter_dd';
  // category filters
  if (selectFromCategory) {
    urlParams.path = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).data('caturl');
    resetFilters(urlParams);
  }
  var isPagination = false;
  // pagination
  if (elem.id === 'prev_btn') {
    urlParams.pageNum = urlParams.pageNum - 1;
    isPagination = true;
  }
  if (elem.id === 'next_btn') {
    urlParams.pageNum = urlParams.pageNum + 1;
    isPagination = true;
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).hasClass("js-pagination")) {
    urlParams.pageNum = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).data("pageNum");
    isPagination = true;
  }
  if (resetToPageOne) {
    urlParams.pageNum = 1;
  }
  var newURL = '';
  var alreadyParams = urlParams && urlParams.path.indexOf("?") > -1;
  //var isPrettyURL = (urlParams.path.indexOf(".jsp") < 0);
  urlParams.path = removeFilterParams(urlParams);
  urlParams.path = safeRemoveParam(urlParams.path, 'arrivalDate');
  if (alreadyParams) {
    var amp = '&';
    if (urlParams.path.indexOf("?") === urlParams.path.length - 1) amp = '';
    newURL = urlParams.path + amp + getFilterParams(urlParams);
  } else {
    newURL = urlParams.path + '?' + getFilterParams(urlParams);
  }

  // append arrival date for selected status
  if (isNew) newURL = newURL + "&arrivalDate=" + urlParams.arrivalDate;
  if (isPersonalShop) {
    newURL = newURL + "&personalshop=true";
  }
  var filtersObj = updateUrlForFiltersParam(newURL);
  if (!selectFromCategory && !isPagination && !isNew && !isWishList && !isPersonalShop && appendParamsToDropdownNav) {
    appendFilterParamsToDropdownNav(urlParams, filtersObj);
  }
  removeHash(filtersObj.url);
  updateContent(filtersObj.url);
}
function keepFilters() {
  return window.rcProps && window.rcProps.keepRefineFilter;
}
function appendFilterParamsToDropdownNav(urlParams, filtersObj) {
  if (!keepFilters() || !filtersObj) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-header__nav-list li.ui-list__item a').each(function () {
    if (!filtersObj.isAddedFilter) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('originalHref'));
      return;
    }
    var currentHref = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');
    var urlParamsFromUrl = getUrlParamsFromUrl(currentHref, urlParams);
    var filtersObjFromUrl = updateUrlForFiltersParam(currentHref);
    var baseUrl = removeURLParameters(currentHref, FILTER_NAMES);
    var newUrl = replaceURLParameters(baseUrl, getFilterParams(urlParamsFromUrl));
    newUrl = clearQueryParameters(newUrl, {
      pageNum: true,
      filter: true,
      sortBy: true
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href', filtersObjFromUrl.filtersApplied ? replaceURLParameters(newUrl, 'filters=' + filtersObjFromUrl.filtersApplied) : clearQueryParameters(newUrl, {
      'filters': true
    }));
  });
}
function updateDropdownNavUrlsOnLoad() {
  if (!keepFilters()) {
    return;
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#clear_filters').css('display') !== 'none' && !isNewPage() && !isSearchPage()) {
    var currentUrl = window.location.href;
    var urlParams = getUrlParams(currentUrl, null);
    var filtersObj = updateUrlForFiltersParam(currentUrl);
    appendFilterParamsToDropdownNav(urlParams, filtersObj);
  }
}
function updateUrlForFiltersParam(url) {
  var filtersApplied = '';
  var urlArray = url.split("?");
  if (urlArray.length > 1) {
    filtersApplied = getFiltersApplied(urlArray[1]);
  } else {
    return url;
  }
  var filtersNotApplied = {};
  url = removeURLParameter(url, FILTERS_PARAM_NAME);
  var isAddedFilter = false;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(FILTER_NAMES, function (index, value) {
    if (url.indexOf(value + '=') >= 0 || url.indexOf(value + '%5B%5D=') >= 0) {
      isAddedFilter = true;
      if (filtersApplied.indexOf(value) < 0) {
        filtersApplied = addFilterApplied(filtersApplied, value);
      }
    } else {
      filtersNotApplied[value] = true;
    }
  });
  for (var filterType in filtersNotApplied) {
    filtersApplied = removeFilterApplied(filtersApplied, filterType);
  }
  if (filtersApplied) url = replaceURLParameters(url, FILTERS_PARAM_NAME + '=' + filtersApplied);else url = clearQueryParameters(url, {
    filters: ''
  });
  return {
    url: url,
    isAddedFilter: isAddedFilter,
    filtersApplied: filtersApplied
  };
}
function removeURLParameters(url, parameterNameList) {
  if (url && parameterNameList.length > 0) {
    parameterNameList.forEach(function (parameterName) {
      url = removeURLParameter(url, parameterName);
      url = removeURLParameter(url, parameterName + "[]");
    });
  }
  return url;
}
function clearQueryParameters(url, params) {
  for (var p in params) {
    url = removeURLParameter(url, p);
    url = removeURLParameter(url, p + "[]");
  }
  return url;
}
function appendQuery(url, query) {
  if ("" == query) {
    return url;
  }
  query = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').html(query).text();
  return url + (url.indexOf("?") > -1 ? "&" : "?") + query;
}
function addFilterApplied(filtersAppliedDelimited, filterToAdd) {
  var result;
  if (filtersAppliedDelimited) {
    result = filtersAppliedDelimited.indexOf(filterToAdd) >= 0 ? filtersAppliedDelimited : filtersAppliedDelimited + FILTERS_APPLIED_DELIMITER + filterToAdd;
  } else {
    result = filterToAdd;
  }
  return result;
}
function removeFilterApplied(filtersAppliedDelimited, filterToRemove) {
  // /-{1}filter|filter{1}-|filter/g
  return filtersAppliedDelimited.replaceAll(new RegExp('-{1}' + filterToRemove + '|' + filterToRemove + '-{1}|' + filterToRemove, 'g'), '');
}
function getFiltersApplied(fullQueryString) {
  if (fullQueryString) {
    var qs = fullQueryString.split('&');
    if (qs) {
      for (var i = 0; i < qs.length; ++i) {
        var p = qs[i].split('=', 2);
        if (p[0] === 'filters') {
          return p.length === 1 ? '' : decodeURIComponent(p[1].replace(/\+/g, " ")).replace(/^=/, "");
        }
      }
    }
  }
  return '';
}
function removeHash(url) {
  var scrollV,
    scrollH,
    loc = window.location;
  if ("pushState" in history) {
    var urlWithoutHash = url ? url.replace('#', '') : loc.pathname + loc.search; // Last ditch effort to remove hash
    history.pushState("", document.title, urlWithoutHash);
  } else {
    // Prevent scrolling by storing the page's current scroll offset
    scrollV = document.body.scrollTop;
    scrollH = document.body.scrollLeft;
    loc.hash = "";

    // Restore the scroll offset, should be flicker free
    document.body.scrollTop = scrollV;
    document.body.scrollLeft = scrollH;
  }
}
function resetFilters(urlParams) {
  urlParams.designers = [''];
  urlParams.sizes = [''];
  urlParams.colors = [''];
  urlParams.prices = [''];
  urlParams.heels = [''];
  urlParams.featuredCodes = [''];
  urlParams.arrivalDate = '';
  urlParams.catFilter = '';
  urlParams.pageNum = 1;
}
function getFilterParams(urlParams) {
  var newURL = 'sortBy=' + urlParams.sortBy;
  var i = 0;
  if (urlParams.designers && urlParams.designers[0]) {
    if (urlParams.designers.length === 1) newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      designer: urlParams.designers[0]
    });else newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      designer: urlParams.designers
    }, true);
  }
  if (urlParams.sizes && urlParams.sizes[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      size: urlParams.sizes
    }, true);
  }
  if (urlParams.colors && urlParams.colors[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      color: urlParams.colors
    }, true);
  }
  if (urlParams.prices && urlParams.prices[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      price: urlParams.prices
    }, true);
  }
  if (urlParams.heels && urlParams.heels[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      heel: urlParams.heels
    }, true);
  }
  if (urlParams.conditions && urlParams.conditions[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      condition: urlParams.conditions
    }, true);
  }
  if (urlParams.category && urlParams.category[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      category: urlParams.category
    }, true);
  }
  if (urlParams.featuredCodes) {
    for (i = 0; i < urlParams.featuredCodes.length; i++) {
      if (urlParams.featuredCodes[i] != '') {
        newURL = newURL + '&featuredCodes=' + encodeURIComponent(urlParams.featuredCodes[i]);
      }
    }
  }
  if (urlParams.catFilter) {
    newURL = newURL + '&catFilter=' + encodeURIComponent(urlParams.catFilter);
  }
  if (urlParams.department) {
    newURL = newURL + '&d=' + encodeURIComponent(urlParams.department);
  }
  newURL = newURL + '&pageNum=' + urlParams.pageNum;
  return newURL;
}

// Prepare the path string.
// If '?' is not followed by '&' then replace it with with '?&'
function prepareForSafeRemove(path) {
  return path.replace(/\?(?!&)/, "?&");
}

// Remove all occurrences of param and its values
function safeRemoveParam(path, param) {
  return path.replace(new RegExp("[&]+" + param + "=[^&\\b]*", "g"), '');
}

// Cleanup the path.
// Replace '?&' with '?
function cleanUpAfterSafeRemove(path) {
  path = path.replace(/\?&+/, '?');
  return path.replace(new RegExp("&{2,}", "g"), '&');
}
function removeFilterParams(urlParams) {
  var resultPath = urlParams.path;
  resultPath = prepareForSafeRemove(resultPath);
  resultPath = safeRemoveParam(resultPath, "sortBy");
  resultPath = safeRemoveParam(resultPath, "designer");
  resultPath = safeRemoveParam(resultPath, "size");
  resultPath = safeRemoveParam(resultPath, "color");
  resultPath = safeRemoveParam(resultPath, "heel");
  resultPath = safeRemoveParam(resultPath, "price");
  resultPath = safeRemoveParam(resultPath, 'condition');
  resultPath = safeRemoveParam(resultPath, 'category');
  resultPath = safeRemoveParam(resultPath, "featuredCodes");
  resultPath = safeRemoveParam(resultPath, "catFilter");
  resultPath = safeRemoveParam(resultPath, "pageNum");
  resultPath = safeRemoveParam(resultPath, "d");
  resultPath = safeRemoveParam(resultPath, 'personalshop');
  resultPath = cleanUpAfterSafeRemove(resultPath);
  return resultPath;
}
function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
    var encodedPrefix = encodeURIComponent(parameter) + '=';
    var unencodedPrefix = parameter + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(encodedPrefix, 0) !== -1) {
        pars.splice(i, 1);
      } else if (pars[i].lastIndexOf(unencodedPrefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
    return url;
  } else {
    return url;
  }
}

// Safe concatenation of url and param strings with taking care of '?' and '&' characters
function safeConcat(url, paramString) {
  var result = '';

  // get rid of the leading '?' or '&' characters
  paramString = removeLeadingChars(paramString);
  var endsWithAmpOrQuestion = /[\?&]$/;
  if (url.indexOf('?') > -1) {
    if (url.match(endsWithAmpOrQuestion)) {
      result = url + paramString;
    } else {
      result = url + '&' + paramString;
    }
  } else {
    result = url + '?' + paramString;
  }
  return result;
}

// Remove the leading '?' or '&' characters
function removeLeadingChars(paramString) {
  // remove RegExp
  return paramString.replace(/^[?&]+/, '');
}

// Replace existing parameters in url with new values in parameterString
function replaceURLParameters(url, parameterString) {
  if (!parameterString) return url;
  var parameters = parameterString.split('&');
  var rtn = url;
  var tmp = '';
  if (parameters) {
    for (var i = 0; i < parameters.length; i++) {
      var p = parameters[i];
      if (p) {
        var parameterPair = p.split('=');
        if (parameterPair && parameterPair.length === 2) {
          rtn = removeURLParameter(rtn, parameterPair[0]);
        }
        tmp = appendQuery(tmp, p);
      }
    }
    rtn = safeConcat(rtn, tmp);
  }
  return rtn;
}

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var productData = {}; // populated via ajax below.
  var codes = []; // List of product codes for which to retrieve data.
  var department = "F"; // Default to women's. Set later when we find out for sure.
  var layoutChangeHandlers = [];
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-plp-container").each(function () {
    var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $swatchContainer = $div.find('.js-plp-swatches');
    if ($swatchContainer.length) {
      createSwatchDropDown($div.find(".js-plp-swatches"));
    }
    createSwatchClickHandlers(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("layout-change", onLayoutChange);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "/r/ajax/GetSwatchData.jsp",
    dataType: "json",
    method: "POST",
    data: {
      product: codes,
      department: department,
      mobile: true
    },
    success: function success(json) {
      productData = json;
    }
  });

  // columnView.js fires a custom event when it changes the layout.
  function onLayoutChange(event) {
    // This doesn't need to be synchronous. Let the event handler return
    // to re-flowing the page.
    window.setTimeout(function () {
      layoutChangeHandlers.forEach(function (f) {
        try {
          f(event);
        } catch (e) {
          console.log(e);
        }
      });
    }, 1);
  }
  function createSwatchClickHandlers($div) {
    var $heart = $div.find('.fav-item');
    var $qv = $div.find(".js-plp-quickview");
    var $img = $div.find(".js-plp-image"); // *Seems to be the only one... need to add class.
    var $name = $div.find(".js-plp-name");
    var $brand = $div.find(".js-plp-brand");
    var $price = $div.find(".js-plp-price");
    var $link = $div.find(".js-plp-pdp-link");
    var $retail = $div.find(".js-plp-price-retail");
    var $swatches = $div.find(".js-plp-swatch");
    $swatches.each(function () {
      var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code");
      department = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("department") || department; // Just stomp on the value. Last one wins.
      codes.push(code);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).click(function () {
        $swatches.removeClass("is-toggled"); // desktop
        $swatches.removeClass("plp_active_color "); // mobile
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("is-toggled"); // desktop
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("plp_active_color"); // mobile
        if (code in productData) {
          var prod = productData[code];
          var srcset = $img.attr("srcset");
          var oldProdCode = $img.closest('div').data('code');
          if (typeof srcset === "undefined") {
            srcset = $img.data("srcset");
          }
          $img.attr("srcset", srcset.replaceAll(oldProdCode, code));
          $img.closest('div').data('code', code);
          $img.attr("src", prod.imgPlp);
          $name.html(prod.name);
          $brand.html(prod.brand);
          $price.html(prod.price);
          $retail.html(prod.retailPrice);
          $link.prop("href", prod.url);
          $qv.attr("data-code", code); // Updates parameter value to Quick View code.

          //update heart status
          $heart.attr("data-pcode", code);
          $heart.toggleClass("favorite-button--active", prod.isFavorite);
        }
      });
    });
    $heart.click(function () {
      var code = this.getAttribute("data-pcode");
      if (productData[code]) {
        productData[code].isFavorite = !productData[code].isFavorite;
      }
    });
  }
  function createSwatchDropDown($container) {
    var visible;
    var expanded;
    function toggleSwatches() {
      visible ? hide() : show();
    }
    function hide() {
      $container.animate({
        height: contracted
      }, 200, function () {
        $up.hide();
        $down.show();
        visible = false;
      });
    }
    function show() {
      $container.animate({
        height: expanded
      }, 200, function () {
        $down.hide();
        $up.show();
        visible = true;
      });
    }
    function init() {
      $container.css("height", ""); // Let the element expand/contract to its natural height.
      var containerWidth = $container.width();
      var numWide = Math.floor(containerWidth / swatchWidth);
      if (numWide >= numSwatches) {
        $toggle.hide();
      } else {
        $toggle.show();
        expanded = $container.height();
        $up.hide();
        $down.show();
        $container.height(contracted);
        visible = false;
      }
    }
    if ($container.find(".js-plp-swatch").length > 1) {
      visible = false;
      var $swatches = $container.find(".js-plp-swatch");
      var $toggle = $container.find(".js-swatch-toggle-container");
      var $down = $toggle.find(".js-swatch-toggle-down");
      var $up = $toggle.find(".js-swatch-toggle-up");
      var numSwatches = $swatches.length;

      // Keep some dimensions handy.
      // We can't reliably determine the height of a single row of swatches, since we'd need to take into account
      // padding, margins, etc. $.position() is likewise unreliable since it returns a position relative to the
      // nearest offsetParent, which depends on CSS properties and might not be the actual parent. So we take a
      // good guess: we know how many rows there are, and we figure they're probably devided more-or-less evenly.
      var swatchWidth = $swatches.outerWidth() + Math.max(parseInt($swatches.css("margin-right")), parseInt($swatches.css("margin-left")));
      var swatchHeight = $swatches.outerHeight() + Math.max(parseInt($swatches.css("margin-top")), parseInt($swatches.css("margin-bottom")));
      var numRows = Math.floor($container.height() / swatchHeight);
      expanded = 0;
      var contracted = Math.ceil($container.outerHeight() / numRows);
      $container.css("overflow-y", "hidden");
      layoutChangeHandlers.push(init);
      init();
      $down.click(toggleSwatches);
      $up.click(toggleSwatches);
      hide();
    }
  }
});
;

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initSidePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_points_plp_manage_refine_menu__ = __webpack_require__(66);


var initSidePanel = function initSidePanel() {
  if (window.rcProps.sidebarHref) {
    var hrefEncoded = encodeURIComponent(window.location.href);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-side-panel-sort-filter').sidePanel({
      url: "".concat(window.rcProps.sidebarHref, "?url=").concat(hrefEncoded),
      onAjaxLoad: function onAjaxLoad() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-side-panel').accordion({
          onLoad: function onLoad() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.side-panel__panel').animate({
              scrollTop: 0
            }, 200);
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__entry_points_plp_manage_refine_menu__["a" /* default */])();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all').productFilterClearAll();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-search').productFilterSearch();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-active-button').productFilterActiveButton();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-count').productFilterCount();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#side-panel__overlay, #done_filters').on('click', function () {
          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all').length) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-side-panel').accordion('closeAll');
          }
        });
      }
    });
  }
};

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOG; });
/* unused harmony export LOG_LEVEL */
/* unused harmony export buildAdClick */
/* unused harmony export buildAdConversion */
/* unused harmony export buildAdImpression */
/* unused harmony export buildAddToCart */
/* unused harmony export buildConsentGranted */
/* unused harmony export buildConsentWithdrawn */
/* unused harmony export buildEcommerceTransaction */
/* unused harmony export buildEcommerceTransactionItem */
/* unused harmony export buildFormFocusOrChange */
/* unused harmony export buildFormSubmission */
/* unused harmony export buildLinkClick */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return buildPagePing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return buildPageView; });
/* unused harmony export buildRemoveFromCart */
/* unused harmony export buildScreenView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildSelfDescribingEvent; });
/* unused harmony export buildSiteSearch */
/* unused harmony export buildSocialInteraction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildStructEvent; });
/* unused harmony export getRuleParts */
/* unused harmony export getSchemaParts */
/* unused harmony export globalContexts */
/* unused harmony export isConditionalContextProvider */
/* unused harmony export isContextCallbackFunction */
/* unused harmony export isContextPrimitive */
/* unused harmony export isFilterProvider */
/* unused harmony export isJson */
/* unused harmony export isNonEmptyJson */
/* unused harmony export isRuleSet */
/* unused harmony export isRuleSetProvider */
/* unused harmony export isSelfDescribingJson */
/* unused harmony export isStringArray */
/* unused harmony export isValidRule */
/* unused harmony export isValidRuleSetArg */
/* unused harmony export matchSchemaAgainstRule */
/* unused harmony export matchSchemaAgainstRuleSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return newEmitter; });
/* unused harmony export newEventStorePayload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newInMemoryEventStore; });
/* unused harmony export payloadBuilder */
/* unused harmony export payloadJsonProcessor */
/* unused harmony export pluginContexts */
/* unused harmony export removeEmptyProperties */
/* unused harmony export resolveDynamicContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackerCore; });
/* unused harmony export validateVendor */
/* unused harmony export validateVendorParts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow JavaScript trackers v4.8.2 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */



var version$1 = "4.8.2";

/*
 * Copyright (c) 2013 Kevin van Zonneveld (http://kvz.io)
 * and Contributors (http://phpjs.org/authors)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/**
 * Decodes a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to decode
 * @returns The decoded string
 */
function base64urldecode(data) {
  if (!data) {
    return data;
  }
  var padding = 4 - data.length % 4;
  switch (padding) {
    case 2:
      data += '==';
      break;
    case 3:
      data += '=';
      break;
  }
  var b64Data = data.replace(/-/g, '+').replace(/_/g, '/');
  return base64decode(b64Data);
}
/**
 * Encodes a string into a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to encode
 * @returns The url safe Base 64 string
 */
function base64urlencode(data) {
  if (!data) {
    return data;
  }
  var enc = base64encode(data);
  return enc.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encode string as base64.
 * Any type can be passed, but will be stringified
 *
 * @param data - string to encode
 * @returns base64-encoded string
 */
function base64encode(data) {
  // discuss at: http://phpjs.org/functions/base64_encode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Bayron Guevara
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Rafał Kukawski (http://kukawski.pl)
  // bugfixed by: Pellentesque Malesuada
  // example 1: base64_encode('Kevin van Zonneveld');
  // returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
  // example 2: base64_encode('a');
  // returns 2: 'YQ=='
  // example 3: base64_encode('✓ à la mode');
  // returns 3: '4pyTIMOgIGxhIG1vZGU='
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0;
  var tmp_arr = [];
  if (!data) {
    return data;
  }
  data = unescape(encodeURIComponent(data));
  do {
    // pack three octets into four hexets
    o1 = data.charCodeAt(i++);
    o2 = data.charCodeAt(i++);
    o3 = data.charCodeAt(i++);
    bits = o1 << 16 | o2 << 8 | o3;
    h1 = bits >> 18 & 0x3f;
    h2 = bits >> 12 & 0x3f;
    h3 = bits >> 6 & 0x3f;
    h4 = bits & 0x3f;
    // use hexets to index into b64, and append result to encoded string
    tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
  } while (i < data.length);
  var enc = tmp_arr.join('');
  var r = data.length % 3;
  return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}
/**
 * Decode base64 to string
 *
 * @param data - base64 to string
 * @returns decoded string
 */
function base64decode(encodedData) {
  //  discuss at: http://locutus.io/php/base64_decode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Kevin van Zonneveld (http://kvz.io)
  //    input by: Aman Gupta
  //    input by: Brett Zamir (http://brett-zamir.me)
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  // bugfixed by: Pellentesque Malesuada
  // bugfixed by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Indigo744
  //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==')
  //   returns 1: 'Kevin van Zonneveld'
  //   example 2: base64_decode('YQ==')
  //   returns 2: 'a'
  //   example 3: base64_decode('4pyTIMOgIGxhIG1vZGU=')
  //   returns 3: '✓ à la mode'
  // decodeUTF8string()
  // Internal function to decode properly UTF8 string
  // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
  var decodeUTF8string = function decodeUTF8string(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  };
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0,
    dec = '';
  var tmpArr = [];
  if (!encodedData) {
    return encodedData;
  }
  encodedData += '';
  do {
    // unpack four hexets into three octets using index points in b64
    h1 = b64.indexOf(encodedData.charAt(i++));
    h2 = b64.indexOf(encodedData.charAt(i++));
    h3 = b64.indexOf(encodedData.charAt(i++));
    h4 = b64.indexOf(encodedData.charAt(i++));
    bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
    o1 = bits >> 16 & 0xff;
    o2 = bits >> 8 & 0xff;
    o3 = bits & 0xff;
    if (h3 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1);
    } else if (h4 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1, o2);
    } else {
      tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
    }
  } while (i < encodedData.length);
  dec = tmpArr.join('');
  return decodeUTF8string(dec.replace(/\0+$/, ''));
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
function payloadBuilder() {
  var dict = {},
    allJson = [],
    jsonForProcessing = [],
    contextEntitiesForProcessing = [];
  var processor;
  var add = function add(key, value) {
    if (value != null && value !== '') {
      // null also checks undefined
      dict[key] = value;
    }
  };
  var addDict = function addDict(dict) {
    for (var key in dict) {
      if (Object.prototype.hasOwnProperty.call(dict, key)) {
        add(key, dict[key]);
      }
    }
  };
  var addJson = function addJson(keyIfEncoded, keyIfNotEncoded, json) {
    if (json && isNonEmptyJson(json)) {
      var jsonWithKeys = {
        keyIfEncoded: keyIfEncoded,
        keyIfNotEncoded: keyIfNotEncoded,
        json: json
      };
      jsonForProcessing.push(jsonWithKeys);
      allJson.push(jsonWithKeys);
    }
  };
  var addContextEntity = function addContextEntity(entity) {
    contextEntitiesForProcessing.push(entity);
  };
  return {
    add: add,
    addDict: addDict,
    addJson: addJson,
    addContextEntity: addContextEntity,
    getPayload: function getPayload() {
      return dict;
    },
    getJson: function getJson() {
      return allJson;
    },
    withJsonProcessor: function withJsonProcessor(jsonProcessor) {
      processor = jsonProcessor;
    },
    build: function build() {
      processor === null || processor === void 0 ? void 0 : processor(this, jsonForProcessing, contextEntitiesForProcessing);
      return dict;
    }
  };
}
/**
 * A helper to build a Snowplow request from a set of name-value pairs, provided using the add methods.
 * Will base64 encode JSON, if desired, on build
 *
 * @returns The request builder, with add and build methods
 */
function payloadJsonProcessor(encodeBase64) {
  return function (payloadBuilder, jsonForProcessing, contextEntitiesForProcessing) {
    var add = function add(json, keyIfEncoded, keyIfNotEncoded) {
      var str = JSON.stringify(json);
      if (encodeBase64) {
        payloadBuilder.add(keyIfEncoded, base64urlencode(str));
      } else {
        payloadBuilder.add(keyIfNotEncoded, str);
      }
    };
    var getContextFromPayload = function getContextFromPayload() {
      var payload = payloadBuilder.getPayload();
      if (encodeBase64 ? payload.cx : payload.co) {
        return JSON.parse(encodeBase64 ? base64urldecode(payload.cx) : payload.co);
      }
      return undefined;
    };
    var combineContexts = function combineContexts(originalContext, newContext) {
      var context = originalContext || getContextFromPayload();
      if (context) {
        context.data = context.data.concat(newContext.data);
      } else {
        context = newContext;
      }
      return context;
    };
    var context = undefined;
    for (var _i = 0, jsonForProcessing_1 = jsonForProcessing; _i < jsonForProcessing_1.length; _i++) {
      var json = jsonForProcessing_1[_i];
      if (json.keyIfEncoded === 'cx') {
        context = combineContexts(context, json.json);
      } else {
        add(json.json, json.keyIfEncoded, json.keyIfNotEncoded);
      }
    }
    jsonForProcessing.length = 0;
    if (contextEntitiesForProcessing.length) {
      var newContext = {
        schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], contextEntitiesForProcessing, true)
      };
      context = combineContexts(context, newContext);
      contextEntitiesForProcessing.length = 0;
    }
    if (context) {
      add(context, 'cx', 'co');
    }
  };
}
/**
 * Is property a non-empty JSON?
 * @param property - Checks if object is non-empty json
 */
function isNonEmptyJson(property) {
  if (!isJson(property)) {
    return false;
  }
  for (var key in property) {
    if (Object.prototype.hasOwnProperty.call(property, key)) {
      return true;
    }
  }
  return false;
}
/**
 * Is property a JSON?
 * @param property - Checks if object is json
 */
function isJson(property) {
  return typeof property !== 'undefined' && property !== null && (property.constructor === {}.constructor || property.constructor === [].constructor);
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var label = 'Snowplow: ';
var LOG_LEVEL;
(function (LOG_LEVEL) {
  LOG_LEVEL[LOG_LEVEL["none"] = 0] = "none";
  LOG_LEVEL[LOG_LEVEL["error"] = 1] = "error";
  LOG_LEVEL[LOG_LEVEL["warn"] = 2] = "warn";
  LOG_LEVEL[LOG_LEVEL["debug"] = 3] = "debug";
  LOG_LEVEL[LOG_LEVEL["info"] = 4] = "info";
})(LOG_LEVEL || (LOG_LEVEL = {}));
var LOG = logger();
function logger(logLevel) {
  if (logLevel === void 0) {
    logLevel = LOG_LEVEL.warn;
  }
  function setLogLevel(level) {
    if (LOG_LEVEL[level]) {
      logLevel = level;
    } else {
      logLevel = LOG_LEVEL.warn;
    }
  }
  /**
   * Log errors, with or without error object
   */
  function error(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.error && typeof console !== 'undefined') {
      var logMsg = label + message + '\n';
      if (error) {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log warnings, with or without error object
   */
  function warn(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.warn && typeof console !== 'undefined') {
      var logMsg = label + message;
      if (error) {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log debug messages
   */
  function debug(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.debug && typeof console !== 'undefined') {
      console.debug.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  /**
   * Log info messages
   */
  function info(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.info && typeof console !== 'undefined') {
      console.info.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  return {
    setLogLevel: setLogLevel,
    warn: warn,
    error: error,
    debug: debug,
    info: info
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Contains helper functions to aid in the addition and removal of Global Contexts
 */
function globalContexts() {
  var globalPrimitives = [];
  var conditionalProviders = [];
  var namedPrimitives = {};
  var namedConditionalProviders = {};
  /**
   * Returns all applicable global contexts for a specified event
   * @param event - The event to check for applicable global contexts for
   * @returns An array of contexts
   */
  var assembleAllContexts = function assembleAllContexts(event) {
    var eventSchema = getUsefulSchema(event);
    var eventType = getEventType(event);
    var contexts = [];
    var generatedPrimitives = generatePrimitives(globalPrimitives.concat(Object.values(namedPrimitives)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedPrimitives);
    var generatedConditionals = generateConditionals(conditionalProviders.concat(Object.values(namedConditionalProviders)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedConditionals);
    return contexts;
  };
  return {
    getGlobalPrimitives: function getGlobalPrimitives() {
      return globalPrimitives.concat(Object.values(namedPrimitives));
    },
    getConditionalProviders: function getConditionalProviders() {
      return conditionalProviders.concat(Object.values(namedConditionalProviders));
    },
    addGlobalContexts: function addGlobalContexts(contexts) {
      if (Array.isArray(contexts)) {
        var acceptedConditionalContexts = [];
        var acceptedContextPrimitives = [];
        for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
          var context = contexts_1[_i];
          if (isConditionalContextProvider(context)) {
            acceptedConditionalContexts.push(context);
          } else if (isContextPrimitive(context)) {
            acceptedContextPrimitives.push(context);
          }
        }
        globalPrimitives = globalPrimitives.concat(acceptedContextPrimitives);
        conditionalProviders = conditionalProviders.concat(acceptedConditionalContexts);
      } else {
        for (var _a = 0, _b = Object.entries(contexts); _a < _b.length; _a++) {
          var _c = _b[_a],
            name_1 = _c[0],
            context = _c[1];
          if (isConditionalContextProvider(context)) {
            namedConditionalProviders[name_1] = context;
          } else if (isContextPrimitive(context)) {
            namedPrimitives[name_1] = context;
          }
        }
      }
    },
    clearGlobalContexts: function clearGlobalContexts() {
      conditionalProviders = [];
      globalPrimitives = [];
      namedConditionalProviders = {};
      namedPrimitives = {};
    },
    removeGlobalContexts: function removeGlobalContexts(contexts) {
      var _loop_1 = function _loop_1(context) {
        if (typeof context === 'string') {
          delete namedConditionalProviders[context];
          delete namedPrimitives[context];
        } else if (isConditionalContextProvider(context)) {
          conditionalProviders = conditionalProviders.filter(function (item) {
            return !compareProvider(context, item);
          });
        } else if (isContextPrimitive(context)) {
          globalPrimitives = globalPrimitives.filter(function (item) {
            return !compareProvider(context, item);
          });
        }
      };
      for (var _i = 0, contexts_2 = contexts; _i < contexts_2.length; _i++) {
        var context = contexts_2[_i];
        _loop_1(context);
      }
    },
    getApplicableContexts: function getApplicableContexts(event) {
      return assembleAllContexts(event);
    }
  };
}
function pluginContexts(plugins) {
  /**
   * Add common contexts to every event
   *
   * @param array - additionalContexts List of user-defined contexts
   * @returns userContexts combined with commonContexts
   */
  return {
    addPluginContexts: function addPluginContexts(additionalContexts) {
      var combinedContexts = additionalContexts ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], additionalContexts, true) : [];
      plugins.forEach(function (plugin) {
        try {
          if (plugin.contexts) {
            combinedContexts.push.apply(combinedContexts, plugin.contexts());
          }
        } catch (ex) {
          LOG.error('Error adding plugin contexts', ex);
        }
      });
      return combinedContexts;
    }
  };
}
/**
 * Find dynamic context generating functions and return their results to be merged into the static contexts
 * Combine an array of unchanging contexts with the result of a context-creating function
 *
 * @param dynamicOrStaticContexts - Array of custom context Objects or custom context generating functions
 * @param Parameters - to pass to dynamic context callbacks
 * @returns An array of Self Describing JSON context
 */
function resolveDynamicContext(dynamicOrStaticContexts) {
  var _a;
  var extraParams = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    extraParams[_i - 1] = arguments[_i];
  }
  return (_a = dynamicOrStaticContexts === null || dynamicOrStaticContexts === void 0 ? void 0 : dynamicOrStaticContexts.map(function (context) {
    if (typeof context === 'function') {
      try {
        return context.apply(void 0, extraParams);
      } catch (e) {
        //TODO: provide warning
        return undefined;
      }
    } else {
      return context;
    }
  }).filter(Boolean)) !== null && _a !== void 0 ? _a : [];
}
/**
 * Slices a schema into its composite parts. Useful for ruleset filtering.
 * @param input - A schema string
 * @returns The vendor, schema name, major, minor and patch information of a schema string
 */
function getSchemaParts(input) {
  var re = new RegExp('^iglu:([a-zA-Z0-9-_.]+)/([a-zA-Z0-9-_]+)/jsonschema/([1-9][0-9]*)-(0|[1-9][0-9]*)-(0|[1-9][0-9]*)$');
  var matches = re.exec(input);
  if (matches !== null) return matches.slice(1, 6);
  return undefined;
}
/**
 * Validates the vendor section of a schema string contains allowed wildcard values
 * @param parts - Array of parts from a schema string
 * @returns Whether the vendor validation parts are a valid combination
 */
function validateVendorParts(parts) {
  if (parts[0] === '*' || parts[1] === '*') {
    return false; // no wildcard in first or second part
  }
  if (parts.slice(2).length > 0) {
    var asterisk = false;
    for (var _i = 0, _a = parts.slice(2); _i < _a.length; _i++) {
      var part = _a[_i];
      if (part === '*')
        // mark when we've found a wildcard
        asterisk = true;else if (asterisk)
        // invalid if alpha parts come after wildcard
        return false;
    }
    return true;
  } else if (parts.length == 2) return true;
  return false;
}
/**
 * Validates the vendor part of a schema string is valid for a rule set
 * @param input - Vendor part of a schema string
 * @returns Whether the vendor validation string is valid
 */
function validateVendor(input) {
  var parts = input.split('.');
  if (parts && parts.length > 1) return validateVendorParts(parts);
  return false;
}
/**
 * Checks for validity of input and returns all the sections of a schema string that are used to match rules in a ruleset
 * @param input - A Schema string
 * @returns The sections of a schema string that are used to match rules in a ruleset
 */
function getRuleParts(input) {
  var re = new RegExp('^iglu:((?:(?:[a-zA-Z0-9-_]+|\\*).)+(?:[a-zA-Z0-9-_]+|\\*))/([a-zA-Z0-9-_.]+|\\*)/jsonschema/([1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)$');
  var matches = re.exec(input);
  if (matches !== null && validateVendor(matches[1])) return matches.slice(1, 6);
  return undefined;
}
/**
 * Ensures the rules specified in a schema string of a ruleset are valid
 * @param input - A Schema string
 * @returns if there rule is valid
 */
function isValidRule(input) {
  var ruleParts = getRuleParts(input);
  if (ruleParts) {
    var vendor = ruleParts[0];
    return ruleParts.length === 5 && validateVendor(vendor);
  }
  return false;
}
/**
 * Check if a variable is an Array containing only strings
 * @param input - The variable to validate
 * @returns True if the input is an array containing only strings
 */
function isStringArray(input) {
  return Array.isArray(input) && input.every(function (x) {
    return typeof x === 'string';
  });
}
/**
 * Validates whether a rule set is an array of valid ruleset strings
 * @param input - The Array of rule set arguments
 * @returns True is the input is an array of valid rules
 */
function isValidRuleSetArg(input) {
  if (isStringArray(input)) return input.every(function (x) {
    return isValidRule(x);
  });else if (typeof input === 'string') return isValidRule(input);
  return false;
}
/**
 * Check if a variable is a valid, non-empty Self Describing JSON
 * @param input - The variable to validate
 * @returns True if a valid Self Describing JSON
 */
function isSelfDescribingJson(input) {
  var sdj = input;
  if (isNonEmptyJson(sdj)) if ('schema' in sdj && 'data' in sdj) return typeof sdj.schema === 'string' && _typeof(sdj.data) === 'object';
  return false;
}
/**
 * Validates if the input object contains the expected properties of a ruleset
 * @param input - The object containing a rule set
 * @returns True if a valid rule set
 */
function isRuleSet(input) {
  var ruleSet = input;
  var ruleCount = 0;
  if (input != null && _typeof(input) === 'object' && !Array.isArray(input)) {
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'accept')) {
      if (isValidRuleSetArg(ruleSet['accept'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'reject')) {
      if (isValidRuleSetArg(ruleSet['reject'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    // if either 'reject' or 'accept' or both exists,
    // we have a valid ruleset
    return ruleCount > 0 && ruleCount <= 2;
  }
  return false;
}
/**
 * Validates if the function can be a valid context generator function
 * @param input - The function to be validated
 */
function isContextCallbackFunction(input) {
  return typeof input === 'function' && input.length <= 1;
}
/**
 * Validates if the function can be a valid context primitive function or self describing json
 * @param input - The function or orbject to be validated
 * @returns True if either a Context Generator or Self Describing JSON
 */
function isContextPrimitive(input) {
  return isContextCallbackFunction(input) || isSelfDescribingJson(input);
}
/**
 * Validates if an array is a valid shape to be a Filter Provider
 * @param input - The Array of Context filter callbacks
 */
function isFilterProvider(input) {
  if (Array.isArray(input)) {
    if (input.length === 2) {
      if (Array.isArray(input[1])) {
        return isContextCallbackFunction(input[0]) && input[1].every(isContextPrimitive);
      }
      return isContextCallbackFunction(input[0]) && isContextPrimitive(input[1]);
    }
  }
  return false;
}
/**
 * Validates if an array is a valid shape to be an array of rule sets
 * @param input - The Array of Rule Sets
 */
function isRuleSetProvider(input) {
  if (Array.isArray(input) && input.length === 2) {
    if (!isRuleSet(input[0])) return false;
    if (Array.isArray(input[1])) return input[1].every(isContextPrimitive);
    return isContextPrimitive(input[1]);
  }
  return false;
}
/**
 * Checks if an input array is either a filter provider or a rule set provider
 * @param input - An array of filter providers or rule set providers
 * @returns Whether the array is a valid {@link ConditionalContextProvider}
 */
function isConditionalContextProvider(input) {
  return isFilterProvider(input) || isRuleSetProvider(input);
}
/**
 * Checks if a given schema matches any rules within the provided rule set
 * @param ruleSet - The rule set containing rules to match schema against
 * @param schema - The schema to be matched against the rule set
 */
function matchSchemaAgainstRuleSet(ruleSet, schema) {
  var rejectCount = 0;
  var acceptCount = 0;
  var acceptRules = ruleSet['accept'];
  if (Array.isArray(acceptRules)) {
    if (ruleSet.accept.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      acceptCount++;
    }
  } else if (typeof acceptRules === 'string') {
    if (matchSchemaAgainstRule(acceptRules, schema)) {
      acceptCount++;
    }
  }
  var rejectRules = ruleSet['reject'];
  if (Array.isArray(rejectRules)) {
    if (ruleSet.reject.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      rejectCount++;
    }
  } else if (typeof rejectRules === 'string') {
    if (matchSchemaAgainstRule(rejectRules, schema)) {
      rejectCount++;
    }
  }
  if (acceptCount > 0 && rejectCount === 0) {
    return true;
  } else if (acceptCount === 0 && rejectCount > 0) {
    return false;
  }
  return false;
}
/**
 * Checks if a given schema matches a specific rule from a rule set
 * @param rule - The rule to match schema against
 * @param schema - The schema to be matched against the rule
 */
function matchSchemaAgainstRule(rule, schema) {
  if (!isValidRule(rule)) return false;
  var ruleParts = getRuleParts(rule);
  var schemaParts = getSchemaParts(schema);
  if (ruleParts && schemaParts) {
    if (!matchVendor(ruleParts[0], schemaParts[0])) return false;
    for (var i = 1; i < 5; i++) {
      if (!matchPart(ruleParts[i], schemaParts[i])) return false;
    }
    return true; // if it hasn't failed, it passes
  }
  return false;
}
function matchVendor(rule, vendor) {
  // rule and vendor must have same number of elements
  var vendorParts = vendor.split('.');
  var ruleParts = rule.split('.');
  if (vendorParts && ruleParts) {
    if (vendorParts.length !== ruleParts.length) return false;
    for (var i = 0; i < ruleParts.length; i++) {
      if (!matchPart(vendorParts[i], ruleParts[i])) return false;
    }
    return true;
  }
  return false;
}
function matchPart(rule, schema) {
  // parts should be the string nested between slashes in the URI: /example/
  return rule && schema && rule === '*' || rule === schema;
}
// Returns the "useful" schema, i.e. what would someone want to use to identify events.
// For some events this is the 'e' property but for unstructured events, this is the
// 'schema' from the 'ue_px' field.
function getUsefulSchema(sb) {
  var eventJson = sb.getJson();
  for (var _i = 0, eventJson_1 = eventJson; _i < eventJson_1.length; _i++) {
    var json = eventJson_1[_i];
    if (json.keyIfEncoded === 'ue_px' && _typeof(json.json['data']) === 'object') {
      var schema = json.json['data']['schema'];
      if (typeof schema == 'string') {
        return schema;
      }
    }
  }
  return '';
}
function getEventType(payloadBuilder) {
  var eventType = payloadBuilder.getPayload()['e'];
  return typeof eventType === 'string' ? eventType : '';
}
function buildGenerator(generator, event, eventType, eventSchema) {
  var contextGeneratorResult = undefined;
  try {
    // try to evaluate context generator
    var args = {
      event: event.getPayload(),
      eventType: eventType,
      eventSchema: eventSchema
    };
    contextGeneratorResult = generator(args);
    // determine if the produced result is a valid SDJ
    if (Array.isArray(contextGeneratorResult) && contextGeneratorResult.every(isSelfDescribingJson)) {
      return contextGeneratorResult;
    } else if (isSelfDescribingJson(contextGeneratorResult)) {
      return contextGeneratorResult;
    } else {
      return undefined;
    }
  } catch (error) {
    contextGeneratorResult = undefined;
  }
  return contextGeneratorResult;
}
function normalizeToArray(input) {
  if (Array.isArray(input)) {
    return input;
  }
  return Array.of(input);
}
function generatePrimitives(contextPrimitives, event, eventType, eventSchema) {
  var _a;
  var normalizedInputs = normalizeToArray(contextPrimitives);
  var partialEvaluate = function partialEvaluate(primitive) {
    var result = evaluatePrimitive(primitive, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInputs.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}
function evaluatePrimitive(contextPrimitive, event, eventType, eventSchema) {
  if (isSelfDescribingJson(contextPrimitive)) {
    return [contextPrimitive];
  } else if (isContextCallbackFunction(contextPrimitive)) {
    var generatorOutput = buildGenerator(contextPrimitive, event, eventType, eventSchema);
    if (isSelfDescribingJson(generatorOutput)) {
      return [generatorOutput];
    } else if (Array.isArray(generatorOutput)) {
      return generatorOutput;
    }
  }
  return undefined;
}
function evaluateProvider(provider, event, eventType, eventSchema) {
  if (isFilterProvider(provider)) {
    var filter = provider[0];
    var filterResult = false;
    try {
      var args = {
        event: event.getPayload(),
        eventType: eventType,
        eventSchema: eventSchema
      };
      filterResult = filter(args);
    } catch (error) {
      filterResult = false;
    }
    if (filterResult === true) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  } else if (isRuleSetProvider(provider)) {
    if (matchSchemaAgainstRuleSet(provider[0], eventSchema)) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  }
  return [];
}
function compareProviderPart(a, b) {
  if (typeof a === 'function') return a === b;
  return JSON.stringify(a) === JSON.stringify(b);
}
function compareProvider(a, b) {
  if (isConditionalContextProvider(a)) {
    if (!isConditionalContextProvider(b)) return false;
    var ruleA = a[0],
      primitivesA = a[1];
    var ruleB = b[0],
      primitivesB_1 = b[1];
    if (!compareProviderPart(ruleA, ruleB)) return false;
    if (Array.isArray(primitivesA)) {
      if (!Array.isArray(primitivesB_1)) return false;
      if (primitivesA.length !== primitivesB_1.length) return false;
      return primitivesA.reduce(function (matches, a, i) {
        return matches && compareProviderPart(a, primitivesB_1[i]);
      }, true);
    } else {
      if (Array.isArray(primitivesB_1)) return false;
      return compareProviderPart(primitivesA, primitivesB_1);
    }
  } else if (isContextPrimitive(a)) {
    if (!isContextPrimitive(b)) return false;
    return compareProviderPart(a, b);
  }
  return false;
}
function generateConditionals(providers, event, eventType, eventSchema) {
  var _a;
  var normalizedInput = normalizeToArray(providers);
  var partialEvaluate = function partialEvaluate(provider) {
    var result = evaluateProvider(provider, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInput.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}

/**
 * Create a new EventStorePayload
 */
function newEventStorePayload(_a) {
  var payload = _a.payload,
    _b = _a.svrAnon,
    svrAnon = _b === void 0 ? false : _b;
  return {
    payload: payload,
    svrAnon: svrAnon
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Transform optional/old-behavior number timestamp into`Timestamp` ADT
 *
 * @param timestamp - optional number or timestamp object
 * @returns correct timestamp object
 */
function getTimestamp(timestamp) {
  if (timestamp == null) {
    return {
      type: 'dtm',
      value: new Date().getTime()
    };
  } else if (typeof timestamp === 'number') {
    return {
      type: 'dtm',
      value: timestamp
    };
  } else if (timestamp.type === 'ttm') {
    // We can return timestamp here, but this is safer fallback
    return {
      type: 'ttm',
      value: timestamp.value
    };
  } else {
    return {
      type: 'dtm',
      value: timestamp.value || new Date().getTime()
    };
  }
}
/**
 * Create a tracker core object
 *
 * @param base64 - Whether to base 64 encode contexts and self describing event JSONs
 * @param corePlugins - The core plugins to be processed with each event
 * @param callback - Function applied to every payload dictionary object
 * @returns Tracker core
 */
function trackerCore(configuration) {
  if (configuration === void 0) {
    configuration = {};
  }
  function newCore(base64, corePlugins, callback) {
    var pluginContextsHelper = pluginContexts(corePlugins),
      globalContextsHelper = globalContexts();
    var encodeBase64 = base64,
      payloadPairs = {}; // Dictionary of key-value pairs which get added to every payload, e.g. tracker version
    /**
     * Wraps an array of custom contexts in a self-describing JSON
     *
     * @param contexts - Array of custom context self-describing JSONs
     * @returns Outer JSON
     */
    function completeContexts(contexts) {
      if (contexts && contexts.length) {
        return {
          schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
          data: contexts
        };
      }
      return undefined;
    }
    /**
     * Adds all global contexts to a contexts array
     *
     * @param pb - PayloadData
     * @param contexts - Custom contexts relating to the event
     */
    function attachGlobalContexts(pb, contexts) {
      var applicableContexts = globalContextsHelper.getApplicableContexts(pb);
      var returnedContexts = [];
      if (contexts && contexts.length) {
        returnedContexts.push.apply(returnedContexts, contexts);
      }
      if (applicableContexts && applicableContexts.length) {
        returnedContexts.push.apply(returnedContexts, applicableContexts);
      }
      return returnedContexts;
    }
    /**
     * Gets called by every trackXXX method
     * Adds context and payloadPairs name-value pairs to the payload
     * Applies the callback to the built payload
     *
     * @param pb - Payload
     * @param context - Custom contexts relating to the event
     * @param timestamp - Timestamp of the event
     * @returns Payload after the callback is applied or undefined if the event is skipped
     */
    function track(pb, context, timestamp) {
      if (!active) {
        LOG.error('Track called on deactivated tracker');
        return undefined;
      }
      pb.withJsonProcessor(payloadJsonProcessor(encodeBase64));
      pb.add('eid', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_uuid__["a" /* v4 */])());
      pb.addDict(payloadPairs);
      var tstamp = getTimestamp(timestamp);
      pb.add(tstamp.type, tstamp.value.toString());
      var allContexts = attachGlobalContexts(pb, pluginContextsHelper.addPluginContexts(context));
      var wrappedContexts = completeContexts(allContexts);
      if (wrappedContexts !== undefined) {
        pb.addJson('cx', 'co', wrappedContexts);
      }
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.beforeTrack) {
            plugin.beforeTrack(pb);
          }
        } catch (ex) {
          LOG.error('Plugin beforeTrack', ex);
        }
      });
      // Call the filter on plugins to determine if the event should be tracked
      var skip = corePlugins.find(function (plugin) {
        try {
          return plugin.filter && plugin.filter(pb.build()) === false;
        } catch (ex) {
          LOG.error('Plugin filter', ex);
          return false;
        }
      });
      if (skip) {
        return undefined;
      }
      if (typeof callback === 'function') {
        callback(pb);
      }
      var finalPayload = pb.build();
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.afterTrack) {
            plugin.afterTrack(finalPayload);
          }
        } catch (ex) {
          LOG.error('Plugin afterTrack', ex);
        }
      });
      return finalPayload;
    }
    /**
     * Set a persistent key-value pair to be added to every payload
     *
     * @param key - Field name
     * @param value - Field value
     */
    function addPayloadPair(key, value) {
      payloadPairs[key] = value;
    }
    var core = {
      track: track,
      addPayloadPair: addPayloadPair,
      getBase64Encoding: function getBase64Encoding() {
        return encodeBase64;
      },
      setBase64Encoding: function setBase64Encoding(encode) {
        encodeBase64 = encode;
      },
      addPayloadDict: function addPayloadDict(dict) {
        for (var key in dict) {
          if (Object.prototype.hasOwnProperty.call(dict, key)) {
            payloadPairs[key] = dict[key];
          }
        }
      },
      resetPayloadPairs: function resetPayloadPairs(dict) {
        payloadPairs = isJson(dict) ? dict : {};
      },
      setTrackerVersion: function setTrackerVersion(version) {
        addPayloadPair('tv', version);
      },
      setTrackerNamespace: function setTrackerNamespace(name) {
        addPayloadPair('tna', name);
      },
      setAppId: function setAppId(appId) {
        addPayloadPair('aid', appId);
      },
      setPlatform: function setPlatform(value) {
        addPayloadPair('p', value);
      },
      setUserId: function setUserId(userId) {
        addPayloadPair('uid', userId);
      },
      setScreenResolution: function setScreenResolution(width, height) {
        addPayloadPair('res', width + 'x' + height);
      },
      setViewport: function setViewport(width, height) {
        addPayloadPair('vp', width + 'x' + height);
      },
      setColorDepth: function setColorDepth(depth) {
        addPayloadPair('cd', depth);
      },
      setTimezone: function setTimezone(timezone) {
        addPayloadPair('tz', timezone);
      },
      setLang: function setLang(lang) {
        addPayloadPair('lang', lang);
      },
      setIpAddress: function setIpAddress(ip) {
        addPayloadPair('ip', ip);
      },
      setUseragent: function setUseragent(useragent) {
        addPayloadPair('ua', useragent);
      },
      addGlobalContexts: function addGlobalContexts(contexts) {
        globalContextsHelper.addGlobalContexts(contexts);
      },
      clearGlobalContexts: function clearGlobalContexts() {
        globalContextsHelper.clearGlobalContexts();
      },
      removeGlobalContexts: function removeGlobalContexts(contexts) {
        globalContextsHelper.removeGlobalContexts(contexts);
      }
    };
    return core;
  }
  var active = true;
  var base64 = configuration.base64,
    corePlugins = configuration.corePlugins,
    callback = configuration.callback,
    plugins = corePlugins !== null && corePlugins !== void 0 ? corePlugins : [],
    partialCore = newCore(base64 !== null && base64 !== void 0 ? base64 : true, plugins, callback),
    core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, partialCore), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        var plugin = configuration.plugin;
        plugins.push(plugin);
        (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
        (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
      },
      deactivate: function deactivate() {
        plugins.forEach(function (plugin) {
          var _a;
          (_a = plugin.deactivatePlugin) === null || _a === void 0 ? void 0 : _a.call(plugin, core);
        });
        plugins.length = 0;
        active = false;
      }
    });
  plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
    var _a, _b;
    (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
    (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
  });
  return core;
}
/**
 * Build a self-describing event
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - Contains the properties and schema location for the event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSelfDescribingEvent(event) {
  var _a = event.event,
    schema = _a.schema,
    data = _a.data,
    pb = payloadBuilder();
  var ueJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/unstruct_event/jsonschema/1-0-0',
    data: {
      schema: schema,
      data: data
    }
  };
  pb.add('e', 'ue');
  pb.addJson('ue_px', 'ue_pr', ueJson);
  return pb;
}
/**
 * Build a Page View Event
 * Represents a Page View, which is typically fired as soon as possible when a web page
 * is loaded within the users browser. Often also fired on "virtual page views" within
 * Single Page Applications (SPA).
 *
 * @param event - Contains the properties for the Page View event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPageView(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    pb = payloadBuilder();
  pb.add('e', 'pv'); // 'pv' for Page View
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  return pb;
}
/**
 * Build a Page Ping Event
 * Fires when activity tracking is enabled in the browser.
 * Tracks same information as the last tracked Page View and includes scroll
 * information from the current page view
 *
 * @param event - Contains the properties for the Page Ping event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPagePing(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    minXOffset = event.minXOffset,
    maxXOffset = event.maxXOffset,
    minYOffset = event.minYOffset,
    maxYOffset = event.maxYOffset,
    pb = payloadBuilder();
  pb.add('e', 'pp'); // 'pp' for Page Ping
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  if (minXOffset && !isNaN(Number(minXOffset))) pb.add('pp_mix', minXOffset.toString());
  if (maxXOffset && !isNaN(Number(maxXOffset))) pb.add('pp_max', maxXOffset.toString());
  if (minYOffset && !isNaN(Number(minYOffset))) pb.add('pp_miy', minYOffset.toString());
  if (maxYOffset && !isNaN(Number(maxYOffset))) pb.add('pp_may', maxYOffset.toString());
  return pb;
}
/**
 * Build a Structured Event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - Contains the properties for the Structured event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildStructEvent(event) {
  var category = event.category,
    action = event.action,
    label = event.label,
    property = event.property,
    value = event.value,
    pb = payloadBuilder();
  pb.add('e', 'se'); // 'se' for Structured Event
  pb.add('se_ca', category);
  pb.add('se_ac', action);
  pb.add('se_la', label);
  pb.add('se_pr', property);
  pb.add('se_va', value == null ? undefined : value.toString());
  return pb;
}
/**
 * Build an Ecommerce Transaction Event
 * Allows for tracking common ecommerce events, this event is usually used when
 * a consumer completes a transaction.
 *
 * @param event - Contains the properties for the Ecommerce Transactoion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransaction(event) {
  var orderId = event.orderId,
    total = event.total,
    affiliation = event.affiliation,
    tax = event.tax,
    shipping = event.shipping,
    city = event.city,
    state = event.state,
    country = event.country,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'tr'); // 'tr' for Transaction
  pb.add('tr_id', orderId);
  pb.add('tr_af', affiliation);
  pb.add('tr_tt', total);
  pb.add('tr_tx', tax);
  pb.add('tr_sh', shipping);
  pb.add('tr_ci', city);
  pb.add('tr_st', state);
  pb.add('tr_co', country);
  pb.add('tr_cu', currency);
  return pb;
}
/**
 * Build an Ecommerce Transaction Item Event
 * Related to the {@link buildEcommerceTransaction}
 * Each Ecommerce Transaction may contain one or more EcommerceTransactionItem events
 *
 * @param event - Contains the properties for the Ecommerce Transaction Item event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransactionItem(event) {
  var orderId = event.orderId,
    sku = event.sku,
    price = event.price,
    name = event.name,
    category = event.category,
    quantity = event.quantity,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'ti'); // 'tr' for Transaction Item
  pb.add('ti_id', orderId);
  pb.add('ti_sk', sku);
  pb.add('ti_nm', name);
  pb.add('ti_ca', category);
  pb.add('ti_pr', price);
  pb.add('ti_qu', quantity);
  pb.add('ti_cu', currency);
  return pb;
}
/**
 * Build a Scren View Event
 * Similar to a Page View but less focused on typical web properties
 * Often used for mobile applications as the user is presented with
 * new views as they performance navigation events
 *
 * @param event - Contains the properties for the Screen View event. One or more properties must be included.
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildScreenView(event) {
  var name = event.name,
    id = event.id;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/screen_view/jsonschema/1-0-0',
      data: removeEmptyProperties({
        name: name,
        id: id
      })
    }
  });
}
/**
 * Build a Link Click Event
 * Used when a user clicks on a link on a webpage, typically an anchor tag `<a>`
 *
 * @param event - Contains the properties for the Link Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildLinkClick(event) {
  var targetUrl = event.targetUrl,
    elementId = event.elementId,
    elementClasses = event.elementClasses,
    elementTarget = event.elementTarget,
    elementContent = event.elementContent;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/link_click/jsonschema/1-0-1',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      elementId: elementId,
      elementClasses: elementClasses,
      elementTarget: elementTarget,
      elementContent: elementContent
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Impression Event
 * Used to track an advertisement impression
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Impression event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdImpression(event) {
  var impressionId = event.impressionId,
    costModel = event.costModel,
    cost = event.cost,
    targetUrl = event.targetUrl,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0',
    data: removeEmptyProperties({
      impressionId: impressionId,
      costModel: costModel,
      cost: cost,
      targetUrl: targetUrl,
      bannerId: bannerId,
      zoneId: zoneId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Click Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdClick(event) {
  var targetUrl = event.targetUrl,
    clickId = event.clickId,
    costModel = event.costModel,
    cost = event.cost,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    impressionId = event.impressionId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_click/jsonschema/1-0-0',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      clickId: clickId,
      costModel: costModel,
      cost: cost,
      bannerId: bannerId,
      zoneId: zoneId,
      impressionId: impressionId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Conversion Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Conversion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdConversion(event) {
  var conversionId = event.conversionId,
    costModel = event.costModel,
    cost = event.cost,
    category = event.category,
    action = event.action,
    property = event.property,
    initialValue = event.initialValue,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_conversion/jsonschema/1-0-0',
    data: removeEmptyProperties({
      conversionId: conversionId,
      costModel: costModel,
      cost: cost,
      category: category,
      action: action,
      property: property,
      initialValue: initialValue,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Social Interaction Event
 * Social tracking will be used to track the way users interact
 * with Facebook, Twitter and Google + widgets
 * e.g. to capture “like this” or “tweet this” events.
 *
 * @param event - Contains the properties for the Social Interaction event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSocialInteraction(event) {
  var action = event.action,
    network = event.network,
    target = event.target;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/social_interaction/jsonschema/1-0-0',
    data: removeEmptyProperties({
      action: action,
      network: network,
      target: target
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Add To Cart Event
 * For tracking users adding items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Add To Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAddToCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/add_to_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Remove From Cart Event
 * For tracking users removing items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Remove From Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildRemoveFromCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/remove_from_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Form Focus or Change Form Event based on schema property
 * When a user focuses on a form element or when a user makes a
 * change to a form element.
 *
 * @param event - Contains the properties for the Form Focus or Change Form event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormFocusOrChange(event) {
  var event_schema = '';
  var schema = event.schema,
    formId = event.formId,
    elementId = event.elementId,
    nodeName = event.nodeName,
    elementClasses = event.elementClasses,
    value = event.value,
    type = event.type;
  var event_data = {
    formId: formId,
    elementId: elementId,
    nodeName: nodeName,
    elementClasses: elementClasses,
    value: value
  };
  if (schema === 'change_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0';
    event_data.type = type;
  } else if (schema === 'focus_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0';
    event_data.elementType = type;
  }
  return buildSelfDescribingEvent({
    event: {
      schema: event_schema,
      data: removeEmptyProperties(event_data, {
        value: true
      })
    }
  });
}
/**
 * Build a Form Submission Event
 * Used to track when a user submits a form
 *
 * @param event - Contains the properties for the Form Submission event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormSubmission(event) {
  var formId = event.formId,
    formClasses = event.formClasses,
    elements = event.elements;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
      data: removeEmptyProperties({
        formId: formId,
        formClasses: formClasses,
        elements: elements
      })
    }
  });
}
/**
 * Build a Site Search Event
 * Used when a user performs a search action on a page
 *
 * @param event - Contains the properties for the Site Search event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSiteSearch(event) {
  var terms = event.terms,
    filters = event.filters,
    totalResults = event.totalResults,
    pageResults = event.pageResults;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0',
      data: removeEmptyProperties({
        terms: terms,
        filters: filters,
        totalResults: totalResults,
        pageResults: pageResults
      })
    }
  });
}
/**
 * Build a Consent Withdrawn Event
 * Used for tracking when a user withdraws their consent
 *
 * @param event - Contains the properties for the Consent Withdrawn event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentWithdrawn(event) {
  var all = event.all,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_withdrawn/jsonschema/1-0-0',
        data: removeEmptyProperties({
          all: all
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Build a Consent Granted Event
 * Used for tracking when a user grants their consent
 *
 * @param event - Contains the properties for the Consent Granted event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentGranted(event) {
  var expiry = event.expiry,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_granted/jsonschema/1-0-0',
        data: removeEmptyProperties({
          expiry: expiry
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - JSON object to clean
 * @param exemptFields - Set of fields which should not be removed even if empty
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event, exemptFields) {
  if (exemptFields === void 0) {
    exemptFields = {};
  }
  var ret = {};
  for (var k in event) {
    if (exemptFields[k] || event[k] !== null && typeof event[k] !== 'undefined') {
      ret[k] = event[k];
    }
  }
  return ret;
}
function newInMemoryEventStore(_a) {
  var _b = _a.maxSize,
    maxSize = _b === void 0 ? 1000 : _b,
    _c = _a.events,
    events = _c === void 0 ? [] : _c;
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], events, true);
  var count = function count() {
    return Promise.resolve(store.length);
  };
  return {
    count: count,
    add: function add(payload) {
      store.push(payload);
      while (store.length > maxSize) {
        store.shift();
      }
      return count();
    },
    removeHead: function removeHead(count) {
      for (var i = 0; i < count; i++) {
        store.shift();
      }
      return Promise.resolve();
    },
    iterator: function iterator() {
      var index = 0;
      // copy the store to prevent mutation
      var events = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true);
      return {
        next: function next() {
          if (index < events.length) {
            return Promise.resolve({
              value: events[index++],
              done: false
            });
          }
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
      };
    },
    getAll: function getAll() {
      return Promise.resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true));
    },
    getAllPayloads: function getAllPayloads() {
      return Promise.resolve(store.map(function (e) {
        return e.payload;
      }));
    }
  };
}
var PAYLOAD_DATA_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4';

/**
 * Enclose an array of events in a self-describing payload_data JSON string
 *
 * @param array - events Batch of events
 * @returns string payload_data self-describing JSON
 */
function encloseInPayloadDataEnvelope(events) {
  return JSON.stringify({
    schema: PAYLOAD_DATA_SCHEMA,
    data: events
  });
}
/**
 * Attaches the STM field to outbound POST events.
 *
 * @param events - the events to attach the STM to
 */
function attachStmToEvent(events) {
  var stm = new Date().getTime().toString();
  for (var i = 0; i < events.length; i++) {
    events[i]['stm'] = stm;
  }
  return events;
}
function newEmitterRequest(_a) {
  var endpoint = _a.endpoint,
    _b = _a.protocol,
    protocol = _b === void 0 ? 'https' : _b,
    port = _a.port,
    _c = _a.eventMethod,
    eventMethod = _c === void 0 ? 'post' : _c,
    customHeaders = _a.customHeaders,
    connectionTimeout = _a.connectionTimeout,
    _d = _a.keepalive,
    keepalive = _d === void 0 ? false : _d,
    _e = _a.postPath,
    postPath = _e === void 0 ? '/com.snowplowanalytics.snowplow/tp2' : _e,
    _f = _a.useStm,
    useStm = _f === void 0 ? true : _f,
    _g = _a.maxPostBytes,
    maxPostBytes = _g === void 0 ? 40000 : _g,
    _h = _a.credentials,
    credentials = _h === void 0 ? 'include' : _h;
  var events = [];
  var usePost = eventMethod.toLowerCase() === 'post';
  var timer;
  var abortController;
  function countBytes() {
    var count = events.reduce(function (acc, event) {
      return acc + (usePost ? event.getPOSTRequestBytesCount() : event.getGETRequestBytesCount());
    }, 0);
    if (usePost) {
      count += 88; // 88 bytes for the payload_data envelope
    }
    return count;
  }
  function countEvents() {
    return events.length;
  }
  function getServerAnonymizationOfExistingEvents() {
    return events.length > 0 ? events[0].getServerAnonymization() : undefined;
  }
  function addEvent(event) {
    if (events.length > 0 && getServerAnonymizationOfExistingEvents() !== event.getServerAnonymization()) {
      return false;
    } else {
      events.push(event);
      return true;
    }
  }
  function getEvents() {
    return events;
  }
  function isFull() {
    if (usePost) {
      return countBytes() >= maxPostBytes;
    } else {
      return events.length >= 1;
    }
  }
  function createHeaders() {
    var headers = new Headers();
    if (usePost) {
      headers.append('Content-Type', 'application/json; charset=UTF-8');
    }
    if (customHeaders) {
      Object.keys(customHeaders).forEach(function (key) {
        headers.append(key, customHeaders[key]);
      });
    }
    if (getServerAnonymizationOfExistingEvents()) {
      headers.append('SP-Anonymous', '*');
    }
    return headers;
  }
  function getFullCollectorUrl() {
    var collectorUrl = endpoint;
    if (!endpoint.includes('://')) {
      collectorUrl = "".concat(protocol, "://").concat(endpoint);
    }
    if (port) {
      collectorUrl = "".concat(collectorUrl, ":").concat(port);
    }
    var path = usePost ? postPath : '/i';
    return collectorUrl + path;
  }
  function makeRequest(url, options) {
    closeRequest(false);
    abortController = new AbortController();
    timer = setTimeout(function () {
      var reason = 'Request timed out';
      console.error(reason);
      timer = undefined;
      closeRequest(false, reason);
    }, connectionTimeout !== null && connectionTimeout !== void 0 ? connectionTimeout : 5000);
    var requestOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      headers: createHeaders(),
      signal: abortController.signal,
      keepalive: keepalive,
      credentials: credentials
    }, options);
    var request = new Request(url, requestOptions);
    return request;
  }
  function makePostRequest() {
    var batch = attachStmToEvent(events.map(function (event) {
      return event.getPOSTRequestBody();
    }));
    return makeRequest(getFullCollectorUrl(), {
      method: 'POST',
      body: encloseInPayloadDataEnvelope(batch)
    });
  }
  function makeGetRequest() {
    if (events.length !== 1) {
      throw new Error('Only one event can be sent in a GET request');
    }
    var event = events[0];
    var url = event.getGETRequestURL(getFullCollectorUrl(), useStm);
    return makeRequest(url, {
      method: 'GET'
    });
  }
  function toRequest() {
    if (events.length === 0) {
      return undefined;
    }
    if (usePost) {
      return makePostRequest();
    } else {
      return makeGetRequest();
    }
  }
  function closeRequest(successful, reason) {
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    if (abortController !== undefined) {
      var controller = abortController;
      abortController = undefined;
      if (!successful) {
        controller.abort(reason);
      }
    }
  }
  return {
    addEvent: addEvent,
    getEvents: getEvents,
    toRequest: toRequest,
    countBytes: countBytes,
    countEvents: countEvents,
    isFull: isFull,
    closeRequest: closeRequest
  };
}

/**
 * Count the number of bytes a string will occupy when UTF-8 encoded
 * Taken from http://stackoverflow.com/questions/2848462/count-bytes-in-textarea-using-javascript/
 *
 * @param s - The string
 * @returns number Length of s in bytes when UTF-8 encoded
 */
function getUTF8Length(s) {
  var len = 0;
  for (var i = 0; i < s.length; i++) {
    var code = s.charCodeAt(i);
    if (code <= 0x7f) {
      len += 1;
    } else if (code <= 0x7ff) {
      len += 2;
    } else if (code >= 0xd800 && code <= 0xdfff) {
      // Surrogate pair: These take 4 bytes in UTF-8 and 2 chars in UCS-2
      // (Assume next char is the other [valid] half and just skip it)
      len += 4;
      i++;
    } else if (code < 0xffff) {
      len += 3;
    } else {
      len += 4;
    }
  }
  return len;
}
/*
  * Convert a dictionary to a querystring
  * The context field is the last in the querystring
  */
function getQuerystring(request) {
  var lowPriorityKeys = {
    co: true,
    cx: true
  };
  var args = [];
  for (var key in request) {
    if (request.hasOwnProperty(key) && !lowPriorityKeys[key]) {
      args.push(key + '=' + encodeURIComponent(request[key]));
    }
  }
  for (var contextKey in lowPriorityKeys) {
    if (request.hasOwnProperty(contextKey) && lowPriorityKeys[contextKey]) {
      args.push(contextKey + '=' + encodeURIComponent(request[contextKey]));
    }
  }
  return '?' + args.join('&');
}
/*
  * Convert numeric fields to strings to match payload_data schema
  */
function preparePostBody(request) {
  var cleanedRequest = Object.keys(request).map(function (k) {
    return [k, request[k]];
  }).reduce(function (acc, _a) {
    var key = _a[0],
      value = _a[1];
    acc[key] = value.toString();
    return acc;
  }, {});
  return cleanedRequest;
}
function newEmitterEvent(eventStorePayload) {
  var querystring = null;
  var postBody = null;
  var byteCountGET = null;
  var byteCountPOST = null;
  function getPayload() {
    return eventStorePayload.payload;
  }
  function getServerAnonymization() {
    var _a;
    return (_a = eventStorePayload.svrAnon) !== null && _a !== void 0 ? _a : false;
  }
  function getCachedQuerystring(payload) {
    if (querystring === null) {
      querystring = getQuerystring(payload);
    }
    return querystring;
  }
  function getGETRequestURL(collectorUrl, useStm) {
    var querystring = getCachedQuerystring(getPayload());
    if (useStm) {
      return collectorUrl + querystring.replace('?', '?stm=' + new Date().getTime() + '&');
    }
    return collectorUrl + querystring;
  }
  function getGETRequestBytesCount() {
    if (byteCountGET === null) {
      var querystring_1 = getCachedQuerystring(getPayload());
      byteCountGET = getUTF8Length(querystring_1);
    }
    return byteCountGET;
  }
  function getPOSTRequestBody() {
    if (postBody === null) {
      postBody = preparePostBody(getPayload());
    }
    return postBody;
  }
  function getPOSTRequestBytesCount() {
    if (byteCountPOST === null) {
      byteCountPOST = getUTF8Length(JSON.stringify(getPOSTRequestBody()));
    }
    return byteCountPOST;
  }
  return {
    getPayload: getPayload,
    getServerAnonymization: getServerAnonymization,
    getGETRequestURL: getGETRequestURL,
    getGETRequestBytesCount: getGETRequestBytesCount,
    getPOSTRequestBody: getPOSTRequestBody,
    getPOSTRequestBytesCount: getPOSTRequestBytesCount
  };
}
function newEmitter(_a) {
  var endpoint = _a.endpoint,
    _b = _a.eventMethod,
    eventMethod = _b === void 0 ? 'post' : _b,
    postPath = _a.postPath,
    protocol = _a.protocol,
    port = _a.port,
    _c = _a.maxPostBytes,
    maxPostBytes = _c === void 0 ? 40000 : _c,
    maxGetBytes = _a.maxGetBytes,
    _d = _a.bufferSize,
    bufferSize = _d === void 0 ? 1 : _d,
    customHeaders = _a.customHeaders,
    serverAnonymization = _a.serverAnonymization,
    connectionTimeout = _a.connectionTimeout,
    keepalive = _a.keepalive,
    cookieExtensionService = _a.cookieExtensionService,
    idService = _a.idService,
    _e = _a.dontRetryStatusCodes,
    dontRetryStatusCodes = _e === void 0 ? [] : _e,
    _f = _a.retryStatusCodes,
    retryStatusCodes = _f === void 0 ? [] : _f,
    _g = _a.retryFailedRequests,
    retryFailedRequests = _g === void 0 ? true : _g,
    onRequestFailure = _a.onRequestFailure,
    onRequestSuccess = _a.onRequestSuccess,
    _h = _a.customFetch,
    customFetch = _h === void 0 ? fetch : _h,
    useStm = _a.useStm,
    _j = _a.eventStore,
    eventStore = _j === void 0 ? newInMemoryEventStore({}) : _j,
    credentials = _a.credentials;
  /* `cookieExtensionService` gets priority until `idService` is completely removed. */
  cookieExtensionService = cookieExtensionService || idService;
  var cookieExtensionServiceCalled = false;
  var flushInProgress = false;
  var usePost = eventMethod.toLowerCase() === 'post';
  dontRetryStatusCodes = dontRetryStatusCodes.concat([400, 401, 403, 410, 422]);
  function shouldRetryForStatusCode(statusCode) {
    // success, don't retry
    if (statusCode >= 200 && statusCode < 300) {
      return false;
    }
    if (!retryFailedRequests) {
      return false;
    }
    // retry if status code among custom user-supplied retry codes
    if (retryStatusCodes.includes(statusCode)) {
      return true;
    }
    // retry if status code *not* among the don't retry codes
    return !dontRetryStatusCodes.includes(statusCode);
  }
  function callOnRequestSuccess(payloads, response) {
    if (onRequestSuccess !== undefined) {
      setTimeout(function () {
        try {
          onRequestSuccess === null || onRequestSuccess === void 0 ? void 0 : onRequestSuccess(payloads, response);
        } catch (e) {
          LOG.error('Error in onRequestSuccess', e);
        }
      }, 0);
    }
  }
  function callOnRequestFailure(failure, response) {
    if (onRequestFailure !== undefined) {
      setTimeout(function () {
        try {
          onRequestFailure === null || onRequestFailure === void 0 ? void 0 : onRequestFailure(failure, response);
        } catch (e) {
          LOG.error('Error in onRequestFailure', e);
        }
      }, 0);
    }
  }
  function executeRequest(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var fetchRequest, payloads, response, willRetry, e_1, message;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            fetchRequest = request.toRequest();
            if (fetchRequest === undefined) {
              throw new Error('Empty batch');
            }
            payloads = request.getEvents().map(function (event) {
              return event.getPayload();
            });
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4 /*yield*/, customFetch(fetchRequest)];
          case 2:
            response = _a.sent();
            return [4 /*yield*/, response.text()];
          case 3:
            _a.sent(); // wait for the response to be fully read
            request.closeRequest(true);
            if (response.ok) {
              callOnRequestSuccess(payloads, response);
              return [2 /*return*/, {
                success: true,
                retry: false,
                status: response.status
              }];
            } else {
              willRetry = shouldRetryForStatusCode(response.status);
              callOnRequestFailure({
                events: payloads,
                status: response.status,
                message: response.statusText,
                willRetry: willRetry
              }, response);
              return [2 /*return*/, {
                success: false,
                retry: willRetry,
                status: response.status
              }];
            }
          case 4:
            e_1 = _a.sent();
            request.closeRequest(false);
            message = typeof e_1 === 'string' ? e_1 : e_1 ? e_1.message : 'Unknown error';
            callOnRequestFailure({
              events: payloads,
              message: message,
              willRetry: true
            });
            return [2 /*return*/, {
              success: false,
              retry: true
            }];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function newEmitterRequestWithConfig() {
    return newEmitterRequest({
      endpoint: endpoint,
      protocol: protocol,
      port: port,
      eventMethod: eventMethod,
      customHeaders: customHeaders,
      connectionTimeout: connectionTimeout,
      keepalive: keepalive,
      maxPostBytes: maxPostBytes,
      useStm: useStm,
      credentials: credentials,
      postPath: postPath
    });
  }
  function shouldSkipEventStore(emitterEvent) {
    var eventTooBigWarning = function eventTooBigWarning(bytes, maxBytes) {
      return LOG.warn('Event (' + bytes + 'B) too big, max is ' + maxBytes);
    };
    if (usePost) {
      var bytes = emitterEvent.getPOSTRequestBytesCount() + 88; // 88 bytes for the payload_data envelope
      var tooBig = bytes > maxPostBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxPostBytes);
      }
      return tooBig;
    } else {
      if (maxGetBytes === undefined) {
        return false;
      }
      var bytes = emitterEvent.getGETRequestBytesCount();
      var tooBig = bytes > maxGetBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxGetBytes);
      }
      return tooBig;
    }
  }
  function callCookieExtensionService() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(cookieExtensionService && !cookieExtensionServiceCalled)) return [3 /*break*/, 2];
            cookieExtensionServiceCalled = true;
            request = new Request(cookieExtensionService, {
              method: 'GET'
            });
            return [4 /*yield*/, customFetch(request)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  }
  function flush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var e_2;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!flushInProgress) return [3 /*break*/, 5];
            flushInProgress = true;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, continueFlush()];
          case 2:
            _a.sent();
            return [3 /*break*/, 5];
          case 3:
            e_2 = _a.sent();
            LOG.error('Error sending events', e_2);
            return [3 /*break*/, 5];
          case 4:
            flushInProgress = false;
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function continueFlush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request, eventStoreIterator, _a, value, done, event_1, _b, success, retry, status;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4 /*yield*/, callCookieExtensionService()];
          case 1:
            _c.sent();
            request = newEmitterRequestWithConfig();
            eventStoreIterator = eventStore.iterator();
            _c.label = 2;
          case 2:
            if (request.isFull()) {
              return [3 /*break*/, 4];
            }
            return [4 /*yield*/, eventStoreIterator.next()];
          case 3:
            _a = _c.sent(), value = _a.value, done = _a.done;
            if (done || value === undefined) {
              return [3 /*break*/, 4];
            }
            event_1 = newEmitterEvent(value);
            if (!request.addEvent(event_1)) {
              return [3 /*break*/, 4];
            }
            return [3 /*break*/, 2];
          case 4:
            if (request.countEvents() === 0) {
              return [2 /*return*/];
            }
            return [4 /*yield*/, executeRequest(request)];
          case 5:
            _b = _c.sent(), success = _b.success, retry = _b.retry, status = _b.status;
            if (!(success || !retry)) return [3 /*break*/, 7];
            if (!success) {
              LOG.error("Status ".concat(status, ", will not retry."));
            }
            return [4 /*yield*/, eventStore.removeHead(request.countEvents())];
          case 6:
            _c.sent();
            _c.label = 7;
          case 7:
            if (!success) return [3 /*break*/, 9];
            return [4 /*yield*/, continueFlush()];
          case 8:
            _c.sent();
            _c.label = 9;
          case 9:
            return [2 /*return*/];
        }
      });
    });
  }
  function input(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var eventStorePayload, event, request, count;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            eventStorePayload = newEventStorePayload({
              payload: payload,
              svrAnon: serverAnonymization
            });
            event = newEmitterEvent(eventStorePayload);
            if (!shouldSkipEventStore(event)) return [3 /*break*/, 2];
            request = newEmitterRequestWithConfig();
            request.addEvent(event);
            return [4 /*yield*/, executeRequest(request)];
          case 1:
            _a.sent();
            return [3 /*break*/, 5];
          case 2:
            return [4 /*yield*/, eventStore.add(eventStorePayload)];
          case 3:
            count = _a.sent();
            if (!(count >= bufferSize)) return [3 /*break*/, 5];
            return [4 /*yield*/, flush()];
          case 4:
            _a.sent();
            _a.label = 5;
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function setCollectorUrl(url) {
    endpoint = url;
  }
  function setAnonymousTracking(at) {
    serverAnonymization = at;
  }
  function setBufferSize(bs) {
    bufferSize = bs;
  }
  return {
    flush: flush,
    input: input,
    setCollectorUrl: setCollectorUrl,
    setAnonymousTracking: setAnonymousTracking,
    setBufferSize: setBufferSize
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var version = version$1;


/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).

var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// dist/wishlist.js